(function () {
  const MODAL_SELECTOR = '[data-product-photo-modal]';
  const TRIGGER_SELECTOR = '[data-photo-upload-modal-trigger]';
  const CLOSE_SELECTOR = '[data-product-photo-modal-close]';
  const UPLOAD_SELECTOR = '[data-product-photo-modal-upload]';
  const UPLOAD_ROW_SELECTOR = '[data-product-photo-modal-upload-row]';
  const FILE_INPUT_SELECTOR = '[data-product-photo-modal-file-input]';
  const FILE_NAME_SELECTOR = '[data-product-photo-modal-file-name]';
  const PREVIEW_SELECTOR = '[data-product-photo-modal-preview]';
  const PREVIEW_IMAGE_SELECTOR = '[data-product-photo-modal-preview-image]';
  const PREVIEW_STATUS_SELECTOR = '[data-product-photo-modal-preview-status]';
  const PREVIEW_REMOVE_SELECTOR = '[data-product-photo-modal-preview-remove]';
  const MESSAGE_SELECTOR = '[data-product-photo-modal-message]';
  const MESSAGE_TEXT_SELECTOR = '[data-product-photo-modal-message-text]';
  const PHOTO_MESSAGE_SELECTOR = '[data-product-photo-modal-photo-message]';
  const CAMERA_TRIGGER_SELECTOR = '[data-product-photo-modal-camera-trigger]';
  const CAMERA_SELECTOR = '[data-product-photo-modal-camera]';
  const CAMERA_VIDEO_SELECTOR = '[data-product-photo-modal-camera-video]';
  const CAMERA_CAPTURE_SELECTOR = '[data-product-photo-modal-camera-capture]';
  const CAMERA_CANCEL_SELECTOR = '[data-product-photo-modal-camera-cancel]';
  const CAMERA_MESSAGE_SELECTOR = '[data-product-photo-modal-camera-message]';
  const CAMERA_FALLBACK_INPUT_SELECTOR = '[data-product-photo-modal-camera-fallback-input]';
  const CAMERA_FALLBACK_TRIGGER_SELECTOR = '[data-product-photo-modal-camera-fallback-trigger]';
  // --- Guided three-angle capture -----------------------------------------
  const GUIDE_SELECTOR = '[data-product-photo-modal-guide]';
  const GUIDE_PANEL_SELECTOR = '[data-product-photo-modal-guide-panel]';
  const GUIDE_START_SELECTOR = '[data-product-photo-modal-guide-start]';
  const GUIDE_UPLOAD_SELECTOR = '[data-product-photo-modal-guide-upload]';
  const GUIDE_BACK_SELECTOR = '[data-product-photo-modal-guide-back]';
  const KEEP_IMAGE_SELECTOR = '[data-product-photo-modal-keep-image]';
  const KEEP_CAPTION_SELECTOR = '[data-product-photo-modal-keep-caption]';
  const KEEP_SAVE_SELECTOR = '[data-product-photo-modal-keep-save]';
  const KEEP_RETAKE_SELECTOR = '[data-product-photo-modal-keep-retake]';
  const CAMERA_HEADER_SELECTOR = '[data-product-photo-modal-camera-header]';
  const CAMERA_BACK_SELECTOR = '[data-product-photo-modal-camera-back]';
  const CAMERA_STEP_COUNT_SELECTOR = '[data-product-photo-modal-camera-step-count]';
  const CAMERA_STEP_LABEL_SELECTOR = '[data-product-photo-modal-camera-step-label]';
  const CAMERA_OVERLAY_SELECTOR = '[data-product-photo-modal-camera-overlay]';
  const CAMERA_SCAN_SELECTOR = '[data-product-photo-modal-camera-scan]';
  const CAMERA_TURN_METER_SELECTOR = '[data-product-photo-modal-camera-turn]';
  const CAMERA_TURN_FILL_SELECTOR = '[data-product-photo-modal-camera-turn-fill]';
  const CAMERA_GUIDANCE_SELECTOR = '[data-product-photo-modal-camera-guidance]';
  const CAMERA_SKIP_SELECTOR = '[data-product-photo-modal-camera-skip]';
  const CAMERA_FLIP_SELECTOR = '[data-product-photo-modal-camera-flip]';
  const CAMERA_FLIP_LABEL_SELECTOR = '[data-product-photo-modal-camera-flip-label]';
  const CAMERA_TORCH_SELECTOR = '[data-product-photo-modal-camera-torch]';
  const CAMERA_FLASH_SELECTOR = '[data-product-photo-modal-camera-flash]';
  const REVIEW_LIST_SELECTOR = '[data-product-photo-modal-review]';
  const REVIEW_HEADING_SELECTOR = '[data-product-photo-modal-review-heading]';
  const REVIEW_NOTICE_SELECTOR = '[data-product-photo-modal-review-notice]';
  const REVIEW_SAVE_SELECTOR = '[data-product-photo-modal-review-save]';
  const REVIEW_DISCARD_SELECTOR = '[data-product-photo-modal-review-discard]';

  const QR_SLOT_SELECTOR = '[data-product-photo-modal-qr-slot]';
  const HANDOFF_ASSETS_SELECTOR = '[data-personalization-handoff-assets]';
  // Same 1024px this file's own CSS already keys off of
  // (`@media screen and (min-width: 1024px)` / `(max-width: 1023px)`, both already present
  // in product-photo-upload-modal.css) and the same breakpoint used elsewhere in the theme —
  // one value, not a second one invented here.
  const CAMERA_DESKTOP_QUERY = '(min-width: 1024px)';
  // Fixed, not derived from any count or loop bound elsewhere — the service refuses anything
  // outside {1, 2, 3} by name, and there is no path in this file that can construct a fourth.
  const EXTRA_SLOT_NUMBERS = [2, 3];
  const REQUIRED_PHOTO_SLOT = 1;
  const PHOTO_SLOT_NUMBERS = [REQUIRED_PHOTO_SLOT, ...EXTRA_SLOT_NUMBERS];

  // Order is the flow: front first, because slot 1 is the required photo and the only one
  // the service generates from today. `slot` is the service's own slot number, so this
  // table is the single place the step order and the slot numbering meet. Declared below
  // REQUIRED_PHOTO_SLOT, not up with the guided selectors, because it reads it at
  // evaluation time — const is hoisted but not initialised.
  const FACING_FRONT = 'user';
  const FACING_REAR = 'environment';
  // The guided flow starts on the rear camera: that is the one pointed at the child while a
  // parent holds the phone. `ideal`, not `exact`, so a device with only a front camera still
  // gets a stream instead of an OverconstrainedError. The single-shot camera outside this
  // flow keeps asking for 'user' and is untouched — see cameraConstraints().
  const GUIDE_DEFAULT_FACING_MODE = FACING_REAR;

  /**
   * WHICH CAMERA, AND WHOSE LEFT.
   *
   * The guided flow opens the REAR camera, and a flip button in the header switches to the
   * front one and back, restarting the stream on the same step. The single-shot camera
   * outside this flow still asks for 'user' and is unchanged.
   *
   * The preview is mirrored ONLY while the active track is the front camera, read from
   * track.getSettings().facingMode with the requested mode as the fallback — see
   * applyCameraMirroring(). The captured file is never mirrored on either camera: the shutter
   * reads the raw stream through canvas drawImage(), which no CSS transform reaches.
   *
   * That means the picture on screen is left-right flipped on one camera and not on the
   * other, so ANY screen-relative instruction ("turn them toward the left of the screen") is
   * wrong half the time. The copy below therefore names the CHILD’S OWN left and right —
   * "their left" — which is a fact about the child’s body, identical whichever camera is
   * running and whichever way the preview is flipped. The step label says the same thing, so
   * the header and the pill under it can never disagree.
   *
   * A head turned to its own left presents the RIGHT cheek to the lens. These labels name the
   * TURN, not the visible cheek, so nothing on screen claims otherwise. Slot 2 does therefore
   * hold the child’s right side and slot 3 the left, which is invisible today because the
   * service stores both slots and reads neither (personalization.service.ts ~495). WHEN
   * GENERATION STARTS READING THEM, decide which cheek belongs in which slot and swap the two
   * entries below — this table is the only place the mapping exists.
   */
  /**
   * turnSign is what makes a "left" step reject a right turn and vice versa — read against
   * precheck.isTurnedTowardStep(noseOffset, turnSign) in applyGuidanceVerdict() below, which
   * only multiplies the two together and does not itself know which physical direction
   * either sign means.
   *
   * +1 on "their left", -1 on "their right". DERIVED, not guessed, because guessing wrong
   * here is worse than the direction-blind bug it replaced (found 2026-09-30 by an
   * adversarial pass): a backwards sign would make a step confidently reject every correct
   * turn and accept every incorrect one, exactly as silently as the original bug did. Two
   * independent derivations agree:
   *
   * 1. BlazeFace's own landmark naming: "rightEye" is the SUBJECT's right eye, and on the
   *    RAW (unmirrored) frame this codebase already relies on elsewhere, a person facing
   *    the lens has their right eye at a SMALLER image x than their left eye (confirmed by
   *    every keypoint fixture in this file and in scripts/test-yaw-rule.js: rightEye.x <
   *    leftEye.x throughout). That alone fixes the mapping: image x increases from the
   *    subject's own right toward their own left.
   * 2. The classic "stage left is house right" fact: two people facing each other have
   *    their left/right sides swapped from each other's point of view. A raw, unmirrored
   *    camera pointed at a person is exactly that — an external observer facing them — so
   *    the same swap applies. Turning to the subject's own left swings the nose toward the
   *    OBSERVER's right, i.e. toward larger image x.
   *
   * Both agree: nose.x moving past the eye midpoint TOWARD LARGER x is a turn to the
   * subject's own LEFT (positive noseOffset, turnSign +1 below); toward smaller x is their
   * RIGHT (negative noseOffset, turnSign -1). If these values or this comment ever disagree
   * with a re-derivation, trust neither blindly — re-derive, because a silently swapped
   * sign is invisible in normal use: the pill still says "Good angle", the photo still gets
   * taken, and only the slot is wrong.
   */
  const GUIDE_STEPS = [
    {
      slot: REQUIRED_PHOTO_SLOT,
      label: 'Front',
      // 2026-10-01: shortened for the searching state's pill ("no face yet"). The
      // hats/sunglasses/face-covering advice this used to carry is not lost — it is its own
      // tip card on the intro screen the parent already saw before opening the camera.
      guidance: 'Point the camera at your child’s face',
      // Only the front step can reach the ready state; see applyGuidanceVerdict().
      turnPrompt: null,
      turnSign: null
    },
    {
      slot: 2,
      label: 'Head turned to their left',
      guidance: 'Make sure nothing is covering your child’s face.',
      turnPrompt: 'Turn your child’s head to their left',
      turnSign: 1
    },
    {
      slot: 3,
      label: 'Head turned to their right',
      guidance: 'Make sure nothing is covering your child’s face.',
      turnPrompt: 'Turn your child’s head to their right',
      turnSign: -1
    }
  ];
  // 2026-10-01 ("the photo scanner guides like Diia"): the front step's five NEW copy
  // strings, one per cascade priority (see applyGuidanceVerdict()). Each is short,
  // second-person, and names one correction at a time — never more than one on screen,
  // per the brief. GUIDE_READY_MESSAGE replaces the old "Perfect! Tap button to take
  // photo": autocapture now does the tapping, so asking the parent to tap is no longer true.
  const GUIDE_READY_MESSAGE = 'Hold still…';
  const GUIDE_CENTER_MESSAGE = 'Center the face in the oval';
  const GUIDE_CLOSER_MESSAGE = 'Move closer';
  const GUIDE_FURTHER_MESSAGE = 'Move a little further away';
  const GUIDE_STRAIGHTEN_MESSAGE = 'Keep the head straight';
  const GUIDE_FACE_CAMERA_MESSAGE = 'Face the camera';
  const GUIDE_DISCARD_CONFIRM =
    'You have taken photos that are not saved yet. Close and discard them?';
  const GUIDE_SLOTS_FULL_MESSAGE =
    'All three photo slots are already full. Remove one below, then add a different photo.';

  // 500 ms is the 2-per-second ceiling this task sets, and the sampler additionally waits
  // for the previous frame to settle — so a slow device samples LESS often, and never
  // queues inference behind itself. That matters most on the two profile steps: a side-on
  // face reads as NO_FACE, which is the detector's slowest answer, not its fastest.
  const GUIDE_SAMPLE_INTERVAL_MS = 500;

  // Hysteresis on the detector's output.
  //
  // A sample every 500 ms is noisy enough that a face sitting at the edge of detection flips
  // the answer twice a second. Without this, the sweep speed, the bracket styling and an
  // aria-live region all flap with it — and the pill being aria-live means a screen reader
  // reads the sentence out loud on every single flip.
  //
  // Asymmetric on purpose: 2 samples to enter a state, 3 to leave it. Reacting quickly when
  // something appears is what makes the thing feel alive; letting go slowly is what stops a
  // blink, a turn of the head, or one bad frame from tearing the state down. At 2 samples a
  // second that is about 1 s to acquire and about 1.5 s to release.
  //
  // CHOSEN, not measured against real captures. Nothing is gated on these, so being wrong
  // costs responsiveness, not a photo.
  const GUIDE_STATE_ENTER_SAMPLES = 2;
  const GUIDE_STATE_LEAVE_SAMPLES = 3;

  // Sticky release is right for a state that DESCRIBES something ("a face is there", "this is
  // the shot") — it stops a blink tearing it down. It is wrong for a state that ISSUES AN
  // INSTRUCTION, because the instruction becomes false the instant the thing it asks for has
  // been done, and 3 samples of stickiness is 1.5 s of telling a parent to turn a head they
  // have already turned.
  //
  // MEASURED on a device recording, 2026-09-30: the head was frontal at t=22.5-23.5 (offsets
  // 0.14, 0.004, 0.049), so the prompt appeared correctly; it turned away by t=24.0 (0.417)
  // and was in hard profile at t=24.5 (1.576) — with the prompt still on screen, stale by
  // about 0.8 s. That frame is what got reported as the feature not working.
  const GUIDE_INSTRUCTION_LEAVE_SAMPLES = 1;

  // Padding around the detected face before the sweep is confined to it, as a fraction of
  // the face's own height, and the smallest band it will ever travel as a fraction of the
  // framed area. A sweep hugging the jawline reads as a glitch; a band shorter than the
  // line's own 88px glow reads as a stuck line.
  const SCAN_BAND_PADDING = 0.22;
  const SCAN_BAND_MIN_FRACTION = 0.28;

  // The 0.00-0.14 (frontal) / 0.35-3.04 (profile) measurement this comment used to cite,
  // and the threshold built on it, now live in photo-precheck.js next to
  // isTurnedTowardStep() and FRONTAL_MAX_NOSE_OFFSET \u2014 the function that reads the
  // threshold is the only thing that still needs to, and it is testable from plain node
  // there. GUIDE_STEPS.turnSign is the piece that stays here; see the block comment above
  // GUIDE_STEPS for the direction derivation.
  //
  // GUIDE_PROFILE_READY_MESSAGE ('Good angle \u2014 tap button to take photo') lived here
  // and is retired, 2026-10-01 evening amendment: a profile step's ready state now reuses
  // GUIDE_READY_MESSAGE ("Hold still\u2026"), same string as the front step's, since the two
  // now share the one 'ready' kind and the amendment's own words ("Ready looks like the
  // front step's... pill 'Hold still\u2026'"). The retired string promised a tap; autocapture
  // does that itself on profile steps now too, so it stopped being true.

  // The bracketed area, as fractions of the VIDEO ELEMENT's box. These four numbers must
  // stay in step with .product-photo-modal__camera-overlay in the CSS (left/right 10%,
  // top 16%, bottom 30% → 0.70). Duplicated here because the JS has to answer "is the face
  // inside the brackets?" and cannot read a percentage back out of a stylesheet.
  // What the brackets MEAN: head and shoulders, hair included — not a crop of the face.
  // Nothing is cut from the saved file (see captureCurrentFrame), so these are a composition
  // guide, and a guide that framed the face tightly would teach a parent to cut off the hair
  // the service needs. Wide and tall enough for a head of curls and a pair of shoulders.
  //
  // These four numbers must stay in step with .product-photo-modal__camera-overlay in the
  // CSS; assertBracketGeometry in the browser suite compares the two and fails on drift.
  const GUIDE_FRAME = { left: 0.08, right: 0.92, top: 0.12, bottom: 0.78 };

  // The face must be at least this many pixels on its short edge before the front step will
  // say "Perfect!".
  //
  // 120 is the SERVICE's own minimum, not a number invented here: photo-precheck.js sets its
  // client threshold to 60 and its comment states why — "deliberately half the server's 120px
  // threshold", because the client must be strictly more permissive than the server and only
  // reject what is unambiguous. That reasoning is right for a REJECT. It is wrong for
  // "Perfect!": telling a parent a photo is good when the service will refuse it is worse
  // than saying nothing, so the ready state is held to the server's bar rather than the
  // client's.
  //
  // Measured on the SAVED STILL's resolution, which costs nothing to guarantee: runLive()
  // samples createImageBitmap(video) at videoWidth x videoHeight, and captureCurrentFrame()
  // draws its canvas at exactly the same videoWidth x videoHeight. The detector's
  // faceShortEdgePx is therefore already in the units of the file that gets saved.
  //
  // AND THE UPLOAD PATH DOES NOT RESCALE IT. Checked rather than assumed, because a
  // downscale anywhere between here and the service would mean a face that cleared 120 px on
  // the frame arriving under 120 px at the far end, and this gate would be quietly lying.
  // Measured 2026-09-30 on the file that actually reaches uploadPhotoToService: 480x640
  // sampled, 480x640 uploaded, 47503 bytes both sides, and the SAME File object — for a
  // guided capture normalizeUploadOrientation returns early and never re-encodes at all,
  // because a canvas-produced JPEG carries no EXIF orientation tag.
  //
  // Even on the paths that DO re-encode (a tagged file from the gallery or the native-camera
  // fallback), reencodeUpright sizes its canvas from the bitmap — `canvas.width = swapsAxes ?
  // bitmap.height : bitmap.width` — so dimensions are preserved and at most transposed. A
  // short edge is invariant under transposition, and the face box transposes with the image,
  // so the comparison survives that path too.
  //
  // WHAT WOULD BREAK IT: reencodeUpright gaining a maximum-dimension cap, captureCurrentFrame
  // sizing its canvas to anything other than videoWidth/videoHeight, or a stream renegotiating
  // its resolution between a sample and the shutter. The first two are code changes and
  // should re-run the measurement; the third is a device behaviour nobody here has observed.
  const GUIDE_READY_MIN_FACE_PX = 120;

  // 2026-10-01 ("the photo scanner guides like Diia"): autocapture is retimed to the ring
  // drawn around the oval, FRONT STEP ONLY. This is an explicit product decision, stated in
  // that task's brief, and it reverses the 2026-09-30 change that had extended autocapture to
  // the two profile steps \u2014 see GUIDE_STEPS' turnSign comment and applyGuidanceVerdict()
  // for why those steps are otherwise unaffected by this change (turn meter, turn prompt,
  // "Good angle" text and the manual shutter stay exactly as they were there).
  //
  // One number, not three: there is no separate hold phase any more (startAutoCapture() only
  // schedules once 'ready' is already committed, which already cost two consecutive good
  // samples \u2014 about 1 s \u2014 through the hysteresis, so the hold the old HOLD_MS bought
  // is already paid for) and no digit countdown to keep in step with a tick rate. The ring is
  // the only countdown a parent sees (.is-ready .camera-ring-fill in the CSS), and this is
  // the one number both the JS timer and the CSS keyframe
  // (product-photo-modal-ready-ring) must agree on.
  //
  // CHOSEN, not measured on a child.
  const GUIDE_READY_RING_MS = 1000;
  const PRECHECK_ASSETS_SELECTOR = '[data-photo-precheck-assets]';
  const HEIC_CONVERTER_ASSETS_SELECTOR = '[data-heic-converter-assets]';
  const PRECHECK_ASSET_KEYS = [
    'module',
    'tfCore',
    'tfConverter',
    'tfBackendWasm',
    'wasmBinary',
    'wasmBinarySimd',
    'blazeface',
    'modelJson',
    'modelShard'
  ];
  const CHECKING_SELECTOR = '[data-product-photo-modal-checking]';
  const GENDER_SELECTOR = '[data-product-photo-modal-gender]';
  const GENDER_NOTE_SELECTOR = '[data-product-photo-modal-gender-note]';
  const AUDIENCE_SELECTOR = '[data-product-photo-modal-audience]';
  const SWATCH_SELECTOR = '[data-product-photo-modal-swatch]';
  const NAME_SELECTOR = '[data-product-photo-modal-name]';
  const NAME_ERROR_SELECTOR = '[data-product-photo-modal-name-error]';
  const BIRTH_DATE_SELECTOR = '[data-product-photo-modal-birth-date]';
  const CONSENT_SELECTOR = '[data-product-photo-modal-consent]';
  const AGE_SELECTOR = '[data-product-photo-modal-age]';
  const AGE_HINT_SELECTOR = '[data-product-photo-modal-age-hint]';
  const PHOTO_COUNT_SELECTOR = '[data-product-photo-modal-photo-count]';
  const FIELD_SELECTOR = '[data-product-photo-modal-field]';
  const SUBMIT_SELECTOR = '[data-product-photo-modal-submit]';
  const PRODUCT_CONTEXT_SELECTOR = '[data-product-personalization]';
  const PRODUCT_FORM_SELECTOR = '.product-hero__form';
  const VARIANT_INPUT_SELECTOR = '[data-variant-id]';
  const CREATE_PERSONALIZATION_URL = '/apps/personalization/create';
  const UPLOAD_PHOTO_URL = '/apps/personalization/upload/photo';
  const CONFIRM_UPLOAD_URL = '/apps/personalization/upload/confirm';
  /**
   * The handoff flow (desktop shows a QR, a phone answers it) is deliberately decoupled
   * from personalization entirely — no personalizationId exists yet when a handoff token is
   * requested, and nothing here waits for, asks for, or assumes one. A photo that arrives
   * this way becomes an ordinary in-browser File via applyCapturedFile() and rejoins the
   * exact same path submitPersonalization() already drives for any other photo; the
   * server's handoff storage is a temporary relay, never a personalization record.
   *
   * `:token/photo/:photoId` (GET) and `:token` (GET) are used here as literally shown in
   * this task's contract. The phone-facing POST target used to be threaded through from the
   * create response's `uploadPath` field — the server has stopped sending that field since
   * the phone page (photo-handoff.js) derives the same path from the token alone, so this
   * client no longer reads or forwards it. See startHandoff() and buildHandoffPhoneUrl().
   */
  const HANDOFF_CREATE_URL = '/apps/personalization/handoff';
  const HANDOFF_BASE_URL = '/apps/personalization/handoff/';
  /**
   * The phone-facing page this theme owns. A HUMAN STEP, not a code dependency: a Shopify
   * page with this exact handle has to exist in the admin, or every QR/link this file
   * generates 404s — see templates/page.photo-handoff.json and this task's run report.
   */
  const HANDOFF_PAGE_PATH = '/pages/photo-handoff';
  /**
   * The registry is the authority on which age bands a product has. Hardcoding them here
   * would be a second list of what exists, free to disagree with the one that resolves —
   * which is exactly what produced the 400 this replaces.
   */
  const AGE_BANDS_URL_PREFIX = '/apps/personalization/products/';
  /**
   * TASK TL9 (S118). `create()` returns a one-time secret alongside `personalizationId` —
   * see PersonalizationResponseDto.guestAccessToken on the service. Kept in localStorage,
   * keyed by personalization id, NEVER in cart/line-item properties (readable in the Shopify
   * admin order view and by any app on the cart/checkout pages), never logged, never put in a
   * URL. localStorage (not sessionStorage) so a customer who reopens the same product in a new
   * tab, or returns after closing the browser, still has it — the id alone is what the service
   * uses to find the record, so losing the token loses nothing today (enforcement is OFF) and
   * only means a guest cannot complete this exact personalization once GUEST_ACCESS_TOKEN_-
   * ENFORCEMENT_ENABLED is turned on, same as presenting a wrong token.
   */
  const GUEST_ACCESS_TOKEN_STORAGE_PREFIX = 'fsb:guestAccessToken:';

  function storeGuestAccessToken(personalizationId, token) {
    if (!personalizationId || !token) {
      return;
    }

    try {
      window.localStorage.setItem(GUEST_ACCESS_TOKEN_STORAGE_PREFIX + personalizationId, token);
    } catch {
      // Storage can throw (private browsing, quota, disabled by the browser) — the token is
      // simply not available to later calls, the same as if create() had never returned one.
    }
  }

  function getGuestAccessToken(personalizationId) {
    if (!personalizationId) {
      return null;
    }

    try {
      return window.localStorage.getItem(GUEST_ACCESS_TOKEN_STORAGE_PREFIX + personalizationId);
    } catch {
      return null;
    }
  }

  // assets/bot-trap.js (task TL4), loaded immediately before this file. Both are deferred, so
  // script order is execution order and this is already defined.
  const BotTrap = window.BotTrap;
  const AGE_BANDS_URL_SUFFIX = '/age-bands';
  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  // TASK TL18 item 2. A HEIC/HEIF file's reported MIME type is inconsistent across OS/browser
  // combinations — Safari on iOS/macOS reports 'image/heic', but many desktop browsers hand
  // back an empty string or 'application/octet-stream' for the same file, so the extension is
  // checked whenever the type is not already one of ALLOWED_FILE_TYPES. A file the browser
  // already calls image/jpeg (iOS Safari's own camera/library export, per that OS's
  // "Compatibility" format setting) is never treated as HEIC here, however it is named —
  // see isHeicFile() below, which is what keeps iOS from being double-converted.
  const HEIC_FILE_TYPES = ['image/heic', 'image/heif'];
  const HEIC_EXTENSION_PATTERN = /\.hei[cf]$/i;
  const COMPLETE_DETAILS_MESSAGE = "Complete your child's details to create the book.";
  const PHOTO_REQUIRED_MESSAGE = "A photo is required to create your child's character. Please upload a clear, front-facing photo.";
  // Designer request 2026-10-28: when the parental-consent box is the ONLY thing missing, say so
  // instead of the generic "complete your details" line, and take the customer to the box.
  const CONSENT_REQUIRED_MESSAGE = "Please tick the box to confirm you are the child's parent or guardian.";
  // TASK TL17. Same copy for a client-side rejection (this constant, checked before any
  // request goes out) and a server-side one (ApiRequestError from upload/photo, which an
  // extension-renamed file — a .gif saved as .jpg — reaches the server to refuse, since
  // File.type is read from the extension, not the bytes). One pair of strings either way,
  // per the task's "same messages" requirement.
  const PHOTO_TYPE_MESSAGE = "We couldn't use this photo file. Please upload a JPG, PNG or WebP photo.";
  const PHOTO_SIZE_MESSAGE = 'This photo is larger than 10 MB.';
  const BIRTH_DATE_INVALID_MESSAGE = "Please check your child's date of birth.";
  // TASK TL18 item 6. Distinct from window.ChildNameRule.MESSAGE (which is about disallowed
  // CHARACTERS in a non-empty name): a name of only spaces trims to empty, so it is a
  // "missing" name, not an "invalid characters" one — same empty-vs-wrong split this file
  // already draws for birth date and the character rule. This is the message for the
  // "empty after trim" case specifically.
  const NAME_REQUIRED_MESSAGE = "Please enter your child's name.";
  /**
   * TASK TL6, corrected by TASK TL17. The error code the service's IsValidChildNameConstraint
   * (S82, child-name.validator.ts) embeds as TEXT inside its validation message — never as
   * `error.code`, which the service's HttpExceptionFilter always normalises to the generic
   * `VALIDATION_ERROR` regardless of which constraint failed (verified against
   * forever-storybooks-service/src/common/errors/http-exception.filter.ts; see this task's
   * report). TL6's `error?.code === CHILD_NAME_INVALID_CHARACTERS_CODE` check could therefore
   * never match — a refusal that slipped past the client's own ChildNameRule check
   * (window.ChildNameRule, assets/child-name-rule.js) still fell into the generic branch and
   * showed "Please check your personalization details and try again.", with no mention of the
   * name field. See hasValidationDetail() and handlePersonalizationError() below for the fix:
   * the code is read out of `error.details[].message` instead.
   */
  const CHILD_NAME_INVALID_CHARACTERS_CODE = 'CHILD_NAME_INVALID_CHARACTERS';
  /**
   * Mirrors the backend's own bound (`MAX_PLAUSIBLE_CHILD_AGE_YEARS`,
   * forever-storybooks-service/src/modules/personalization/child-birth-date.ts) — kept as a
   * literal, not derived from ageRange, for the same reason the service keeps it separate:
   * this field must never correct or be corrected by ageRange.
   */
  const MAX_PLAUSIBLE_CHILD_AGE_YEARS = 18;
  const UPLOAD_FAILED_MESSAGE = "We couldn't upload the photo. Please try again.";
  const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';
  /**
   * TASK TL17. Two different "we don't know what else to say" messages, for two different
   * reasons — collapsing them into one is the bug this task exists to fix (every production
   * 400 read as "check your details," even a photo upload the server refused outright).
   *
   * SERVER_ERROR_MESSAGE: the request never got a real answer from the service — a network
   * failure (fetch() itself rejected), a 5xx, or a 429. Nothing the customer typed is at
   * fault, so the copy says so and invites a retry.
   *
   * CHECK_DETAILS_MESSAGE: the service DID answer, with a 400 that could not be attributed to
   * a specific field (every nameable case — the photo itself, the child's name, the birth
   * date — is intercepted earlier in handlePersonalizationError(), before this is reached).
   * This is the true last resort, not the first thing shown.
   */
  const SERVER_ERROR_MESSAGE = 'Something went wrong on our side. Please try again in a moment.';
  const CHECK_DETAILS_MESSAGE = 'Please check your personalization details and try again.';
  // getUserMedia missing or refused is an expected state (in-app browsers like Instagram's
  // and Facebook's block it outright), not a failure to report as an error — see openCamera().
  // Both name the SAME next action — tapping the fallback button revealed below the
  // message — because that button, not an automatic .click(), is what actually happens
  // now. See useCameraFallback()/showCameraFallbackTrigger(): a programmatic .click() on
  // the hidden capture="user" input, run without a fresh user gesture, is silently refused
  // by Safari and by Chrome in several cases, which is the defect this message text (and
  // the button) replaces.
  const CAMERA_UNAVAILABLE_MESSAGE = 'Camera access is not available in this browser. Use the Open device camera button below to take a photo.';
  const CAMERA_DENIED_MESSAGE = "We couldn't access your camera. Use the Open device camera button below to take a photo, or choose one from your device.";
  // Reached only when the captured file cannot be handed to the existing input. See
  // applyCapturedFile(): the parent has already taken the photo by then, so the one thing
  // this must never be is silence.
  const CAMERA_ATTACH_FAILED_MESSAGE = "We couldn't attach that photo. Please choose a photo from your device instead.";
  const CAMERA_CAPTURE_FAILED_MESSAGE = "We couldn't use that photo. Please try again, or choose a file instead.";

  const HANDOFF_LOADING_TEXT = 'Preparing your code…';
  // "Open on your phone" described what this click used to do on a phone, and would still
  // wrongly say that here — the click this label sits on now runs on the SAME computer
  // that is showing it. Names the object (a link meant for the phone), not an action on
  // this device: see handleHandoffLinkClick() for what a plain left click does instead.
  const HANDOFF_LINK_TEXT = 'Copy phone link';
  const HANDOFF_LINK_COPIED_TEXT = 'Copied!';
  const HANDOFF_EXPIRED_MESSAGE = 'This code expired.';
  const HANDOFF_ERROR_MESSAGE = "We couldn't load a code for your phone. You can still upload from this computer.";
  const HANDOFF_ATTACH_FAILED_MESSAGE = "Your phone's photo couldn't be attached. Please choose a photo from your computer instead.";
  const HANDOFF_ALL_SLOTS_FULL_MESSAGE = 'All three photo slots are full. Remove a photo here to add the one from your phone.';
  const HANDOFF_NEW_CODE_LABEL = 'Get a new code';
  const HANDOFF_TRY_AGAIN_LABEL = 'Try again';
  /**
   * How often the desktop asks the server "has a photo arrived yet". Chosen, not measured —
   * this endpoint does not exist yet (see the task brief's server dependency). Erring toward
   * TOO FREQUENT rather than too slow: this poll runs only while one specific modal is open
   * on one specific customer's screen, bounded by the handoff token's own short expiresAt —
   * the total request volume any one customer can generate is small and self-limiting by
   * construction. Erring the other way costs a parent staring at their screen after already
   * taking the photo, wondering whether anything happened — which is the one experience this
   * feature exists to prevent.
   */
  const HANDOFF_POLL_INTERVAL_MS = 2000;

  // Client reasons (photo-precheck.js) and server reasons (confirm response)
  // map into the same region. Copy each names the fix, not the fault, per
  // project docs — never implies the photo was good, only what to change.
  const PHOTO_REASON_MESSAGES = {
    NO_FACE: "This photo doesn't appear to include a child. Please try uploading a different photo.",
    NO_FACE_DETECTED: "This photo doesn't appear to include a child. Please try uploading a different photo.",
    MULTIPLE_FACES: 'This photo has more than one person in it. Please upload a photo of your child alone.',
    FACE_TOO_SMALL: "Your child's face is too small in this photo. Please upload a closer photo.",
    UNDECODABLE: 'We could not open this file. Please try a different photo.',
    TOO_SMALL: 'This image is too small. Please upload a larger photo.',
    FACE_NOT_FRONTAL: 'We need a front-facing photo of your child. Please upload one facing the camera.',
    TOO_BLURRY: 'This photo is too blurry. Please upload a sharper photo.',
    OBSTRUCTED: "Your child's face is partially covered. Please upload a photo with a clear view of their face.",
    NOT_A_PHOTO: 'This does not look like a photo of your child. Please upload a real photo.'
  };

  function getPhotoReasonMessage(reason) {
    return (reason && PHOTO_REASON_MESSAGES[reason]) || null;
  }

  // TASK TL18 item 2. See the comment on HEIC_FILE_TYPES above — an already-allowed type
  // (iOS's own JPEG export) always wins over the filename, so a .heic-named file iOS has
  // already converted is never re-converted.
  function isHeicFile(file) {
    if (!file) {
      return false;
    }

    const type = (file.type || '').toLowerCase();

    if (ALLOWED_FILE_TYPES.includes(type)) {
      return false;
    }

    if (HEIC_FILE_TYPES.includes(type)) {
      return true;
    }

    return HEIC_EXTENSION_PATTERN.test(file.name || '');
  }

  /**
   * Converts one HEIC/HEIF file to a JPEG File using the vendored heic2any (see
   * assets/heic2any.js's own header for source/license/size). Resolves null — never
   * rejects — on any failure, so every caller can fall through to the same
   * PHOTO_TYPE_MESSAGE a non-HEIC unsupported file already gets.
   */
  async function convertHeicFileToJpeg(file, loadHeicConverterModule) {
    const heic2any = await loadHeicConverterModule();

    if (!heic2any) {
      return null;
    }

    try {
      const result = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 });
      const blob = Array.isArray(result) ? result[0] : result;

      if (!blob) {
        return null;
      }

      const baseName = (file.name || 'upload').replace(HEIC_EXTENSION_PATTERN, '') || 'upload';
      return new File([blob], baseName + '.jpg', { type: 'image/jpeg', lastModified: Date.now() });
    } catch (error) {
      console.warn('[product-photo-upload-modal] HEIC conversion failed', {
        name: error?.name || null,
        message: error?.message || String(error)
      });
      return null;
    }
  }

  function recordPhotoPrecheckTelemetry(verdict) {
    const payload = {
      reason: verdict.reason || null,
      verdict: verdict.verdict,
      faceShortEdgePx: verdict.faceShortEdgePx || null,
      imageWidth: verdict.imageWidth || null,
      imageHeight: verdict.imageHeight || null,
      detectorPath: verdict.detectorPath || null,
      // Count only — never coordinates, never the name. The photo is a
      // child's face; boxes must never leave the browser except as the
      // customer's own chosen hint on submit.
      candidateCount: Array.isArray(verdict.candidates) ? verdict.candidates.length : null
    };

    // No analytics channel exists in this theme today. console.debug is the
    // placeholder sink until one does — do not add an analytics vendor here.
    console.debug('[photo-precheck]', payload);
  }

  // A Shopify line-item property value is a short string; full float
  // precision buys nothing and only bloats the cart payload.
  function roundTo4(value) {
    return Math.round(value * 10000) / 10000;
  }

  /**
   * `<input type="date">.value` is always `yyyy-mm-dd` (HTML spec) or `''` when empty —
   * never the DTO's `mm/dd/yyyy`. Sending the browser's format as-is would 400 on every
   * filled-in field. Returns `null` for an empty or malformed value so the caller can omit
   * the property entirely rather than send `""`, which the DTO also rejects.
   */
  function isoDateToChildBirthDate(isoValue) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoValue || '');

    if (!match) {
      return null;
    }

    const [, year, month, day] = match;
    return `${month}/${day}/${year}`;
  }

  /**
   * Mirrors the backend's plausibility check (`isChildBirthDatePlausible` in
   * forever-storybooks-service) so a customer sees the rejection immediately instead of
   * after a round trip: not in the future, not more than MAX_PLAUSIBLE_CHILD_AGE_YEARS ago.
   * A real calendar date is already guaranteed by the native date picker, so this is the
   * one part of the backend rule left to check here.
   *
   * Takes the parsed `Date` plus "now", rather than reaching for `Date.now()` itself, so it
   * stays a pure function.
   */
  function isChildBirthDatePlausible(date, now) {
    if (date.getTime() > now.getTime()) {
      return false;
    }

    // UTC, not local — `date` comes from `new Date('yyyy-mm-dd')`, which the spec parses as
    // UTC midnight. Building the cutoff from local calendar fields would drift by a day
    // around a timezone boundary and no longer agree with the backend's own UTC math.
    const earliestPlausible = new Date(now);
    earliestPlausible.setUTCFullYear(earliestPlausible.getUTCFullYear() - MAX_PLAUSIBLE_CHILD_AGE_YEARS);

    return date.getTime() >= earliestPlausible.getTime();
  }

  /**
   * Mirrors the backend's own age arithmetic (`computeChildAgeAtDate` in
   * forever-storybooks-service/src/modules/personalization/child-age.ts): full years by UTC
   * calendar fields, minus one if this year's birthday has not yet occurred relative to
   * `atDate`. This is what the backend uses to decide the book's printed age, so reusing the
   * exact same rule here is what lets a birth-date-driven suggestion agree with it — a
   * different rounding rule would suggest a band the backend's own math would not have
   * chosen.
   */
  function computeChildAgeAtDate(birthDate, atDate) {
    const birthMonth = birthDate.getUTCMonth();
    const birthDay = birthDate.getUTCDate();

    let age = atDate.getUTCFullYear() - birthDate.getUTCFullYear();

    const birthdayThisYear = Date.UTC(atDate.getUTCFullYear(), birthMonth, birthDay);

    if (atDate.getTime() < birthdayThisYear) {
      age -= 1;
    }

    return age;
  }

  /**
   * TASK TL18 item 7. Mirrors the backend's `isChildBirthDatePrintableAge`
   * (forever-storybooks-service/src/modules/personalization/child-birth-date.ts), by calling
   * it via the server's own `normaliseChildAge` bounds (1-17 inclusive) rather than
   * re-declaring them — same discipline that file documents for itself. This is a SEPARATE,
   * stricter check from isChildBirthDatePlausible() above: a birth date of today (age 0) or
   * one giving an age over 17 passes the loose Klaviyo-plausibility bound (not in the future,
   * not more than 18 years ago) but still cannot be printed, and the backend refuses it for
   * that reason — see this task's brief ("a birth date of today or the future, or one giving
   * an age under 1 or over 17"). Reuses computeChildAgeAtDate(), the exact arithmetic the
   * backend's own version reuses too, so a date accepted here cannot disagree with what the
   * backend computes from the identical value.
   */
  function isChildBirthDatePrintableAge(date, now) {
    const age = computeChildAgeAtDate(date, now);
    return age >= 1 && age <= 17;
  }

  /**
   * Pulls the two integer bounds out of an age-band string the registry returned ('0-3',
   * '4-7', ...), independent of which separator character it used. The registry
   * (AGE_BANDS_URL_PREFIX above) is the only source of which bands exist for a product — this
   * file keeps no second list of band literals to compare a separator against, so the
   * separator cannot be assumed in advance. Returns null for anything that isn't exactly two
   * numbers, so an unrecognised shape is skipped rather than guessed at.
   */
  function parseAgeBandBounds(band) {
    const numbers = typeof band === 'string' ? band.match(/\d+/g) : null;

    if (!numbers || numbers.length !== 2) {
      return null;
    }

    const min = Number(numbers[0]);
    const max = Number(numbers[1]);

    if (!Number.isFinite(min) || !Number.isFinite(max) || min > max) {
      return null;
    }

    return { min, max };
  }

  // Half-extent of the box wrapped around a marker point. A deliberate
  // wrapper, not a measurement: the backend matcher uses only the box centre
  // (hintCenterX = x + width / 2), so the size carries no information — it
  // exists because the payload contract requires width > 0 and height > 0.
  const SUBJECT_MARKER_HALF = 0.01;

  // Clamp BEFORE rounding, and keep x + width within the contract's 1.001
  // ceiling: a marker dropped in a corner is exactly where a naive
  // implementation emits a box the backend rejects outright, which would make
  // the hint silently vanish.
  function subjectHintBoxFromPoint(point) {
    const size = SUBJECT_MARKER_HALF * 2;
    const maxOrigin = 1 - size;

    return {
      x: Math.min(Math.max(point.x - SUBJECT_MARKER_HALF, 0), maxOrigin),
      y: Math.min(Math.max(point.y - SUBJECT_MARKER_HALF, 0), maxOrigin),
      width: size,
      height: size
    };
  }

  function recordSubjectHintTelemetry(source) {
    // Count only which gesture produced the hint. Never the position, never
    // the box, never the photo, never the child's name.
    console.debug('[subject-hint]', { source: source });
  }

  // Parses just enough of the JPEG marker stream to find the APP1/Exif
  // segment and read tag 0x0112. Returns null for anything that isn't a
  // plain big/little-endian TIFF-in-JPEG Exif block - callers must treat
  // null as "no orientation known," not as an error.
  function readTiffOrientation(view, tiffOffset) {
    if (tiffOffset + 8 > view.byteLength) return null;

    const byteOrderMarker = view.getUint16(tiffOffset, false);
    let little;
    if (byteOrderMarker === 0x4949) little = true;
    else if (byteOrderMarker === 0x4d4d) little = false;
    else return null;

    if (view.getUint16(tiffOffset + 2, little) !== 0x002a) return null;

    const ifdOffset = tiffOffset + view.getUint32(tiffOffset + 4, little);
    if (ifdOffset + 2 > view.byteLength) return null;

    const numEntries = view.getUint16(ifdOffset, little);
    for (let i = 0; i < numEntries; i++) {
      const entryOffset = ifdOffset + 2 + i * 12;
      if (entryOffset + 12 > view.byteLength) break;

      if (view.getUint16(entryOffset, little) === 0x0112) {
        return view.getUint16(entryOffset + 8, little);
      }
    }

    return null;
  }

  function findExifOrientation(buffer) {
    const view = new DataView(buffer);
    if (view.byteLength < 4 || view.getUint16(0, false) !== 0xffd8) return null;

    let offset = 2;
    while (offset + 4 <= view.byteLength) {
      if (view.getUint8(offset) !== 0xff) break;

      const marker = view.getUint8(offset + 1);

      if (marker === 0xd8 || marker === 0xd9 || marker === 0x01 || (marker >= 0xd0 && marker <= 0xd7)) {
        offset += 2;
        continue;
      }

      if (marker === 0xda) break;

      const size = view.getUint16(offset + 2, false);

      if (marker === 0xe1) {
        const exifOffset = offset + 4;
        if (
          exifOffset + 6 <= view.byteLength &&
          view.getUint32(exifOffset, false) === 0x45786966 &&
          view.getUint16(exifOffset + 4, false) === 0x0000
        ) {
          return readTiffOrientation(view, exifOffset + 6);
        }
      }

      offset += 2 + size;
    }

    return null;
  }

  // WebP is a RIFF container: 'RIFF' <u32 LE size> 'WEBP', then a list of
  // chunks, each 'FourCC' <u32 LE size> <payload padded to an even length>.
  // Unlike a JPEG's Exif APP1 - which sits in the first bytes - a WebP's EXIF
  // chunk conventionally follows the compressed bitstream, so a leading header
  // window never reaches it in a photo of any real size. The chunk list is a
  // linked walk instead: each 8-byte header gives the size of the payload to
  // skip, so the EXIF chunk is found by reading only those headers - three
  // 8-byte reads for a typical file - and then only its own payload. The
  // customer's pixel data is never read. The payload is the same TIFF block
  // the JPEG path hands to readTiffOrientation, so that parser is reused here
  // rather than written a second time.
  async function readWebpExifOrientation(file) {
    const header = new DataView(await file.slice(0, 12).arrayBuffer());
    if (header.byteLength < 12) return null;
    if (header.getUint32(0, false) !== 0x52494646) return null; // 'RIFF'
    if (header.getUint32(8, false) !== 0x57454250) return null; // 'WEBP'

    // Trust the RIFF size field only as far as the file actually goes.
    const limit = Math.min(file.size, 8 + header.getUint32(4, true));

    let offset = 12;

    // A bound on the walk, not on the file: real WebPs carry a handful of
    // chunks, and a corrupt one must not spin.
    for (let i = 0; i < 32 && offset + 8 <= limit; i++) {
      const chunk = new DataView(await file.slice(offset, offset + 8).arrayBuffer());
      if (chunk.byteLength < 8) return null;

      const fourCC = chunk.getUint32(0, false);
      const size = chunk.getUint32(4, true);
      const payload = offset + 8;

      if (fourCC === 0x45584946) { // 'EXIF'
        // 64KB matches the cap on a JPEG APP1 segment; metadata past that is
        // not an orientation tag worth reading a customer's photo for.
        const end = Math.min(payload + size, payload + 65536, file.size);
        const view = new DataView(await file.slice(payload, end).arrayBuffer());

        // Some encoders prefix the payload with the JPEG-style "Exif\0\0"
        // marker and some start straight at the TIFF header; accept both.
        const hasExifMarker =
          view.byteLength >= 6 &&
          view.getUint32(0, false) === 0x45786966 &&
          view.getUint16(4, false) === 0x0000;

        return readTiffOrientation(view, hasExifMarker ? 6 : 0);
      }

      if (payload + size > limit) break;

      offset = payload + size + (size % 2);
    }

    return null;
  }

  // Which container this actually is, decided from the bytes present - never
  // from file.type or an extension, either of which can be wrong or absent.
  async function readContainerSignature(file) {
    try {
      const view = new DataView(await file.slice(0, 12).arrayBuffer());

      if (view.byteLength >= 2 && view.getUint16(0, false) === 0xffd8) return 'jpeg';

      if (
        view.byteLength >= 12 &&
        view.getUint32(0, false) === 0x52494646 &&
        view.getUint32(8, false) === 0x57454250
      ) {
        return 'webp';
      }

      return null;
    } catch {
      return null;
    }
  }

  // Reads only a bounded part of the file. For a JPEG the Exif APP1 segment is
  // capped at 64KB and sits immediately after the SOI marker, so a 128KB header
  // window covers every real-world case without reading a customer's whole
  // multi-megabyte photo into memory twice; for a WebP the chunk walk above
  // reads less still. Anything that is neither container yields null - "no
  // orientation known", which is not the same as "orientation is 1".
  async function readExifOrientation(file) {
    try {
      const container = await readContainerSignature(file);

      if (container === 'jpeg') {
        const headerSize = Math.min(file.size, 131072);
        return findExifOrientation(await file.slice(0, headerSize).arrayBuffer());
      }

      if (container === 'webp') return await readWebpExifOrientation(file);

      return null;
    } catch {
      return null;
    }
  }

  // Chrome applies a JPEG's Exif orientation while decoding and ignores
  // imageOrientation:'none'; for WebP it applies nothing at all. Measured, not
  // assumed - and neither behaviour is safe to hard-code. Trusting a decoder
  // that does nothing leaves the photo sideways; re-rotating one that already
  // rotated turns 90 degrees into 180. So ask the decoder what it does, once
  // per container, with a 2x1 image whose Exif orientation is 6: a decoder
  // that honours the tag hands back 1x2. These two are that question, not
  // artwork - 90 and 297 bytes.
  const ORIENTATION_PROBES = {
    webp:
      'UklGRlIAAABXRUJQVlA4WAoAAAAIAAAAAQAAAAAAVlA4TBEAAAAvAQAAAA8Q87//8x8OMqL/' +
      'AQBFWElGGgAAAElJKgAIAAAAAQASAQMAAQAAAAYAAAAAAAAA',
    jpeg:
      '/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD//gAQTGF2YzYyLjExLjEw' +
      'MAD/2wBDAAgEBAQEBAUFBQUFBQYGBgYGBgYGBgYGBgYHBwcICAgHBwcGBgcHCAgICAkJCQgI' +
      'CAgJCQoKCgwMCwsODg4RERT/xABaAAEBAAAAAAAAAAAAAAAAAAAABwEBAQEAAAAAAAAAAAAA' +
      'AAAAAAIHEAAABwEAAAAAAAAAAAAAAAAAAgQDBbJ0NBEAAQUBAAAAAAAAAAAAAAAABgUDALQ2' +
      'df/AABEIAAEAAgMBEgACEgADEgD/2gAMAwEAAhEDEQA/AJFId6vQ9cwSHer0PXMNqBMOL8NJ' +
      'pMwCYcX4aTSZkmewI+yp23YM9gR9lTtuz//Z'
  };

  const decoderOrientationSupport = {};

  // Resolves true (decoder applies the tag), false (it does not), or null
  // (could not tell). true and false are cached - they are properties of the
  // browser, not of the customer's file, so one probe per container is enough.
  // null is deliberately NOT cached: a non-answer is not an answer, and
  // remembering one transient failure would put every later upload in that
  // session onto the degraded path for good.
  function decoderAppliesOrientation(container) {
    if (!ORIENTATION_PROBES[container]) return Promise.resolve(null);

    if (!decoderOrientationSupport[container]) {
      const probe = (async () => {
        let bitmap;
        try {
          const binary = atob(ORIENTATION_PROBES[container]);
          const bytes = new Uint8Array(binary.length);
          for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);

          bitmap = await createImageBitmap(new Blob([bytes], { type: 'image/' + container }), {
            imageOrientation: 'from-image'
          });

          return bitmap.height > bitmap.width;
        } catch {
          return null;
        } finally {
          if (bitmap && typeof bitmap.close === 'function') bitmap.close();
        }
      })();

      decoderOrientationSupport[container] = probe
        .catch(() => null)
        .then((result) => {
          if (result === null) delete decoderOrientationSupport[container];
          return result;
        });
    }

    return decoderOrientationSupport[container];
  }

  // Maps stored pixels onto upright ones for the case where the decoder left
  // the tag unapplied. width/height are the bitmap's own (stored) dimensions.
  function applyOrientation(context, orientation, width, height) {
    switch (orientation) {
      case 2: context.translate(width, 0); context.scale(-1, 1); break;
      case 3: context.translate(width, height); context.rotate(Math.PI); break;
      case 4: context.translate(0, height); context.scale(1, -1); break;
      case 5: context.rotate(0.5 * Math.PI); context.scale(1, -1); break;
      case 6: context.rotate(0.5 * Math.PI); context.translate(0, -height); break;
      case 7: context.rotate(0.5 * Math.PI); context.translate(width, -height); context.scale(-1, 1); break;
      case 8: context.rotate(-0.5 * Math.PI); context.translate(-width, 0); break;
      default: break;
    }
  }

  // No downscaling: canvas is sized to the image's own upright dimensions.
  // Returns null on any failure so the caller can fail open.
  async function reencodeUpright(file, quality, orientation, container) {
    let bitmap;
    try {
      bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    } catch {
      return null;
    }

    try {
      // Only rotate here when the decoder demonstrably did not. Guessing
      // "not applied" is not an option: Chrome does apply a JPEG's tag, so
      // rotating on top of that would turn 90 degrees into 180 on the path
      // that is live today.
      //
      // Guessing the other way is worse, which is why an unanswerable probe
      // refuses instead. Re-encoding without knowing would write the stored
      // pixels to JPEG and drop the orientation tag along with them. For a
      // sideways WebP that yields a photo the service accepts - no tag left
      // to refuse - carrying pixels in one frame and the customer's subject
      // hint in another. The hint can then land on the wrong child while
      // looking like the customer chose them. A refusal costs the hint and
      // says so; a wrong guess costs the hint, hides it, and blames nobody.
      //
      // So: return null and let normalizeUploadOrientation fail open, sending
      // the original File with its tag intact. The service refuses the hint
      // loudly, which is exactly today's behaviour and is recoverable.
      // Untagged files never get here, and a browser whose createImageBitmap
      // cannot decode a 90-byte blob is unlikely to decode a customer's photo
      // either - so in practice this mostly coincides with the decode failure
      // that already falls open above.
      const decoderApplied = await decoderAppliesOrientation(container);
      if (decoderApplied === null && orientation) return null;

      const pending = decoderApplied === false && orientation ? orientation : 1;
      const swapsAxes = pending >= 5 && pending <= 8;

      const canvas = document.createElement('canvas');
      canvas.width = swapsAxes ? bitmap.height : bitmap.width;
      canvas.height = swapsAxes ? bitmap.width : bitmap.height;

      const context = canvas.getContext('2d');
      if (!context) return null;

      applyOrientation(context, pending, bitmap.width, bitmap.height);
      context.drawImage(bitmap, 0, 0);

      const blob = await new Promise((resolve) => {
        canvas.toBlob(resolve, 'image/jpeg', quality);
      });

      if (!blob) return null;

      return new File([blob], 'upload.jpg', { type: 'image/jpeg', lastModified: Date.now() });
    } catch {
      return null;
    } finally {
      if (bitmap && typeof bitmap.close === 'function') bitmap.close();
    }
  }

  // The single entry point the upload flow calls. Always resolves - a
  // customer's order must never be lost to this. Normalises only when the
  // file carries an orientation tag other than 1, in a container whose tag
  // this code can read; every other file (no tag, unrecognised container,
  // unparsable) passes through byte-for-byte, as the same File object.
  async function normalizeUploadOrientation(file) {
    const container = await readContainerSignature(file);
    const orientation = await readExifOrientation(file);

    if (!orientation || orientation === 1) {
      console.debug('[photo-upload-orientation]', { normalized: false, orientation: orientation || null });
      return file;
    }

    const reencoded = await reencodeUpright(file, 0.92, orientation, container);

    if (!reencoded) {
      console.debug('[photo-upload-orientation]', { normalized: false, orientation, reason: 'reencode_failed' });
      return file;
    }

    if (reencoded.size > file.size && reencoded.size > MAX_FILE_SIZE) {
      const retried = await reencodeUpright(file, 0.85, orientation, container);

      if (retried && !(retried.size > file.size && retried.size > MAX_FILE_SIZE)) {
        console.debug('[photo-upload-orientation]', { normalized: true, orientation, retried: true });
        return retried;
      }

      console.debug('[photo-upload-orientation]', { normalized: false, orientation, reason: 'over_cap_after_retry' });
      return file;
    }

    console.debug('[photo-upload-orientation]', { normalized: true, orientation, retried: false });
    return reencoded;
  }

  class ApiRequestError extends Error {
    constructor(payload, status) {
      const apiError = payload && payload.error ? payload.error : null;
      super(apiError?.message || GENERIC_ERROR_MESSAGE);
      this.name = 'ApiRequestError';
      this.code = apiError?.code || null;
      // TASK TL17. Only class-validator's array-shaped VALIDATION_ERROR response ever
      // populates this (see ApiErrorBodyDto on the service) — each entry is `{message}`,
      // the raw constraint message, never a structured field name. `code` above is always
      // one of the generic ApiErrorCode values (http-exception.filter.ts maps it from the
      // HTTP status, not from whatever a throw site's own `code` field said), so a
      // per-field signal — when the service has one at all — lives only as TEXT inside one
      // of these messages. See hasValidationDetail() below for how that text is read.
      this.details = Array.isArray(apiError?.details) ? apiError.details : [];
      // TASK TL17, S219 (forever-storybooks-service, branch
      // fix/a-photo-is-accepted-by-what-it-is, commit ea3355d0 — done, not yet merged into
      // develop as of this task). Reading this field now, ahead of that merge, is what the
      // task brief asks for directly: "Read the exact field name of the code from the S219
      // report if it exists when you start." It does. S219 adds `error.reasonCode` as a NEW,
      // ADDITIVE field — never the existing `code`, which stays the generic HTTP-status value
      // for every throw site, S219's new one included (see http-exception.filter.ts's
      // `getErrorCode`, unchanged by S219). Absent on every response until that merge ships,
      // so `getPhotoUploadFailureMessage()` below does not depend on it being present — it is
      // read opportunistically, not required.
      this.reasonCode = typeof apiError?.reasonCode === 'string' ? apiError.reasonCode : null;
      this.requestId = payload?.requestId || null;
      this.status = status;
    }
  }

  class PersonalizationFlowError extends Error {
    constructor(message, code = null, status = null) {
      super(message);
      this.name = 'PersonalizationFlowError';
      this.code = code;
      this.status = status;
      this.requestId = null;
    }
  }

  class PhotoRejectedError extends Error {
    constructor(reason, message) {
      super(message || getPhotoReasonMessage(reason) || GENERIC_ERROR_MESSAGE);
      this.name = 'PhotoRejectedError';
      this.reason = reason || null;
    }
  }

  /**
   * TASK TL17. POST upload/photo answered, but refused the request itself — wrong content
   * type, a magic-byte mismatch (an extension-renamed file), or over the size cap. Distinct
   * from PhotoRejectedError (the PAID photo-content gate in confirmUpload's 200 response) and
   * from a bare ApiRequestError (which carries no opinion on where in the flow it happened):
   * this class exists so handlePersonalizationError() can route it to the photo field without
   * re-deriving "this came from the upload step" from status codes after the fact. See
   * getPhotoUploadFailureMessage() for how `message` is chosen.
   */
  class PhotoUploadFailedError extends Error {
    constructor(message, cause) {
      super(message);
      this.name = 'PhotoUploadFailedError';
      this.cause = cause || null;
    }
  }

  /**
   * TASK TL17. Internal signal only — never reaches handlePersonalizationError(). Thrown when
   * a REUSED personalizationId (see ensurePersonalization()) is refused by the step that used
   * it, so submitPersonalization() can catch it, drop the stale id, and retry once from a
   * fresh create() — see isPersonalizationReuseRefusal().
   */
  class PersonalizationReuseRefusedError extends Error {
    constructor(cause) {
      super('Personalization reuse refused');
      this.name = 'PersonalizationReuseRefusedError';
      this.cause = cause || null;
    }
  }

  /**
   * TASK TL17. fetch() itself rejected — offline, DNS failure, a dropped connection — before
   * any HTTP response existed to read a status or body from. Distinct from ApiRequestError (a
   * response DID come back, just not a success one): there is no server-authored message to
   * show here, so this is the one error class that carries its own customer-facing text up
   * front, in the same "something went wrong on our side" bucket as a 5xx or a 429 — see
   * isServerSideError().
   */
  class NetworkError extends Error {
    constructor(cause) {
      super(SERVER_ERROR_MESSAGE);
      this.name = 'NetworkError';
      this.code = 'NETWORK_ERROR';
      this.status = null;
      this.cause = cause || null;
    }
  }

  // TASK TL17. True of any failure where nothing the customer typed or picked is at fault:
  // the request never reached the service (NetworkError), or it did and the service itself
  // could not handle it (5xx) or asked for backoff (429). Shared by getCustomerErrorMessage()
  // (the generic footer) and the upload-specific path (getPhotoUploadFailureMessage() must
  // NOT be reached for these — a 503 is not "wrong photo format").
  function isServerSideError(error) {
    if (error instanceof NetworkError) {
      return true;
    }

    const status = typeof error?.status === 'number' ? error.status : null;
    return status !== null && (status >= 500 || status === 429);
  }

  // TASK TL17. Every message in ApiRequestError.details is `{message: string}` — see the
  // comment on that class. Centralised here so every reader of `details` (the child-name
  // check, the child-birth-date check, any future one) agrees on how to get a flat list of
  // strings out of it.
  function getValidationDetailMessages(error) {
    if (!Array.isArray(error?.details)) {
      return [];
    }

    return error.details
      .map((detail) => detail?.message)
      .filter((message) => typeof message === 'string');
  }

  function hasValidationDetail(error, matches) {
    return error?.code === 'VALIDATION_ERROR' && getValidationDetailMessages(error).some(matches);
  }

  /**
   * TASK TL17. The message for a 400 from POST upload/photo specifically — the bytes
   * themselves were refused, not anything about the fields.
   *
   * `error.reasonCode === 'PHOTO_FORMAT_UNSUPPORTED'` — the dedicated signal S219
   * (forever-storybooks-service, branch fix/a-photo-is-accepted-by-what-it-is, commit
   * ea3355d0, done but NOT YET MERGED into develop as of this task) adds for this exact
   * case — is deliberately NOT branched on separately here: it resolves to the same text as
   * every other 400 this endpoint can answer (Content-Type rejected, magic-byte mismatch —
   * both measured against personalization.service.ts/controller.ts on `develop`), because all
   * of them mean the same thing to the customer — the content is wrong in some way they can
   * only fix by picking a different file. A real branch here would be two identical return
   * statements. See the comment on ApiRequestError.reasonCode for where that field is read;
   * this function needs nothing further once S219 merges. 413 means something different ("too
   * big," not "wrong kind") and gets its own text. Never called for a server-side failure —
   * see isServerSideError() — so there is no branch here for "we don't know," only "too big"
   * or "wrong kind."
   */
  function getPhotoUploadFailureMessage(error) {
    if (error?.status === 413 || error?.code === 'PAYLOAD_TOO_LARGE') {
      return PHOTO_SIZE_MESSAGE;
    }

    return PHOTO_TYPE_MESSAGE;
  }

  /**
   * TASK TL17. Whether a REUSED personalizationId (see ensurePersonalization()) was refused
   * by the step that just tried to use it, rather than the request itself being bad for some
   * other reason. Measured against the service: `uploadPhoto` and `confirmUpload` both answer
   * 400 with a message containing "terminal personalization" when the id has moved to a
   * terminal status since it was created (personalization.service.ts), and either answers 404
   * if the id is not found at all. Message-text matching, not a dedicated code — the service
   * has no dedicated code for this either (see the comment on ApiRequestError.details above
   * for why that is the general shape here, not an exception).
   */
  function isPersonalizationReuseRefusal(error) {
    if (!(error instanceof ApiRequestError)) {
      return false;
    }

    if (error.status === 404) {
      return true;
    }

    return error.status === 400 && typeof error.message === 'string' && /terminal personalization/i.test(error.message);
  }

  function toShopifyGid(type, id) {
    if (!id) {
      return '';
    }

    const value = String(id);
    return value.startsWith('gid://') ? value : `gid://shopify/${type}/${value}`;
  }

  async function parseJsonResponse(response) {
    let payload = null;

    try {
      payload = await response.json();
    } catch {
      payload = null;
    }

    if (!response.ok || payload?.success === false) {
      throw new ApiRequestError(payload, response.status);
    }

    return payload;
  }

  async function getJson(url) {
    let response;

    try {
      response = await fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' }
      });
    } catch (error) {
      throw new NetworkError(error);
    }

    return parseJsonResponse(response);
  }

  async function postJson(url, body) {
    let response;

    try {
      response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });
    } catch (error) {
      throw new NetworkError(error);
    }

    return parseJsonResponse(response);
  }

  /**
   * One optional photo slot (2 or 3), independent of slot 1 and of every other extra slot.
   *
   * Slot 1's precheck state (filePrecheckToken, photoPrecheckRejected, the subject chooser)
   * is a set of singleton fields on ProductPhotoUploadModal — see R1 in the branch report:
   * sharing those across slots would let a file pick in one slot silently invalidate an
   * in-flight precheck result in another. Each ExtraPhotoSlot instance gets its own token
   * instead, so slots 2 and 3 (and slot 1, untouched) can never step on each other.
   *
   * A rejection here is always advisory: it sets a message on this slot alone and never
   * touches the modal's shared `photo` field or its validate()/submit gate — photos 2 and 3
   * are not paid-checked before checkout, so nothing they do may block it.
   */
  class ExtraPhotoSlot {
    constructor(modal, slot, loadPrecheckModule, precheckAssetUrls, loadHeicConverterModule, refreshPhotoCount) {
      this.slot = slot;
      this.loadPrecheckModule = loadPrecheckModule;
      this.precheckAssetUrls = precheckAssetUrls;
      this.loadHeicConverterModule = loadHeicConverterModule;
      // TASK TL18 item 5. Called directly on every state change instead of relying on a
      // modal-wide delegated listener — see refreshPhotoCount()'s own docblock on
      // ProductPhotoUploadModal for why that delegation was removed.
      this.refreshPhotoCount = refreshPhotoCount;

      this.fieldEl = modal.querySelector(`[data-product-photo-modal-extra-slot="${slot}"]`);
      this.uploadRow = modal.querySelector(`[data-product-photo-modal-extra-upload-row="${slot}"]`);
      this.uploadButton = modal.querySelector(`[data-product-photo-modal-extra-upload="${slot}"]`);
      // This slot's own button is out of sight and out of the tab order since the 2026-09-15
      // redesign, so focus after a removal must land on the one visible dropzone. Focusing
      // `this.uploadButton` would drop focus into an element nobody can see.
      this.sharedUploadButton = modal.querySelector(UPLOAD_SELECTOR);
      this.fileInput = modal.querySelector(`[data-product-photo-modal-extra-file-input="${slot}"]`);
      this.fileName = modal.querySelector(`[data-product-photo-modal-extra-file-name="${slot}"]`);
      this.preview = modal.querySelector(`[data-product-photo-modal-extra-preview="${slot}"]`);
      this.previewImage = modal.querySelector(`[data-product-photo-modal-extra-preview-image="${slot}"]`);
      this.previewStatus = modal.querySelector(`[data-product-photo-modal-extra-preview-status="${slot}"]`);
      this.previewRemoveButton = modal.querySelector(`[data-product-photo-modal-extra-preview-remove="${slot}"]`);
      this.checkingIndicator = modal.querySelector(`[data-product-photo-modal-extra-checking="${slot}"]`);
      this.messageEl = modal.querySelector(`[data-product-photo-modal-extra-message="${slot}"]`);

      this.precheckToken = 0;
      this.previewObjectUrl = null;
      this.disabled = false;

      this.handleUploadClick = this.handleUploadClick.bind(this);
      this.handleFileChange = this.handleFileChange.bind(this);
      this.handleRemoveClick = this.handleRemoveClick.bind(this);

      if (this.uploadButton && this.fileInput) {
        this.uploadButton.addEventListener('click', this.handleUploadClick);
        this.fileInput.addEventListener('change', this.handleFileChange);
      }

      if (this.previewRemoveButton) {
        this.previewRemoveButton.addEventListener('click', this.handleRemoveClick);
      }
    }

    destroy() {
      if (this.uploadButton) {
        this.uploadButton.removeEventListener('click', this.handleUploadClick);
      }

      if (this.fileInput) {
        this.fileInput.removeEventListener('change', this.handleFileChange);
      }

      if (this.previewRemoveButton) {
        this.previewRemoveButton.removeEventListener('click', this.handleRemoveClick);
      }

      this.clearPreviewObjectUrl();
    }

    getFile() {
      return this.fileInput && this.fileInput.files ? this.fileInput.files[0] : null;
    }

    /**
     * The extra-slot mirror of ProductPhotoUploadModal.applyCapturedFile() — same DataTransfer
     * assignment, same dispatched 'change', so a phone photo routed to this slot runs through
     * this slot's own handleFileChange() (precheck, preview, file name, removal button) instead
     * of a second, parallel path that would have to reimplement all of that.
     */
    applyCapturedFile(file) {
      if (!this.fileInput) {
        return;
      }

      try {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        this.fileInput.files = dataTransfer.files;
      } catch (error) {
        console.warn('[product-photo-upload-modal] could not attach captured file to extra slot', {
          slot: this.slot,
          name: error?.name || null
        });
        this.setMessage(HANDOFF_ATTACH_FAILED_MESSAGE);
        return;
      }

      this.fileInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    handleUploadClick(event) {
      event.preventDefault();

      if (this.disabled) {
        return;
      }

      this.fileInput.click();
    }

    handleFileChange() {
      if (this.disabled) {
        return;
      }

      const file = this.getFile();

      this.precheckToken += 1;
      const token = this.precheckToken;
      this.setChecking(false);
      this.setMessage('');

      if (!file) {
        this.clearPreview();
        this.refreshPhotoCount();
        return;
      }

      if (isHeicFile(file)) {
        this.convertHeicAndProcess(file, token);
        return;
      }

      this.processSelectedPhotoFile(file, token);
    }

    // TASK TL18 item 2. Mirrors ProductPhotoUploadModal.convertHeicAndProcess() — see that
    // method's docblock for why conversion cannot wait until submit time.
    convertHeicAndProcess(file, token) {
      this.setChecking(true);

      convertHeicFileToJpeg(file, this.loadHeicConverterModule).then((converted) => {
        if (token !== this.precheckToken) {
          return;
        }

        this.setChecking(false);

        if (!converted) {
          this.fileInput.value = '';
          this.setFileName('');
          this.clearPreview();
          this.setMessage(PHOTO_TYPE_MESSAGE);
          this.refreshPhotoCount();
          return;
        }

        try {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(converted);
          this.fileInput.files = dataTransfer.files;
        } catch (error) {
          console.warn('[product-photo-upload-modal] could not attach converted HEIC file', {
            slot: this.slot,
            name: error?.name || null
          });
          this.fileInput.value = '';
          this.setFileName('');
          this.clearPreview();
          this.setMessage(PHOTO_TYPE_MESSAGE);
          this.refreshPhotoCount();
          return;
        }

        this.processSelectedPhotoFile(converted, token);
      });
    }

    processSelectedPhotoFile(file, token) {
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        this.fileInput.value = '';
        this.setFileName('');
        this.clearPreview();
        this.setMessage(PHOTO_TYPE_MESSAGE);
        this.refreshPhotoCount();
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        this.fileInput.value = '';
        this.setFileName('');
        this.clearPreview();
        this.setMessage(PHOTO_SIZE_MESSAGE);
        this.refreshPhotoCount();
        return;
      }

      this.setFileName(file.name);
      this.setPreview(file);
      this.runPrecheck(file, token);
      this.refreshPhotoCount();
    }

    handleRemoveClick(event) {
      event.preventDefault();

      if (this.disabled) {
        return;
      }

      this.reset();
      this.refreshPhotoCount();

      if (this.sharedUploadButton && !this.sharedUploadButton.hidden) {
        this.sharedUploadButton.focus({ preventScroll: true });
      }
    }

    runPrecheck(file, token) {
      this.setChecking(true);

      this.loadPrecheckModule()
        .then((precheck) => {
          if (!precheck) {
            return { verdict: 'unknown', detectorPath: 'none' };
          }

          return precheck.run(file, this.precheckAssetUrls);
        })
        .catch(() => ({ verdict: 'unknown', detectorPath: 'none' }))
        .then((verdict) => {
          // Same discipline as the primary slot's runPhotoPrecheck: a verdict for a file the
          // customer has already replaced or removed in THIS slot must never surface.
          if (token !== this.precheckToken) {
            return;
          }

          this.setChecking(false);
          recordPhotoPrecheckTelemetry(verdict);

          if (verdict.verdict === 'reject') {
            this.setMessage(getPhotoReasonMessage(verdict.reason) || GENERIC_ERROR_MESSAGE);
          }

          // 'pass', 'unknown', and 'choose_subject' all show nothing here. Unlike slot 1, an
          // extra slot never opens the subject chooser — see R1: the chooser is a page-wide
          // singleton, and the subject hint it produces is for the generation-driving photo,
          // not for a supplementary reference photo. A multi-face extra photo is left to the
          // post-payment validation pipeline, same as any other extra-photo issue.
        });
    }

    setFileName(name) {
      if (!this.fileName) {
        return;
      }

      this.fileName.textContent = name ? `Selected photo: ${name}` : '';
      this.fileName.hidden = true;
    }

    setChecking(isChecking) {
      if (this.uploadButton) {
        this.uploadButton.setAttribute('aria-busy', isChecking ? 'true' : 'false');
      }

      if (this.checkingIndicator) {
        this.checkingIndicator.hidden = !isChecking;
      }
    }

    setMessage(message) {
      if (!this.messageEl) {
        return;
      }

      this.messageEl.textContent = message || '';
      this.messageEl.hidden = !message;

      if (this.fieldEl) {
        this.fieldEl.classList.toggle('has-error', Boolean(message));
      }
    }

    setPreview(file) {
      if (!this.preview) {
        return;
      }

      this.clearPreviewObjectUrl();
      this.preview.hidden = false;
      this.preview.classList.remove('is-empty');
      this.preview.classList.add('is-loading');
      this.preview.setAttribute('aria-label', `Selected photo: ${file.name}`);

      if (this.uploadRow) {
        this.uploadRow.classList.add('has-photo');
      }

      if (this.previewRemoveButton) {
        this.previewRemoveButton.hidden = false;
      }

      if (this.previewStatus) {
        this.previewStatus.textContent = '';
      }

      if (file.type.startsWith('image/') && this.previewImage) {
        const previewUrl = URL.createObjectURL(file);
        this.previewObjectUrl = previewUrl;
        this.previewImage.hidden = false;
        this.previewImage.src = previewUrl;
        this.previewImage.alt = `Uploaded child photo preview: ${file.name}`;

        this.previewImage.onload = () => {
          this.preview.classList.remove('is-loading');

          if (this.previewObjectUrl === previewUrl) {
            URL.revokeObjectURL(previewUrl);
            this.previewObjectUrl = null;
          }
        };

        this.previewImage.onerror = () => {
          this.reset();
          this.setMessage('We could not preview this photo. Please choose a different JPG, PNG, or WebP image.');
        };
      }
    }

    clearPreview() {
      this.clearPreviewObjectUrl();

      if (this.preview) {
        this.preview.hidden = true;
        this.preview.classList.add('is-empty');
        this.preview.classList.remove('is-loading');
        this.preview.removeAttribute('aria-label');
      }

      if (this.uploadRow) {
        this.uploadRow.classList.remove('has-photo');
      }

      if (this.previewImage) {
        this.previewImage.hidden = true;
        this.previewImage.removeAttribute('src');
        this.previewImage.alt = 'Uploaded child photo preview';
        this.previewImage.onload = null;
        this.previewImage.onerror = null;
      }

      if (this.previewStatus) {
        this.previewStatus.textContent = '';
      }

      if (this.previewRemoveButton) {
        this.previewRemoveButton.hidden = true;
      }
    }

    clearPreviewObjectUrl() {
      if (this.previewObjectUrl) {
        URL.revokeObjectURL(this.previewObjectUrl);
        this.previewObjectUrl = null;
      }
    }

    reset() {
      if (this.fileInput) {
        this.fileInput.value = '';
      }

      this.precheckToken += 1;
      this.setChecking(false);
      this.setMessage('');
      this.setFileName('');
      this.clearPreview();
    }

    setDisabled(isDisabled) {
      this.disabled = isDisabled;

      [this.uploadButton, this.fileInput, this.previewRemoveButton].filter(Boolean).forEach((element) => {
        element.disabled = isDisabled;
      });
    }
  }

  class ProductPhotoUploadModal {
    constructor(modal) {
      this.modal = modal;
      this.dialog = modal.querySelector('.product-photo-modal__dialog');
      this.form = modal.querySelector('[data-product-photo-modal-form]');
      this.closeButton = modal.querySelector('.product-photo-modal__close');
      this.uploadButton = modal.querySelector(UPLOAD_SELECTOR);
      this.uploadRow = modal.querySelector(UPLOAD_ROW_SELECTOR);
      this.fileInput = modal.querySelector(FILE_INPUT_SELECTOR);
      this.fileName = modal.querySelector(FILE_NAME_SELECTOR);
      this.preview = modal.querySelector(PREVIEW_SELECTOR);
      this.previewImage = modal.querySelector(PREVIEW_IMAGE_SELECTOR);
      this.previewStatus = modal.querySelector(PREVIEW_STATUS_SELECTOR);
      this.previewRemoveButton = modal.querySelector(PREVIEW_REMOVE_SELECTOR);
      this.message = modal.querySelector(MESSAGE_SELECTOR);
      this.messageText = modal.querySelector(MESSAGE_TEXT_SELECTOR);
      this.photoMessage = modal.querySelector(PHOTO_MESSAGE_SELECTOR);
      this.checkingIndicator = modal.querySelector(CHECKING_SELECTOR);
      this.cameraTrigger = modal.querySelector(CAMERA_TRIGGER_SELECTOR);
      this.camera = modal.querySelector(CAMERA_SELECTOR);
      this.cameraVideo = modal.querySelector(CAMERA_VIDEO_SELECTOR);
      this.cameraCaptureButton = modal.querySelector(CAMERA_CAPTURE_SELECTOR);
      this.cameraCancelButton = modal.querySelector(CAMERA_CANCEL_SELECTOR);
      this.cameraMessage = modal.querySelector(CAMERA_MESSAGE_SELECTOR);
      this.cameraFallbackInput = modal.querySelector(CAMERA_FALLBACK_INPUT_SELECTOR);
      this.cameraFallbackTrigger = modal.querySelector(CAMERA_FALLBACK_TRIGGER_SELECTOR);
      this.guide = modal.querySelector(GUIDE_SELECTOR);
      this.guidePanels = Array.from(modal.querySelectorAll(GUIDE_PANEL_SELECTOR));
      this.guideStartButton = modal.querySelector(GUIDE_START_SELECTOR);
      this.guideUploadButton = modal.querySelector(GUIDE_UPLOAD_SELECTOR);
      // Two of these now — the intro's chevron and the keep screen's — so every match is
      // bound, not just the first one querySelector would have found.
      this.guideBackButtons = Array.from(modal.querySelectorAll(GUIDE_BACK_SELECTOR));
      this.keepImage = modal.querySelector(KEEP_IMAGE_SELECTOR);
      this.keepCaption = modal.querySelector(KEEP_CAPTION_SELECTOR);
      this.keepSaveButton = modal.querySelector(KEEP_SAVE_SELECTOR);
      this.keepRetakeButton = modal.querySelector(KEEP_RETAKE_SELECTOR);
      this.cameraHeader = modal.querySelector(CAMERA_HEADER_SELECTOR);
      this.cameraBackButton = modal.querySelector(CAMERA_BACK_SELECTOR);
      this.cameraStepCount = modal.querySelector(CAMERA_STEP_COUNT_SELECTOR);
      this.cameraStepLabel = modal.querySelector(CAMERA_STEP_LABEL_SELECTOR);
      this.cameraOverlay = modal.querySelector(CAMERA_OVERLAY_SELECTOR);
      this.cameraScan = modal.querySelector(CAMERA_SCAN_SELECTOR);
      this.cameraTurnMeter = modal.querySelector(CAMERA_TURN_METER_SELECTOR);
      this.cameraTurnFill = modal.querySelector(CAMERA_TURN_FILL_SELECTOR);
      this.cameraGuidance = modal.querySelector(CAMERA_GUIDANCE_SELECTOR);
      this.cameraSkipButton = modal.querySelector(CAMERA_SKIP_SELECTOR);
      this.cameraFlipButton = modal.querySelector(CAMERA_FLIP_SELECTOR);
      this.cameraFlipLabel = modal.querySelector(CAMERA_FLIP_LABEL_SELECTOR);
      this.cameraTorchButton = modal.querySelector(CAMERA_TORCH_SELECTOR);
      this.torchOn = false;
      this.cameraFlash = modal.querySelector(CAMERA_FLASH_SELECTOR);
      this.reviewList = modal.querySelector(REVIEW_LIST_SELECTOR);
      this.reviewNotice = modal.querySelector(REVIEW_NOTICE_SELECTOR);
      this.reviewSaveButton = modal.querySelector(REVIEW_SAVE_SELECTOR);
      this.reviewDiscardButton = modal.querySelector(REVIEW_DISCARD_SELECTOR);
      // Which camera the GUIDED flow is asking for. Survives a step change so a parent who
      // flipped to the front camera on the left profile is not thrown back to the rear one on
      // the right profile; reset only when the flow ends. The single-shot camera never reads
      // this — it has its own fixed constraint in cameraConstraints().
      this.guideFacingMode = GUIDE_DEFAULT_FACING_MODE;
      // What the browser says is actually running, which is not always what was asked for:
      // `ideal` is a preference, and a device with one camera satisfies either request with
      // the same hardware. Drives the preview mirror and the flip button's label.
      this.cameraActiveFacingMode = null;
      // Set across the close/open cycle of a flip so focus can land back on the flip button
      // rather than the shutter — a parent who just flipped is more likely to flip again.
      this.guideFlipPending = false;
      // Bumped by every openCamera() and every closeCamera(), so a getUserMedia still in
      // flight can tell whether it is still the request the UI is waiting for. Same
      // discipline as filePrecheckToken and handoffRequestToken elsewhere in this file.
      this.cameraRequestToken = 0;
      // Committed detector signals and how many consecutive samples currently disagree with
      // each. Reset whenever a camera stage starts, so a step never inherits the last one's
      // conclusion. See debounceSignal().
      this.guideSignals = {
        detected: false,
        frontal: false,
        profileOk: false,
        needsCenter: false,
        needsCloser: false,
        needsFurther: false,
        needsStraighten: false,
        needsFaceCamera: false
      };
      this.guideSignalStreaks = {
        detected: 0,
        frontal: 0,
        profileOk: 0,
        needsCenter: 0,
        needsCloser: 0,
        needsFurther: 0,
        needsStraighten: 0,
        needsFaceCamera: 0
      };
      // How many cameras this device actually has. null means "not counted yet" — and an
      // uncounted device keeps the flip button, because hiding a working control on the
      // strength of a query that failed is worse than showing one that does nothing.
      this.videoInputCount = null;
      // One entry per step: { file, url } once shot, null while unshot or skipped. NOTHING
      // here reaches a slot until the review screen's Save — which is what makes that button
      // an action rather than a confirmation of work already done, and what lets any step be
      // retaken without having to undo a slot.
      this.guidePendingPhotos = GUIDE_STEPS.map(() => null);
      // Set while a step is being retaken FROM the review screen, so finishing that step
      // returns there instead of walking forward through the remaining steps.
      this.guideReturnToReview = false;
      this.autoCaptureTimer = null;
      // The raw (undebounced) front-step ready condition, recomputed every sample — read only
      // by startAutoCapture()'s own fire-time check. See that method's doc comment.
      this.guideRawReady = false;
      // True between the shutter press and the frame being handed on. A second press inside
      // that window used to land after the stage had moved to 'keep'.
      this.captureInFlight = false;
      // null when the guided flow is not running. 'intro' | 'camera' | 'keep' otherwise —
      // the single source of truth for which of the three stages is on screen, and what
      // Escape, the shutter and the camera's own lifecycle should do.
      this.guideStage = null;
      this.guideStepIndex = 0;
      // Where focus came from when the flow started, so closeGuide() can put it back —
      // the same contract closeCamera() honours through cameraLastTrigger.
      this.guideLastTrigger = null;
      // The frame waiting on the "Keep this photo?" stage, and its blob: URL. Both are
      // dropped (and the URL revoked) the moment that stage is left by any route — save,
      // retake, skip, back, Escape or the modal closing.
      this.guideCapturedFile = null;
      this.guideCapturedUrl = null;
      // A downscaled copy for the review rows; see createThumbnailUrl().
      this.guideCapturedThumbUrl = null;
      this.guideSampleTimer = null;
      this.guideSampleInFlight = false;
      // The last state announced through the guidance pill ('ready' | 'turn' | 'static'),
      // so a sample that agrees with the previous one does not rewrite an aria-live region
      // twice a second. null until the first camera stage opens.
      this.guideGuidanceKind = null;
      // Set when the tab is backgrounded mid-capture so returning to it can reopen the
      // camera on the same step instead of stranding the parent on a dead black panel.
      this.guideResumeOnReturn = false;
      // A laptop/desktop's own camera, when it has one at all, faces the customer, not the
      // child in front of them — the QR slot plays the camera card's role there instead
      // (see updateCameraAvailability()). MediaQueryList here, not a one-time
      // window.innerWidth check: a tablet gets rotated, a window gets dragged wider, and the
      // card has to react without a reload. `addEventListener` on a MediaQueryList is
      // supported everywhere this codebase already requires (Safari 14+; only Safari 13 and
      // earlier lack it, already below this file's DataTransfer-driven floor — see the
      // camera-fallback task's run report), so no addListener() fallback is needed.
      this.cameraDesktopQuery = window.matchMedia(CAMERA_DESKTOP_QUERY);
      this.cameraStream = null;
      this.cameraOpen = false;
      this.cameraLastTrigger = null;
      this.qrSlot = modal.querySelector(QR_SLOT_SELECTOR);
      this.handoffAssetUrls = this.readHandoffAssetUrls();
      this.qrEncoderModulePromise = null;
      // Non-null exactly while a handoff is active (requested, showing a QR, or polling).
      // Cleared by stopHandoff() on close, on the >=1024 breakpoint being left, on
      // expiresAt passing, and on the server reporting alive:false.
      this.handoffToken = null;
      this.handoffExpiresAtMs = null;
      this.handoffPollTimer = null;
      this.handoffExpiryTimer = null;
      // Bumped on every startHandoff()/stopHandoff() so a slow in-flight create/poll
      // response from a superseded handoff can never write into current state — same
      // discipline as filePrecheckToken elsewhere in this file.
      this.handoffRequestToken = 0;
      // photoIds already imported via applyCapturedFile(), so a photo the phone already
      // sent is never re-fetched and re-applied on the next poll.
      this.handoffSeenPhotoIds = new Set();
      this.precheckAssetUrls = this.readPrecheckAssetUrls();
      this.precheckModulePromise = null;
      this.heicConverterAssetUrl = this.readHeicConverterAssetUrl();
      this.heicConverterModulePromise = null;
      this.filePrecheckToken = 0;
      this.photoPrecheckRejected = false;
      this.extraSlots = EXTRA_SLOT_NUMBERS.map((slot) => {
        return new ExtraPhotoSlot(
          modal,
          slot,
          this.loadPrecheckModule.bind(this),
          this.precheckAssetUrls,
          this.loadHeicConverterModule.bind(this),
          this.refreshPhotoCount.bind(this)
        );
      });
      // Set only via the chooser's 'subjectselect:select' event, on a candidate
      // box from the client precheck — never an index, never auto-picked. See
      // buildSubjectHintProperty().
      this.selectedSubjectHint = null;
      this.subjectHintObjectUrl = null;
      this.nameInput = modal.querySelector(NAME_SELECTOR);
      this.nameErrorEl = modal.querySelector(NAME_ERROR_SELECTOR);
      this.genderNoteEl = modal.querySelector(GENDER_NOTE_SELECTOR);
      // Set once by applyAudienceLock() in init() and never cleared — see that method's
      // docblock for why setSubmittingState() below must not be allowed to re-enable a locked
      // gender control once a submit finishes.
      this.genderLocked = false;
      this.birthDateInput = modal.querySelector(BIRTH_DATE_SELECTOR);
      this.consentCheckbox = modal.querySelector(CONSENT_SELECTOR);
      this.ageSelect = modal.querySelector(AGE_SELECTOR);
      this.ageHintEl = modal.querySelector(AGE_HINT_SELECTOR);
      this.ageBandsLoaded = false;
      // The strings GET /age-bands actually returned for this product, kept so a later birth
      // date edit can re-match against them without a second request. Never a hardcoded band
      // list — see the comment on AGE_BANDS_URL_PREFIX.
      this.ageBands = [];
      // Set only by a real 'change' on the select (handleAgeSelectManualChange) — never by
      // applyBirthDateAgeHint's own `.value =` — so a programmatic preselect can never be
      // mistaken for the customer's own choice. Once true, the birth date must never move the
      // select again.
      this.ageSelectTouchedByUser = false;
      this.photoCountEl = modal.querySelector(PHOTO_COUNT_SELECTOR);
      this.submitButton = modal.querySelector(SUBMIT_SELECTOR);
      this.isOpen = false;
      this.isSubmitting = false;
      // TASK TL17. Set only by createFreshPersonalization(), once create() has actually
      // succeeded — see ensurePersonalization(). Cleared on close() (a new open() is a new
      // session) and whenever a reused id is refused by the server (submitPersonalization()).
      this.activePersonalizationId = null;
      this.activePersonalizationFingerprint = null;
      this.lastTrigger = null;
      this.scrollY = 0;
      this.previousBodyStyles = null;
      this.previewObjectUrl = null;
      this.submitButtonText = this.submitButton ? this.submitButton.textContent.trim() : '';

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleUploadClick = this.handleUploadClick.bind(this);
      this.handleFileChange = this.handleFileChange.bind(this);
      this.handlePreviewRemoveClick = this.handlePreviewRemoveClick.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleSubmitClick = this.handleSubmitClick.bind(this);
      this.handleValidationInput = this.handleValidationInput.bind(this);
      this.handleNameInput = this.handleNameInput.bind(this);
      this.handleNameBlur = this.handleNameBlur.bind(this);
      this.handleAgeSelectManualChange = this.handleAgeSelectManualChange.bind(this);
      this.applyBirthDateAgeHint = this.applyBirthDateAgeHint.bind(this);
      this.refreshPhotoCount = this.refreshPhotoCount.bind(this);
      this.handleSubjectSelect = this.handleSubjectSelect.bind(this);
      this.handleSubjectReupload = this.handleSubjectReupload.bind(this);
      this.handleSubjectDismiss = this.handleSubjectDismiss.bind(this);
      this.handleCameraTriggerClick = this.handleCameraTriggerClick.bind(this);
      this.handleCameraCaptureClick = this.handleCameraCaptureClick.bind(this);
      this.handleCameraCancelClick = this.handleCameraCancelClick.bind(this);
      this.handleCameraFallbackChange = this.handleCameraFallbackChange.bind(this);
      this.handleCameraFallbackTriggerClick = this.handleCameraFallbackTriggerClick.bind(this);
      this.handleGuideStartClick = this.handleGuideStartClick.bind(this);
      this.handleGuideUploadClick = this.handleGuideUploadClick.bind(this);
      this.handleGuideBackClick = this.handleGuideBackClick.bind(this);
      this.handleKeepSaveClick = this.handleKeepSaveClick.bind(this);
      this.handleKeepRetakeClick = this.handleKeepRetakeClick.bind(this);
      this.handleCameraSkipClick = this.handleCameraSkipClick.bind(this);
      this.handleCameraFlipClick = this.handleCameraFlipClick.bind(this);
      this.handleCameraTorchClick = this.handleCameraTorchClick.bind(this);
      this.handleReviewSaveClick = this.handleReviewSaveClick.bind(this);
      this.handleReviewDiscardClick = this.handleReviewDiscardClick.bind(this);
      this.handleReviewRetakeClick = this.handleReviewRetakeClick.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
      this.updateCameraAvailability = this.updateCameraAvailability.bind(this);
      this.updateHandoffAvailability = this.updateHandoffAvailability.bind(this);
      this.pollHandoffStatus = this.pollHandoffStatus.bind(this);
      this.handleHandoffRetryClick = this.handleHandoffRetryClick.bind(this);
      this.handleHandoffLinkClick = this.handleHandoffLinkClick.bind(this);

      this.init();
    }

    init() {
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');

      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleKeydown);

      if (this.uploadButton && this.fileInput) {
        this.uploadButton.addEventListener('click', this.handleUploadClick);
        this.fileInput.addEventListener('change', this.handleFileChange);
      }

      if (this.previewRemoveButton) {
        this.previewRemoveButton.addEventListener('click', this.handlePreviewRemoveClick);
      }

      if (this.cameraTrigger) {
        this.cameraTrigger.addEventListener('click', this.handleCameraTriggerClick);
      }

      if (this.cameraCaptureButton) {
        this.cameraCaptureButton.addEventListener('click', this.handleCameraCaptureClick);
      }

      if (this.cameraCancelButton) {
        this.cameraCancelButton.addEventListener('click', this.handleCameraCancelClick);
      }

      if (this.cameraFallbackInput) {
        this.cameraFallbackInput.addEventListener('change', this.handleCameraFallbackChange);
      }

      if (this.cameraFallbackTrigger) {
        this.cameraFallbackTrigger.addEventListener('click', this.handleCameraFallbackTriggerClick);
      }

      if (this.guideStartButton) {
        this.guideStartButton.addEventListener('click', this.handleGuideStartClick);
      }

      if (this.guideUploadButton) {
        this.guideUploadButton.addEventListener('click', this.handleGuideUploadClick);
      }

      // Both back affordances leave the guided flow entirely — see handleGuideBackClick.
      this.guideBackButtons.forEach((button) => {
        button.addEventListener('click', this.handleGuideBackClick);
      });

      if (this.cameraBackButton) {
        this.cameraBackButton.addEventListener('click', this.handleGuideBackClick);
      }

      if (this.keepSaveButton) {
        this.keepSaveButton.addEventListener('click', this.handleKeepSaveClick);
      }

      if (this.keepRetakeButton) {
        this.keepRetakeButton.addEventListener('click', this.handleKeepRetakeClick);
      }

      if (this.cameraSkipButton) {
        this.cameraSkipButton.addEventListener('click', this.handleCameraSkipClick);
      }

      if (this.cameraFlipButton) {
        this.cameraFlipButton.addEventListener('click', this.handleCameraFlipClick);
      }

      if (this.cameraTorchButton) {
        this.cameraTorchButton.addEventListener('click', this.handleCameraTorchClick);
      }

      if (this.reviewSaveButton) {
        this.reviewSaveButton.addEventListener('click', this.handleReviewSaveClick);
      }

      if (this.reviewDiscardButton) {
        this.reviewDiscardButton.addEventListener('click', this.handleReviewDiscardClick);
      }

      // Delegated: the retake buttons are rebuilt by renderGuideReview() on every visit, so
      // binding them individually would mean rebinding them individually too.
      if (this.reviewList) {
        this.reviewList.addEventListener('click', this.handleReviewRetakeClick);
      }

      // A backgrounded tab must not hold the camera open. Registered on document rather
      // than the modal because visibilitychange only ever fires there.
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      // Reloading or navigating away with photos held loses them — they live in memory only
      // until the review screen's Save. Best effort: the browser decides whether to honour
      // it, and several mobile browsers will not.
      window.addEventListener('beforeunload', this.handleBeforeUnload);

      if (this.cameraDesktopQuery) {
        this.cameraDesktopQuery.addEventListener('change', this.updateCameraAvailability);
        // Separate listener, same query: a live resize/rotation must also start or stop the
        // handoff poll, not just toggle the camera card. updateHandoffAvailability() itself
        // is a no-op below 1024 or while the modal is closed, so registering it now (before
        // the modal has ever been opened) is harmless — see the method for why.
        this.cameraDesktopQuery.addEventListener('change', this.updateHandoffAvailability);
      }

      // Sets the correct initial state on load — the change listener above only fires on a
      // LATER crossing of the breakpoint, never for the state the page already loaded in.
      this.updateCameraAvailability();

      if (this.nameInput) {
        this.nameInput.addEventListener('input', this.handleValidationInput);
        // TASK TL6. Two separate, narrow jobs — never shows a NEW error on a keystroke (only
        // clears one already shown) and shows one on leaving the field, per the "shown on blur
        // and on submit" requirement. Neither carries role="alert"; see showNameError().
        this.nameInput.addEventListener('input', this.handleNameInput);
        this.nameInput.addEventListener('blur', this.handleNameBlur);
      }

      if (this.ageSelect) {
        this.ageSelect.addEventListener('change', this.handleValidationInput);
        // A real user gesture on the select — separate from handleValidationInput so this
        // fires even once the footer message is no longer visible, which is when it matters
        // most (the customer is choosing, not correcting an error).
        this.ageSelect.addEventListener('change', this.handleAgeSelectManualChange);
      }

      if (this.birthDateInput) {
        this.birthDateInput.addEventListener('change', this.handleValidationInput);
        this.birthDateInput.addEventListener('change', this.applyBirthDateAgeHint);
      }

      if (this.consentCheckbox) {
        this.consentCheckbox.addEventListener('change', this.handleValidationInput);
      }

      if (this.submitButton) {
        this.submitButton.addEventListener('click', this.handleSubmitClick);
      }

      if (this.form) {
        this.form.addEventListener('submit', this.handleFormSubmit);
      }

      // The chooser (subject-select-modal.js) is a separate, independently
      // initialised component that dispatches these on itself with
      // bubbles: true — listen at the document rather than holding a direct
      // reference, since its instance may not exist yet at construction time.
      document.addEventListener('subjectselect:select', this.handleSubjectSelect);
      document.addEventListener('subjectselect:reupload', this.handleSubjectReupload);
      document.addEventListener('subjectselect:dismiss', this.handleSubjectDismiss);

      // The product this page instance is for never changes without a reload, so this runs
      // once, here, rather than on every open() — same reasoning as loadAgeBands()'s own
      // per-product cache.
      this.applyAudienceLock();
    }

    destroy() {
      if (this.isOpen) {
        // No confirmation on teardown: a section reload is not the parent's decision, and a
        // dialog they did not ask for cannot save work that is going away regardless.
        this.close(false, { confirmPending: false });
      }

      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleKeydown);

      if (this.uploadButton) {
        this.uploadButton.removeEventListener('click', this.handleUploadClick);
      }

      if (this.fileInput) {
        this.fileInput.removeEventListener('change', this.handleFileChange);
      }

      if (this.previewRemoveButton) {
        this.previewRemoveButton.removeEventListener('click', this.handlePreviewRemoveClick);
      }

      if (this.cameraTrigger) {
        this.cameraTrigger.removeEventListener('click', this.handleCameraTriggerClick);
      }

      if (this.cameraCaptureButton) {
        this.cameraCaptureButton.removeEventListener('click', this.handleCameraCaptureClick);
      }

      if (this.cameraCancelButton) {
        this.cameraCancelButton.removeEventListener('click', this.handleCameraCancelClick);
      }

      if (this.cameraFallbackInput) {
        this.cameraFallbackInput.removeEventListener('change', this.handleCameraFallbackChange);
      }

      if (this.cameraFallbackTrigger) {
        this.cameraFallbackTrigger.removeEventListener('click', this.handleCameraFallbackTriggerClick);
      }

      if (this.guideStartButton) {
        this.guideStartButton.removeEventListener('click', this.handleGuideStartClick);
      }

      if (this.guideUploadButton) {
        this.guideUploadButton.removeEventListener('click', this.handleGuideUploadClick);
      }

      this.guideBackButtons.forEach((button) => {
        button.removeEventListener('click', this.handleGuideBackClick);
      });

      if (this.cameraBackButton) {
        this.cameraBackButton.removeEventListener('click', this.handleGuideBackClick);
      }

      if (this.keepSaveButton) {
        this.keepSaveButton.removeEventListener('click', this.handleKeepSaveClick);
      }

      if (this.keepRetakeButton) {
        this.keepRetakeButton.removeEventListener('click', this.handleKeepRetakeClick);
      }

      if (this.cameraSkipButton) {
        this.cameraSkipButton.removeEventListener('click', this.handleCameraSkipClick);
      }

      if (this.cameraFlipButton) {
        this.cameraFlipButton.removeEventListener('click', this.handleCameraFlipClick);
      }

      if (this.cameraTorchButton) {
        this.cameraTorchButton.removeEventListener('click', this.handleCameraTorchClick);
      }

      if (this.reviewSaveButton) {
        this.reviewSaveButton.removeEventListener('click', this.handleReviewSaveClick);
      }

      if (this.reviewDiscardButton) {
        this.reviewDiscardButton.removeEventListener('click', this.handleReviewDiscardClick);
      }

      if (this.reviewList) {
        this.reviewList.removeEventListener('click', this.handleReviewRetakeClick);
      }

      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('beforeunload', this.handleBeforeUnload);

      if (this.cameraDesktopQuery) {
        this.cameraDesktopQuery.removeEventListener('change', this.updateCameraAvailability);
        this.cameraDesktopQuery.removeEventListener('change', this.updateHandoffAvailability);
      }

      this.stopHandoff();
      this.closeGuide({ restoreFocus: false });
      this.closeCamera();

      if (this.nameInput) {
        this.nameInput.removeEventListener('input', this.handleValidationInput);
        this.nameInput.removeEventListener('input', this.handleNameInput);
        this.nameInput.removeEventListener('blur', this.handleNameBlur);
      }

      if (this.ageSelect) {
        this.ageSelect.removeEventListener('change', this.handleValidationInput);
        this.ageSelect.removeEventListener('change', this.handleAgeSelectManualChange);
      }

      if (this.birthDateInput) {
        this.birthDateInput.removeEventListener('change', this.handleValidationInput);
        this.birthDateInput.removeEventListener('change', this.applyBirthDateAgeHint);
      }

      if (this.consentCheckbox) {
        this.consentCheckbox.removeEventListener('change', this.handleValidationInput);
      }

      if (this.submitButton) {
        this.submitButton.removeEventListener('click', this.handleSubmitClick);
      }

      if (this.form) {
        this.form.removeEventListener('submit', this.handleFormSubmit);
      }

      document.removeEventListener('subjectselect:select', this.handleSubjectSelect);
      document.removeEventListener('subjectselect:reupload', this.handleSubjectReupload);
      document.removeEventListener('subjectselect:dismiss', this.handleSubjectDismiss);

      this.extraSlots.forEach((extraSlot) => extraSlot.destroy());

      this.clearPreviewObjectUrl();
      this.clearSubjectHintObjectUrl();
    }

    handleDocumentClick(event) {
      const trigger = event.target.closest(TRIGGER_SELECTOR);

      if (trigger) {
        /**
         * `preventDefault()` FIRST, WITH NO WAY PAST IT.
         *
         * This used to be reachable only after `shouldBypassProductTrigger`, which returned
         * early — BEFORE this line — whenever the URL carried `?edit`. The CTA is a real
         * `type="submit"` button inside the product form (`sections/product-hero.liquid:289`),
         * so skipping `preventDefault()` submitted the form natively: the product entered the
         * cart with no photo, no name, no age and no personalization record. An order placed
         * that way has nothing to generate a book from.
         *
         * Removed 2026-09-15. The edit flow it was written for moved into
         * `cart-edit-modal.js`, and a grep of the whole repository found nothing that builds
         * a `?edit=` URL — the only reader was `product-hero.js:7`. So the sole remaining way
         * to reach the bypass was typing `?edit` into the address bar, and its only possible
         * outcome was the defect above. Even the flow it served was broken: the product form
         * carries zero `properties[...]` inputs, so re-adding a line through it would have
         * stripped the personalization it was meant to preserve.
         *
         * DO NOT reintroduce a conditional before this line. If an edit flow is ever needed
         * on this page again, it has to carry the personalization properties with it, which
         * is a different change from letting the button submit.
         */
        event.preventDefault();

        if (this.isTriggerDisabled(trigger)) {
          return;
        }

        this.open(trigger);
        return;
      }

      const genderOption = event.target.closest(GENDER_SELECTOR);

      if (genderOption && this.modal.contains(genderOption)) {
        event.preventDefault();

        if (this.isSubmitting) {
          return;
        }

        this.selectGender(genderOption);
        return;
      }

      const swatchOption = event.target.closest(SWATCH_SELECTOR);

      if (swatchOption && this.modal.contains(swatchOption)) {
        event.preventDefault();

        if (this.isSubmitting) {
          return;
        }

        this.selectSwatch(swatchOption);
        return;
      }

      if (!this.isOpen) {
        return;
      }

      const closeTarget = event.target.closest(CLOSE_SELECTOR);

      if (closeTarget && this.modal.contains(closeTarget)) {
        event.preventDefault();

        if (this.isSubmitting) {
          return;
        }

        this.close();
      }
    }

    handleKeydown(event) {
      if (!this.isOpen) {
        return;
      }

      // The camera view sits above the dialog and owns Escape/Tab while it is open —
      // Escape here must close the camera, not the whole modal underneath it. Inside the
      // guided flow it closes the whole flow: leaving a bare camera behind, with the
      // step counter gone and no way back to the intro, is not a state worth having.
      if (this.cameraOpen) {
        if (event.key === 'Escape') {
          event.preventDefault();

          if (this.guideStage) {
            this.closeGuide();
          } else {
            this.closeCamera();
          }
        } else if (event.key === 'Tab') {
          this.trapCameraFocus(event);
        }

        return;
      }

      // The guided intro and "keep this photo?" panels sit in the same layer the camera
      // does, and own Escape/Tab on the same terms while either is showing.
      if (this.guide && !this.guide.hidden) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeGuide();
        } else if (event.key === 'Tab') {
          this.trapFocusWithin(this.guide, event);
        }

        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key === 'Tab') {
        this.trapFocus(event);
      }
    }

    /**
     * The one visible dropzone opens the FIRST FREE slot. Slot order is decided here and
     * nowhere else: with three inputs and one affordance, a second place that picks a slot
     * would be free to disagree with this one, and the customer would watch a photo land in
     * a tile they did not point at.
     *
     * Slot 1 first, by construction — so a customer who has supplied nothing still fills
     * the required photo, and the optional slots cannot be reached before it. That is the
     * rule the old `updateExtraPhotosVisibility()` enforced by hiding a whole section; it is
     * now a consequence of the order, not a second mechanism.
     */
    handleUploadClick(event) {
      event.preventDefault();

      if (this.isSubmitting) {
        return;
      }

      const target = this.firstFreeFileInput();

      if (target) {
        target.click();
      }
    }

    /** The file input of the first slot holding no file, or null when all three are full. */
    firstFreeFileInput() {
      if (this.fileInput && !this.getSelectedFile()) {
        return this.fileInput;
      }

      for (const extraSlot of this.extraSlots) {
        if (extraSlot.fileInput && !extraSlot.getFile()) {
          return extraSlot.fileInput;
        }
      }

      return null;
    }

    handleFileChange() {
      if (this.isSubmitting) {
        return;
      }

      const file = this.fileInput.files && this.fileInput.files[0];

      // Bump the token and clear any prior verdict for every change, even a
      // gate rejection below — a stale precheck for a superseded file must
      // never surface once the customer has moved on to a different one.
      this.filePrecheckToken += 1;
      const token = this.filePrecheckToken;
      this.photoPrecheckRejected = false;
      this.setPhotoCheckingState(false);
      this.setPhotoMessage('');
      this.closeSubjectChooser();

      if (!file) {
        this.clearPreview();
        this.refreshPhotoCount();
        this.refreshUploadAffordance();
        return;
      }

      if (isHeicFile(file)) {
        this.convertHeicAndProcess(file, token);
        return;
      }

      this.processSelectedPhotoFile(file);
    }

    /**
     * TASK TL18 item 2. Converts a HEIC/HEIF file to JPEG before it ever reaches
     * processSelectedPhotoFile() — a raw HEIC blob cannot be previewed via
     * URL.createObjectURL()+<img> in any browser this theme supports, so conversion cannot
     * be deferred to submit time the way normalizeUploadOrientation() is. Checks `token`
     * against `this.filePrecheckToken` after the (async) conversion, same discipline as
     * runPhotoPrecheck() — a slower conversion for a file the customer has since replaced
     * or removed must never clobber what is on screen by the time it resolves.
     */
    convertHeicAndProcess(file, token) {
      this.setPhotoCheckingState(true);

      convertHeicFileToJpeg(file, this.loadHeicConverterModule.bind(this)).then((converted) => {
        if (token !== this.filePrecheckToken) {
          return;
        }

        this.setPhotoCheckingState(false);

        if (!converted) {
          this.fileInput.value = '';
          this.setFileName('');
          this.clearPreview();
          this.setFieldError('photo', true);
          this.setMessage(PHOTO_TYPE_MESSAGE, true);
          this.refreshPhotoCount();
          this.refreshUploadAffordance();
          return;
        }

        try {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(converted);
          this.fileInput.files = dataTransfer.files;
        } catch (error) {
          console.warn('[product-photo-upload-modal] could not attach converted HEIC file', {
            name: error?.name || null
          });
          this.fileInput.value = '';
          this.setFileName('');
          this.clearPreview();
          this.setFieldError('photo', true);
          this.setMessage(PHOTO_TYPE_MESSAGE, true);
          this.refreshPhotoCount();
          this.refreshUploadAffordance();
          return;
        }

        this.processSelectedPhotoFile(converted);
      });
    }

    processSelectedPhotoFile(file) {
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        this.fileInput.value = '';
        this.setFileName('');
        this.clearPreview();
        this.setFieldError('photo', true);
        this.setMessage(PHOTO_TYPE_MESSAGE, true);
        this.refreshPhotoCount();
        this.refreshUploadAffordance();
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        this.fileInput.value = '';
        this.setFileName('');
        this.clearPreview();
        this.setFieldError('photo', true);
        this.setMessage(PHOTO_SIZE_MESSAGE, true);
        this.refreshPhotoCount();
        this.refreshUploadAffordance();
        return;
      }

      this.runPhotoPrecheck(file, this.filePrecheckToken);

      this.setFileName(file.name);
      this.setPreview(file);
      this.setFieldError('photo', false);
      this.refreshValidationMessage();
      // TASK TL18 item 5. No longer reached via a bubbled 'change' hitting a modal-wide
      // delegated listener — see refreshPhotoCount()'s own docblock for why that delegation
      // was removed. Called explicitly here so a newly accepted photo still updates "N of 3".
      this.refreshPhotoCount();
      this.refreshUploadAffordance();
    }

    /**
     * Replaces `updateExtraPhotosVisibility()`, which hid a section of the page that no
     * longer exists. Keeping the old name for a function that now means something else is
     * the drift this project keeps paying for, so the name moved with the meaning.
     *
     * What it means now: the single dropzone is offered exactly while a free slot exists.
     * It reads the inputs themselves — the same ones `firstFreeFileInput()` and the submit
     * path read — so there is no second tally of how full the row is.
     */
    refreshUploadAffordance() {
      if (!this.uploadButton) {
        return;
      }

      this.uploadButton.hidden = this.firstFreeFileInput() === null;
    }

    handlePreviewRemoveClick(event) {
      event.preventDefault();

      if (this.isSubmitting) {
        return;
      }

      if (this.fileInput) {
        this.fileInput.value = '';
      }

      this.filePrecheckToken += 1;
      this.photoPrecheckRejected = false;
      this.setPhotoCheckingState(false);
      this.setPhotoMessage('');
      this.closeSubjectChooser();

      this.setFileName('');
      this.clearPreview();
      this.setFieldError('photo', false);
      this.refreshValidationMessage();
      // DEF-65: slots 2/3 are independent, non-blocking extras (see
      // e78fb39, "accept two optional extra photos beside the required
      // one") — removing photo 1 must only clear photo 1. refreshPhotoCount()
      // re-reads every slot's own input, so "N of 3" reflects 2/3 untouched.
      this.refreshPhotoCount();
      this.refreshUploadAffordance();

      if (this.uploadButton) {
        this.uploadButton.focus({ preventScroll: true });
      }
    }

    handleFormSubmit(event) {
      event.preventDefault();
      this.submitPersonalization();
    }

    handleSubmitClick(event) {
      event.preventDefault();
      this.submitPersonalization();
    }

    handleValidationInput() {
      this.refreshValidationMessage();
    }

    // TASK TL6. Only ever CLEARS an already-shown name error as the customer types a fix — it
    // never shows a new one, so a parent is never scolded about the character rule mid-keystroke
    // on a name they have not finished typing. Runs unconditionally (not gated on the shared
    // footer message's visibility, unlike handleValidationInput above) because a name error can
    // be showing from handleNameBlur alone, with the footer message never having appeared.
    handleNameInput() {
      if (!this.nameErrorEl || this.nameErrorEl.hidden || !this.nameInput) {
        return;
      }

      const value = this.nameInput.value.trim();

      if (value === '' || window.ChildNameRule.isValidChildName(value)) {
        this.clearNameError();
      }
    }

    // TASK TL6, extended by TASK TL18 item 6. The one place a name error is first SHOWN
    // outside of submit. A field the customer has never touched (rawValue === '') is
    // "missing," not "invalid characters" — validate()'s own required-field message owns
    // that case, so blur on a genuinely untouched field says nothing here, matching how
    // hasInvalidBirthDate treats "empty" and "filled in wrong" as different states with
    // different messages. A name of only spaces is different again: the customer DID type
    // something, so leaving blur silent here (as it was before TL18) reads as the field
    // quietly swallowing the keystrokes — checked against the RAW value, not the trimmed
    // one, so this still says nothing for a field nobody has touched at all.
    handleNameBlur() {
      if (!this.nameInput) {
        return;
      }

      const rawValue = this.nameInput.value;

      if (rawValue === '') {
        return;
      }

      const value = rawValue.trim();

      if (value === '') {
        // alert: false — a blur-triggered message must not interrupt; see showNameError().
        this.showNameError(NAME_REQUIRED_MESSAGE, { alert: false });
        return;
      }

      if (window.ChildNameRule.isValidChildName(value)) {
        this.clearNameError();
        return;
      }

      // alert: false — a blur-triggered message must not interrupt; see showNameError().
      this.showNameError(window.ChildNameRule.MESSAGE, { alert: false });
    }

    // Fires only on a real 'change' dispatched by the browser — never on this file's own
    // `this.ageSelect.value = ...` assignments (a plain property write, which never dispatches
    // an event). That is the entire mechanism behind "the birth date never moves the select
    // again" — see the flag's own comment on the constructor.
    handleAgeSelectManualChange() {
      this.ageSelectTouchedByUser = true;
    }

    open(trigger) {
      if (this.isOpen) {
        return;
      }

      // TASK TL4: the minimum-time clock starts when the modal becomes fillable, not at page
      // load — the modal can sit unopened on a product page for minutes.
      BotTrap.markOpened(this.form, Date.now());

      this.lastTrigger = trigger;
      this.isOpen = true;
      this.modal.hidden = false;
      this.loadAgeBands();
      this.refreshPhotoCount();
      this.modal.setAttribute('aria-hidden', 'false');
      this.modal.classList.add('is-open');
      this.lockBodyScroll();
      // Only actually starts anything when the viewport is already >=1024 — see the method.
      // Below that, opening the modal makes zero handoff-related network requests.
      this.updateHandoffAvailability();

      window.requestAnimationFrame(() => {
        const focusTarget = this.closeButton || this.getFocusableElements()[0] || this.dialog;

        if (focusTarget) {
          focusTarget.focus({ preventScroll: true });
        }
      });
    }

    /**
     * Fills the age select from the service, which derives the list from the same ACTIVE
     * templates that resolution reads.
     *
     * BIASED TOWARDS REFUSING, and here is the trade-off stated rather than implied. If this
     * request fails the select stays disabled and says so, instead of falling back to a
     * guessed band. Offering a band the registry does not have costs the customer the whole
     * form — name, photo, upload — and then fails at the last step with "something went
     * wrong"; refusing up front costs one message. The failure mode that would make a
     * fallback valuable (the service being unreachable) is also the one where `create` could
     * not succeed anyway, so a fallback would buy nothing and lose that.
     *
     * Cached per product id: reopening the modal must not re-request.
     */
    async loadAgeBands() {
      if (!this.ageSelect || this.ageBandsLoaded) {
        return;
      }

      const productContext = document.querySelector(PRODUCT_CONTEXT_SELECTOR);
      const productId = productContext?.dataset.productId || productContext?.dataset.productGid;

      if (!productId) {
        this.setAgeSelectState('unavailable', 'Age options are unavailable on this page.');
        return;
      }

      this.setAgeSelectState('loading', null);

      let payload;
      try {
        payload = await getJson(
          AGE_BANDS_URL_PREFIX + encodeURIComponent(productId) + AGE_BANDS_URL_SUFFIX
        );
      } catch (error) {
        console.warn('[product-photo-upload-modal] Age bands request failed', {
          message: error?.message || null,
          code: error?.code || null,
          requestId: error?.requestId || null,
          status: typeof error?.status === 'number' ? error.status : null
        });
        this.setAgeSelectState('unavailable', 'Could not load age options. Please refresh the page.');
        return;
      }

      // `registry_unavailable` is the service saying it does not know, which is not the same
      // as "this product has no bands" and must not read as one.
      if (payload?.status === 'registry_unavailable') {
        this.setAgeSelectState('unavailable', 'Age options are temporarily unavailable. Please try again shortly.');
        return;
      }

      const bands = Array.isArray(payload?.ageBands) ? payload.ageBands : [];
      this.ageBands = bands;

      if (bands.length === 0) {
        this.setAgeSelectState('unavailable', 'This book is not available to personalize right now.');
        return;
      }

      this.ageSelect.innerHTML = '';

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Tap to select';
      this.ageSelect.appendChild(placeholder);

      for (const band of bands) {
        const option = document.createElement('option');
        option.value = band;
        option.textContent = band;
        this.ageSelect.appendChild(option);
      }

      // One band means there is nothing to choose. Preselecting it removes a required click
      // whose only possible answer is already known.
      if (bands.length === 1) {
        this.ageSelect.value = bands[0];
      }

      this.ageBandsLoaded = true;
      this.setAgeSelectState('ready', null);

      // In case the customer already filled in a birth date before the registry answered.
      this.applyBirthDateAgeHint();
    }

    /**
     * Fills "N of 3 uploaded" from the file inputs themselves, not from a counter this
     * class keeps in step by hand. A separate tally is a second statement of how many
     * photos exist, free to disagree with the inputs the submit path actually reads
     * (`getSelectedFile()` for slot 1, `extraSlot.getFile()` for the rest) — and the
     * disagreement would show the customer a number that is not what gets uploaded.
     *
     * TASK TL18 item 4. this.photoPrecheckRejected excludes slot 1 even though its file is
     * still attached (see the client precheck's reject branch and the PhotoRejectedError
     * branch in handlePersonalizationError() — both leave the file in place on purpose, so
     * the customer can reconsider it, but neither leaves it counted as a usable upload).
     * Extras have no equivalent flag: a rejected extra is still non-blocking by design (see
     * e78fb39) and was never gated out of the count before this task either.
     *
     * TASK TL18 item 5. Every caller now invokes this directly (handleFileChange,
     * processSelectedPhotoFile, handlePreviewRemoveClick, handleSubjectReupload here, and
     * ExtraPhotoSlot's own processSelectedPhotoFile/handleRemoveClick via the
     * refreshPhotoCount callback passed into its constructor) — see this method's own git
     * history for the pair of `this.modal.addEventListener('change'|'click',
     * this.refreshPhotoCount)` listeners this replaced. That delegation caught every bubbled
     * click in the ENTIRE modal, not just a remove button's, so typing a single character
     * into the child's name field — or any other click anywhere in the form — re-assigned
     * this.photoCountEl.textContent on every keystroke. Measured 2026-11-03: that
     * textContent mutation, sitting above the fold in `.product-photo-modal__scroll`
     * (overflow-y: auto, no overflow-anchor: none), was what Chrome's default scroll
     * anchoring reacted to by resetting the container's scrollTop to 0 — reproduced with a
     * MutationObserver + scrollTop poll showing the childList mutation on photoCountEl is
     * the only DOM change in the frame immediately before the reset, with no JS anywhere
     * calling .scrollTo()/.scrollTop= on that container. This is item 5's "modal scrolls
     * back to the top by itself while filling the form" bug.
     */
    refreshPhotoCount() {
      if (!this.photoCountEl) {
        this.refreshUploadAffordance();
        return;
      }

      const slotCount = 1 + this.extraSlots.length;
      let filled = this.getSelectedFile() && !this.photoPrecheckRejected ? 1 : 0;

      for (const extraSlot of this.extraSlots) {
        if (extraSlot.getFile()) {
          filled += 1;
        }
      }

      this.photoCountEl.textContent = filled + ' of ' + slotCount + ' uploaded';

      // Same events, same reading of the same inputs: the counter and the dropzone can
      // never describe a different number of photos.
      this.refreshUploadAffordance();
    }

    setAgeSelectState(state, message) {
      if (!this.ageSelect) {
        return;
      }

      this.ageSelect.disabled = state !== 'ready';

      if (state === 'loading') {
        const placeholder = this.ageSelect.querySelector('option[value=""]');
        if (placeholder) {
          placeholder.textContent = 'Loading…';
        }
      }

      if (message) {
        this.setMessage(message, true);
      }
    }

    /**
     * Two independent jobs, both reached from the same birth-date `change` event:
     *
     * 1. A HINT, not an autocorrection: preselects the age band that matches the entered date
     *    of birth, but only while the registry has actually answered (this.ageBandsLoaded) and
     *    only while the customer has not already picked a band themselves
     *    (this.ageSelectTouchedByUser). It never sends anything to the backend on its own —
     *    the select's `.value` is still the one and only thing submitPersonalization() reads.
     *    Never erases a value once one exists, matched or not.
     *
     * 2. TASK TL18 item 7. A SOFT warning under the age field when the entered birth date's
     *    computed age falls outside whichever band is CURRENTLY selected — regardless of
     *    ageSelectTouchedByUser, because this is about what is selected right now, not about
     *    who selected it. Mirrors the backend's own non-blocking signal
     *    (checkAgeBandConsistency / age-band-consistency.ts, task #67: "the FACT is recorded
     *    ... the order proceeds unchanged. Neither field is auto-corrected; the order is not
     *    rejected"): a parent may be buying ahead of a birthday, so this never blocks a submit
     *    and never corrects either field — compare hasInvalidBirthDate in validate(), the
     *    actual block, which only fires for the backend's own hard bound (today/future, or an
     *    age under 1 or over 17), never for an age merely outside the selected band.
     */
    applyBirthDateAgeHint() {
      if (!this.ageSelect || !this.birthDateInput) {
        return;
      }

      // Still loading, or the registry came back empty/unavailable — both states are owned
      // entirely by setAgeSelectState and must not be second-guessed here.
      if (!this.ageBandsLoaded || !this.ageBands.length) {
        return;
      }

      const rawBirthDate = this.birthDateInput.value;

      if (!rawBirthDate) {
        this.setAgeHint('');
        return;
      }

      const birthDate = new Date(rawBirthDate);

      // An implausible date — including the hard age-under-1/over-17 bound — is the existing
      // birth-date validation's problem, not this one's: leave both the select and the hint
      // alone and let BIRTH_DATE_INVALID_MESSAGE own it. Showing "you can still order it as a
      // gift" under a date validate() is about to refuse outright would read as a contradiction.
      if (
        !isChildBirthDatePlausible(birthDate, new Date()) ||
        !isChildBirthDatePrintableAge(birthDate, new Date())
      ) {
        this.setAgeHint('');
        return;
      }

      const age = computeChildAgeAtDate(birthDate, new Date());

      if (!this.ageSelectTouchedByUser) {
        const matchedBand = this.ageBands.find((band) => {
          const bounds = parseAgeBandBounds(band);
          return bounds !== null && age >= bounds.min && age <= bounds.max;
        });

        if (matchedBand && this.ageSelect.value !== matchedBand) {
          this.ageSelect.value = matchedBand;
        }
      }

      const selectedBounds = parseAgeBandBounds(this.ageSelect.value);

      if (!selectedBounds || (age >= selectedBounds.min && age <= selectedBounds.max)) {
        this.setAgeHint('');
        return;
      }

      // Exact wording and dash characters from this task's brief: an en dash in the band
      // range, an em dash before the reassurance — never auto-corrected, never a block.
      this.setAgeHint(
        `This book is written for ages ${selectedBounds.min}–${selectedBounds.max}. ` +
          `Your child is ${age} — you can still order it as a gift for later.`
      );
    }

    setAgeHint(message) {
      if (!this.ageHintEl) {
        return;
      }

      this.ageHintEl.textContent = message || '';
      this.ageHintEl.hidden = !message;
    }

    close(restoreFocus = true, options = {}) {
      if (!this.isOpen) {
        return;
      }

      // The review gate means nothing a parent has shot has reached a slot yet, so closing
      // here throws away real work — and the overlay behind the dialog is easy to hit with a
      // thumb. This is the one place in the flow where a confirmation earns its
      // intrusiveness: it can only fire when there is something to lose, and what it
      // protects is several minutes of a child being asked to hold still.
      //
      // A native confirm rather than a designed dialog, deliberately: it is a stopgap that
      // cannot itself be missed or mis-styled, and it adds no new surface to a flow that has
      // just grown a lot of it. Worth replacing with something quieter once there is a
      // pattern for it in this modal.
      if (options.confirmPending !== false && this.guidePendingPhotos.some(Boolean)) {
        if (!window.confirm(GUIDE_DISCARD_CONFIRM)) {
          return;
        }
      }

      // Must never leave a getUserMedia stream running behind a closed modal — that is
      // the camera indicator staying lit for no visible reason. See closeCamera().
      // closeGuide() covers the guided flow's own teardown (sampler, blob: URL, stages)
      // and calls closeCamera() itself; the second call is idempotent and stands as the
      // guarantee for the single-shot camera, which never enters the guided flow at all.
      this.closeGuide({ restoreFocus: false });
      this.closeCamera();

      // The poll must never outlive the modal — see stopHandoff(). Before isOpen flips,
      // though it does not matter here: stopHandoff() does not read isOpen itself.
      this.stopHandoff();

      this.isOpen = false;
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      this.modal.hidden = true;
      this.unlockBodyScroll();

      // TASK TL17. "Reuse on retry" is scoped to one open/close session — see
      // ensurePersonalization(). A reopen is a fresh session and must create fresh, not
      // resume submitting against a personalization from a visit the customer has left.
      this.activePersonalizationId = null;
      this.activePersonalizationFingerprint = null;

      if (restoreFocus && this.lastTrigger && document.contains(this.lastTrigger)) {
        this.lastTrigger.focus({ preventScroll: true });
      }
    }

    isTriggerDisabled(trigger) {
      return Boolean(
        trigger.disabled ||
        trigger.getAttribute('aria-disabled') === 'true' ||
        trigger.classList.contains('is-disabled')
      );
    }


    selectGender(selectedOption) {
      const options = this.modal.querySelectorAll(GENDER_SELECTOR);

      options.forEach((option) => {
        const isSelected = option === selectedOption;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      this.refreshValidationMessage();
    }

    selectSwatch(selectedOption) {
      const group = selectedOption.dataset.productPhotoModalSwatch;
      const options = this.modal.querySelectorAll(`[data-product-photo-modal-swatch="${group}"]`);

      options.forEach((option) => {
        const isSelected = option === selectedOption;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      this.refreshValidationMessage();
    }

    getSelectedSwatch(group) {
      return this.modal.querySelector(`[data-product-photo-modal-swatch="${group}"].is-selected`);
    }

    setFileName(name) {
      if (!this.fileName) {
        return;
      }

      this.fileName.textContent = name ? `Selected photo: ${name}` : '';
      this.fileName.hidden = true;
    }

    setPreview(file) {
      if (!this.preview) {
        return;
      }

      this.clearPreviewObjectUrl();
      this.preview.hidden = false;
      this.preview.classList.remove('is-empty', 'is-file');
      this.preview.classList.add('is-loading');
      this.preview.setAttribute('aria-label', `Selected photo: ${file.name}`);

      if (this.uploadRow) {
        this.uploadRow.classList.add('has-photo');
      }

      if (this.previewRemoveButton) {
        this.previewRemoveButton.hidden = false;
      }

      if (this.previewStatus) {
        this.previewStatus.textContent = '';
      }

      if (file.type.startsWith('image/') && this.previewImage) {
        const previewUrl = URL.createObjectURL(file);
        this.previewObjectUrl = previewUrl;
        this.previewImage.hidden = false;
        this.previewImage.src = previewUrl;
        this.previewImage.alt = `Uploaded child photo preview: ${file.name}`;

        this.previewImage.onload = () => {
          this.preview.classList.remove('is-loading');

          if (this.previewObjectUrl === previewUrl) {
            URL.revokeObjectURL(previewUrl);
            this.previewObjectUrl = null;
          }
        };

        this.previewImage.onerror = () => {
          if (this.fileInput) {
            this.fileInput.value = '';
          }

          this.setFileName('');
          this.clearPreview();
          this.setFieldError('photo', true);
          this.setMessage('We could not preview this photo. Please choose a different JPG, PNG, or WebP image.', true);
        };

        return;
      }
    }

    clearPreview() {
      this.clearPreviewObjectUrl();

      if (this.preview) {
        this.preview.hidden = true;
        this.preview.classList.add('is-empty');
        this.preview.classList.remove('is-file', 'is-loading');
        this.preview.removeAttribute('aria-label');
      }

      if (this.uploadRow) {
        this.uploadRow.classList.remove('has-photo');
      }

      if (this.previewImage) {
        this.previewImage.hidden = true;
        this.previewImage.removeAttribute('src');
        this.previewImage.alt = 'Uploaded child photo preview';
        this.previewImage.onload = null;
        this.previewImage.onerror = null;
      }

      if (this.previewStatus) {
        this.previewStatus.textContent = '';
      }

      if (this.previewRemoveButton) {
        this.previewRemoveButton.hidden = true;
      }
    }

    clearPreviewObjectUrl() {
      if (this.previewObjectUrl) {
        URL.revokeObjectURL(this.previewObjectUrl);
        this.previewObjectUrl = null;
      }
    }

    setMessage(message, isError) {
      if (!this.message) {
        return;
      }

      if (this.messageText) {
        this.messageText.textContent = message;
      } else {
        this.message.textContent = message;
      }

      this.message.hidden = !message;
      this.message.classList.toggle('is-error', Boolean(isError));
      this.modal.classList.toggle('has-validation-error', Boolean(message && isError));
    }

    setPhotoMessage(message) {
      if (!this.photoMessage) {
        return;
      }

      this.photoMessage.textContent = message || '';
      this.photoMessage.hidden = !message;
    }

    setPhotoCheckingState(isChecking) {
      if (this.uploadButton) {
        this.uploadButton.setAttribute('aria-busy', isChecking ? 'true' : 'false');
      }

      if (this.checkingIndicator) {
        this.checkingIndicator.hidden = !isChecking;
      }
    }

    /**
     * 2026-09-29, "the product page locks the gender a book is written for": storefront half of
     * a guard the service already enforces (400 GENDER_NOT_FOR_THIS_BOOK on `create` since
     * edc332e — see getCustomerErrorMessage()'s 'BAD_REQUEST' case below for the other half,
     * corrected by TASK TL17 to actually show the service's message instead of a generic one).
     * Reads the
     * `gender:for-girls` / `gender:for-boys` product tags via the JSON island
     * snippets/product-photo-upload-modal.liquid writes — the exact tags
     * sections/collection_all.liquid's own filter already reads, not a new
     * `audience-*` vocabulary (task correction, 2026-09-29). Any other value, or no tag at all,
     * is "any" and this leaves the field untouched, exactly as it already behaved.
     *
     * Preselects the matching button via the existing selectGender() (so validate()'s
     * getSelectedGender() sees it as a real, valid choice, same as a customer's own click) and
     * disables both buttons — `this.genderLocked` is read by setSubmittingState() so a later
     * submit failure can never re-enable a control this method locked.
     */
    applyAudienceLock() {
      const audience = this.readAudience();
      const genderTag = audience && typeof audience.gender === 'string' ? audience.gender : '';

      let targetLabel = null;
      if (genderTag === 'for-girls') targetLabel = 'girl';
      if (genderTag === 'for-boys') targetLabel = 'boy';

      if (!targetLabel) {
        return;
      }

      const genderButtons = Array.from(this.modal.querySelectorAll(GENDER_SELECTOR));
      const targetButton = genderButtons.find(
        (button) => button.textContent.trim().toLowerCase() === targetLabel
      );

      if (!targetButton) {
        return;
      }

      this.selectGender(targetButton);
      genderButtons.forEach((button) => {
        button.disabled = true;
      });
      this.genderLocked = true;

      if (this.genderNoteEl) {
        this.genderNoteEl.textContent = `This book is written for a ${targetLabel}.`;
        this.genderNoteEl.hidden = false;
      }
    }

    readAudience() {
      const el = this.modal.querySelector(AUDIENCE_SELECTOR);

      if (!el) {
        return null;
      }

      try {
        return JSON.parse(el.textContent);
      } catch {
        return null;
      }
    }

    readPrecheckAssetUrls() {
      const el = this.modal.querySelector(PRECHECK_ASSETS_SELECTOR);

      if (!el) {
        return null;
      }

      let parsed;

      try {
        parsed = JSON.parse(el.textContent);
      } catch {
        return null;
      }

      // The three binaries come from Settings -> Files via `file_url`, which
      // renders an empty string when the file is not there. An empty URL does
      // not fail loudly: tfjs fetches the page itself, gets HTML back, and the
      // detector ends as { verdict: 'unknown', detectorPath: 'none' } - the
      // same shape as a genuine "could not tell", with nothing naming the
      // cause. So refuse the whole set here, by name, and let the caller take
      // its existing no-detector path instead of a ten-second timeout.
      const missing = PRECHECK_ASSET_KEYS.filter((key) => {
        return typeof parsed[key] !== 'string' || parsed[key].length === 0;
      });

      if (missing.length > 0) {
        console.error('[photo-precheck-assets] Missing asset URL, detector disabled', { missing });
        return null;
      }

      return parsed;
    }

    loadPrecheckModule() {
      if (!this.precheckModulePromise) {
        if (!this.precheckAssetUrls || !this.precheckAssetUrls.module) {
          return Promise.resolve(null);
        }

        // Plain <script> injection, not dynamic import(): Shopify's asset
        // pipeline rewrites import(variable) into a bare require() call,
        // which throws in a browser. Confirmed by diffing the served file
        // against source.
        this.precheckModulePromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = this.precheckAssetUrls.module;
          script.async = false;
          script.onload = () => resolve();
          script.onerror = () => reject(new Error('Failed to load ' + script.src));
          document.head.appendChild(script);
        })
          .then(() => window.PhotoPrecheck || null)
          .catch(() => null);
      }

      return this.precheckModulePromise;
    }

    readHeicConverterAssetUrl() {
      const el = this.modal.querySelector(HEIC_CONVERTER_ASSETS_SELECTOR);

      if (!el) {
        return null;
      }

      let parsed;

      try {
        parsed = JSON.parse(el.textContent);
      } catch {
        return null;
      }

      return typeof parsed.module === 'string' && parsed.module.length > 0 ? parsed.module : null;
    }

    // TASK TL18 item 2. Same plain-<script>-injection, memoize-the-promise shape as
    // loadPrecheckModule() above, and for the same reason (Shopify's asset pipeline breaks a
    // dynamic import()). Shared with every ExtraPhotoSlot via the bound reference passed into
    // its constructor, so a HEIC file picked in any slot loads the ~1.3 MB library once.
    loadHeicConverterModule() {
      if (!this.heicConverterModulePromise) {
        if (!this.heicConverterAssetUrl) {
          return Promise.resolve(null);
        }

        this.heicConverterModulePromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = this.heicConverterAssetUrl;
          script.async = false;
          script.onload = () => resolve();
          script.onerror = () => reject(new Error('Failed to load ' + script.src));
          document.head.appendChild(script);
        })
          .then(() => window.heic2any || null)
          .catch(() => null);
      }

      return this.heicConverterModulePromise;
    }

    runPhotoPrecheck(file, token) {
      this.setPhotoCheckingState(true);

      this.loadPrecheckModule()
        .then((precheck) => {
          if (!precheck) {
            return { verdict: 'unknown', detectorPath: 'none' };
          }

          return precheck.run(file, this.precheckAssetUrls);
        })
        .catch(() => ({ verdict: 'unknown', detectorPath: 'none' }))
        .then((verdict) => {
          // A later file selection (or removal) bumped the token — this
          // verdict is for a file the customer has already moved on from.
          if (token !== this.filePrecheckToken) {
            return;
          }

          this.setPhotoCheckingState(false);
          recordPhotoPrecheckTelemetry(verdict);

          if (verdict.verdict === 'choose_subject') {
            // A question, not a failure: no field error, no rejection flag —
            // the photo is fine, the customer just needs to point at their
            // child. this.filePrecheckToken is captured in the chooser's
            // context and re-checked on the response events below, so a
            // later file pick invalidates it exactly like a reject would.
            this.openSubjectChooser(verdict, token);
            return;
          }

          if (verdict.verdict === 'reject') {
            this.photoPrecheckRejected = true;
            this.setFieldError('photo', true);
            this.setPhotoMessage(getPhotoReasonMessage(verdict.reason) || GENERIC_ERROR_MESSAGE);
            // TASK TL18 item 4. The file and preview stay in place — the customer can still
            // see and reconsider it, same as the PhotoRejectedError branch in
            // handlePersonalizationError() — but it must stop counting as a filled slot the
            // instant it is flagged, not just grow an error border. refreshPhotoCount()
            // reads this.photoPrecheckRejected, so "N of 3" drops by one here too.
            this.refreshPhotoCount();
          }
          // 'pass' and 'unknown' show nothing — never a green check, never
          // approval. The client verdict is untrusted and closes nothing.
        });
    }

    openSubjectChooser(verdict, token) {
      const chooser = window.subjectSelectModalInstance;
      const file = this.getSelectedFile();

      if (!chooser || !file || !Array.isArray(verdict.candidates) || !verdict.candidates.length) {
        return;
      }

      this.clearSubjectHintObjectUrl();
      this.subjectHintObjectUrl = URL.createObjectURL(file);

      chooser.open({
        childName: this.nameInput ? this.nameInput.value.trim() : '',
        photo: {
          url: this.subjectHintObjectUrl,
          width: verdict.imageWidth,
          height: verdict.imageHeight
        },
        candidates: verdict.candidates,
        context: { token: token }
      });
    }

    closeSubjectChooser() {
      this.selectedSubjectHint = null;
      this.clearSubjectHintObjectUrl();

      if (window.subjectSelectModalInstance) {
        window.subjectSelectModalInstance.close({ restoreFocus: false });
      }
    }

    handleSubjectSelect(event) {
      const detail = event.detail || {};

      // Same discipline as runPhotoPrecheck: a response tied to a superseded
      // file must never write into current state.
      if (!detail.context || detail.context.token !== this.filePrecheckToken) {
        return;
      }

      // The chooser guarantees exactly one of these is set. `source`
      // distinguishes the two gestures so their success rates can be measured
      // separately; the backend ignores unknown keys today.
      if (detail.candidate) {
        this.selectedSubjectHint = { box: detail.candidate, source: 'client_precheck' };
      } else if (detail.markerPoint) {
        this.selectedSubjectHint = {
          box: subjectHintBoxFromPoint(detail.markerPoint),
          source: 'client_marker'
        };
      } else {
        this.selectedSubjectHint = null;
      }

      if (this.selectedSubjectHint) {
        recordSubjectHintTelemetry(this.selectedSubjectHint.source);
      }

      this.clearSubjectHintObjectUrl();
    }

    handleSubjectReupload(event) {
      const detail = event.detail || {};

      if (!detail.context || detail.context.token !== this.filePrecheckToken) {
        return;
      }

      this.selectedSubjectHint = null;
      this.clearSubjectHintObjectUrl();

      if (this.fileInput) {
        this.fileInput.value = '';
      }

      this.filePrecheckToken += 1;
      this.photoPrecheckRejected = false;
      this.setPhotoCheckingState(false);
      this.setPhotoMessage('');
      this.setFileName('');
      this.clearPreview();
      this.setFieldError('photo', false);
      this.refreshValidationMessage();
      // DEF-65: see handlePreviewRemoveClick — extras 2/3 are independent of slot 1.
      this.refreshPhotoCount();
      this.refreshUploadAffordance();

      if (this.fileInput) {
        this.fileInput.click();
      }
    }

    handleSubjectDismiss(event) {
      const detail = event.detail || {};

      if (!detail.context || detail.context.token !== this.filePrecheckToken) {
        return;
      }

      // Explicit, not incidental: dismiss must never leave a stored choice
      // behind, but it must leave the file, preview and any (absent) error
      // state exactly as they were — this is not a reupload.
      this.selectedSubjectHint = null;
      this.clearSubjectHintObjectUrl();
    }

    clearSubjectHintObjectUrl() {
      if (this.subjectHintObjectUrl) {
        URL.revokeObjectURL(this.subjectHintObjectUrl);
        this.subjectHintObjectUrl = null;
      }
    }

    buildSubjectHintProperty() {
      if (!this.selectedSubjectHint || !this.selectedSubjectHint.box) {
        return null;
      }

      const source = this.selectedSubjectHint.source;
      const box = {
        x: roundTo4(this.selectedSubjectHint.box.x),
        y: roundTo4(this.selectedSubjectHint.box.y),
        width: roundTo4(this.selectedSubjectHint.box.width),
        height: roundTo4(this.selectedSubjectHint.box.height)
      };

      // The backend requires four finite numbers in [0,1] with width > 0 and
      // height > 0, and x + width / y + height no greater than 1.001. A box
      // failing any of those is rejected outright and the hint disappears
      // without a trace — so send nothing rather than something unusable, and
      // check it here, after rounding, where the values are final.
      const withinContract = ['x', 'y', 'width', 'height'].every((key) => {
        return Number.isFinite(box[key]) && box[key] >= 0 && box[key] <= 1;
      }) &&
        box.width > 0 &&
        box.height > 0 &&
        box.x + box.width <= 1.001 &&
        box.y + box.height <= 1.001;

      if (!withinContract) {
        console.warn('[product-photo-upload-modal] Dropped an out-of-contract subject hint', { source });
        return null;
      }

      return JSON.stringify({ v: 1, box, source });
    }

    refreshValidationMessage() {
      if (this.message && !this.message.hidden) {
        this.validate({ focusFirst: false });
      }
    }

    validate({ focusFirst = false, isSubmit = false } = {}) {
      const missingFields = [];
      const hasName = Boolean(this.nameInput && this.nameInput.value.trim());
      const hasAge = Boolean(this.ageSelect && this.ageSelect.value);
      const hasGender = Boolean(this.getSelectedGender());
      const hasHairColor = Boolean(this.getSelectedSwatch('hair'));
      const hasEyeColor = Boolean(this.getSelectedSwatch('eye'));
      const file = this.getSelectedFile();
      const hasPhoto = Boolean(file);
      const hasConsent = Boolean(this.consentCheckbox && this.consentCheckbox.checked);
      const rawBirthDate = this.birthDateInput ? this.birthDateInput.value : '';
      const hasBirthDate = Boolean(rawBirthDate);

      if (!hasName) missingFields.push('name');
      if (!hasBirthDate) missingFields.push('birthDate');
      if (!hasAge) missingFields.push('age');
      if (!hasGender) missingFields.push('gender');
      if (!hasHairColor) missingFields.push('hairColor');
      if (!hasEyeColor) missingFields.push('eyeColor');
      if (!hasPhoto) missingFields.push('photo');
      if (!hasConsent) missingFields.push('consent');

      const hasInvalidPhotoType = Boolean(file && !ALLOWED_FILE_TYPES.includes(file.type));
      const hasInvalidPhotoSize = Boolean(file && file.size > MAX_FILE_SIZE);

      // Date of birth is REQUIRED as of 2026-09-21, reversing the original decision that it
      // was optional. The reason is not a UX preference: the printed age is computed from this
      // date and from nothing else (backend DECISION-2026-09-18), and the Shiv handoff refuses
      // with SHIV_HANDOFF_NO_CHILD_AGE when that age is absent. An optional field here fed a
      // mandatory precondition there, so a customer who skipped it bought a book that could
      // never be printed — see the backend finding
      // `2026-09-21-an-optional-field-feeds-a-mandatory-precondition.md`.
      //
      // "Empty" and "filled in wrong" still need different handling, and both now block: empty
      // joins missingFields above and shows the generic complete-your-details message, while a
      // present-but-implausible date keeps its own message and its own early return, because
      // telling someone "this field is missing" when they have visibly filled it in is worse
      // than saying nothing.
      //
      // TASK TL18 item 7. Also checks isChildBirthDatePrintableAge() — the backend refuses a
      // birth date of today or one giving an age over 17 even though isChildBirthDatePlausible()
      // alone would accept it (see that function's own docblock). Both bounds route to the
      // same BIRTH_DATE_INVALID_MESSAGE below; this is "show the same rule on the client
      // before submit", not a second, differently-worded refusal.
      const hasInvalidBirthDate = Boolean(
        rawBirthDate && (
          !isChildBirthDatePlausible(new Date(rawBirthDate), new Date()) ||
          !isChildBirthDatePrintableAge(new Date(rawBirthDate), new Date())
        )
      );

      ['name', 'age', 'gender', 'hairColor', 'eyeColor', 'photo', 'consent'].forEach((fieldName) => {
        const hasPhotoError = fieldName === 'photo' &&
          (hasInvalidPhotoType || hasInvalidPhotoSize || this.photoPrecheckRejected);
        this.setFieldError(fieldName, missingFields.includes(fieldName) || hasPhotoError);
      });
      this.setFieldError(
        'birthDate',
        missingFields.includes('birthDate') || hasInvalidBirthDate
      );

      if (hasInvalidPhotoType) {
        this.setMessage(PHOTO_TYPE_MESSAGE, true);

        if (focusFirst) {
          this.focusField('photo');
        }

        return false;
      }

      if (hasInvalidPhotoSize) {
        this.setMessage(PHOTO_SIZE_MESSAGE, true);

        if (focusFirst) {
          this.focusField('photo');
        }

        return false;
      }

      // TASK TL18 item 4. this.photoPrecheckRejected was already folded into hasPhotoError
      // above for the field border, but that alone never stopped a submit — missingFields
      // does not know about it (the file is still attached, so hasPhoto is true), and this
      // method fell straight through to the `!missingFields.length` success case below. A
      // photo the client precheck OR the server's own photo-check gate (PhotoRejectedError
      // in handlePersonalizationError()) has flagged must block here explicitly.
      if (this.photoPrecheckRejected) {
        const rejectionMessage = (this.photoMessage && this.photoMessage.textContent) || GENERIC_ERROR_MESSAGE;
        this.setMessage(rejectionMessage, true);

        if (focusFirst) {
          this.focusField('photo');
        }

        return false;
      }

      // TASK TL6. Checked only at submit (isSubmit), and deliberately not folded into the
      // missingFields/setFieldError loop above: "empty" already reaches missingFields via
      // !hasName, so this only ever fires for a NON-empty name that fails the character rule —
      // same "empty vs filled in wrong" split as hasInvalidBirthDate above. Blur and live typing
      // manage their own display via handleNameBlur()/handleNameInput(), so this is the one
      // place the rule can actually BLOCK a submit; it does not duplicate their display outside
      // of a submit attempt, which is what keeps role="alert" off every keystroke.
      const rawName = this.nameInput ? this.nameInput.value.trim() : '';
      const hasInvalidName = Boolean(rawName && !window.ChildNameRule.isValidChildName(rawName));

      // TASK TL18 item 6. A name of only spaces trims to '', so !hasName above already
      // pushes it onto missingFields — but missingFields' own message is the generic
      // COMPLETE_DETAILS_MESSAGE (or PHOTO_REQUIRED_MESSAGE/CONSENT_REQUIRED_MESSAGE when
      // name is not the only gap), never one that names the name field itself. A raw,
      // untyped-in field is "missing" with no message of its own either — same split as
      // hasInvalidName above, distinguished by the RAW (untrimmed) value here too, so this
      // never fires for a field nobody has touched.
      const hasBlankName = Boolean(
        this.nameInput && this.nameInput.value !== '' && !this.nameInput.value.trim()
      );

      if (isSubmit && hasBlankName) {
        this.setMessage('', false);
        this.showNameError(NAME_REQUIRED_MESSAGE, { alert: true });

        if (focusFirst) {
          this.focusField('name');
        }

        return false;
      }

      if (isSubmit && hasInvalidName) {
        this.setMessage('', false);
        this.showNameError(window.ChildNameRule.MESSAGE, { alert: true });

        if (focusFirst) {
          this.focusField('name');
        }

        return false;
      }

      if (hasInvalidBirthDate) {
        this.setMessage(BIRTH_DATE_INVALID_MESSAGE, true);

        if (focusFirst) {
          this.focusField('birthDate');
        }

        return false;
      }

      if (!missingFields.length) {
        this.setMessage('', false);
        return true;
      }

      let message = COMPLETE_DETAILS_MESSAGE;

      if (missingFields.length === 1 && missingFields[0] === 'photo') {
        message = PHOTO_REQUIRED_MESSAGE;
      } else if (missingFields.length === 1 && missingFields[0] === 'consent') {
        message = CONSENT_REQUIRED_MESSAGE;
      }

      this.setMessage(message, true);

      if (focusFirst) {
        this.focusField(missingFields[0]);
      }

      return false;
    }

    /**
     * TASK TL4. Adds the two bot signals to a service URL as QUERY parameters.
     *
     * Not body fields: the service's global ValidationPipe runs `forbidNonWhitelisted: true`,
     * and a probe against the real CreatePersonalizationDto answered "property hp should not
     * exist" — body fields would 400 every request. These routes bind query parameters
     * individually (`@Query('slot')`), never as a whole-query DTO, so extra ones are ignored
     * until task S75 reads them.
     */
    withTrapSignals(url) {
      return BotTrap.appendSignals(url, this.botTrapVerdict || { hp: '', elapsed: 0 });
    }

    async submitPersonalization() {
      if (this.isSubmitting) {
        return;
      }

      // TASK TL4, reworked 2026-10-13. Only the TRAP can stop a submission here. No
      // `enforceTime`, so a fast submit is sent with its elapsed time attached rather than
      // discarded — a time rule that guesses wrong on this path loses a real customer's photo
      // while showing them the cart, which is a worse outcome than letting a bot through.
      //
      // Checked before validate(), so a trapped bot gets the success path rather than a field
      // error that would tell it which rule it broke. On a trip nothing is sent and the browser
      // goes to /cart — exactly where a real submission ends — and nothing is added to the cart.
      this.botTrapVerdict = BotTrap.evaluate(this.form, Date.now());

      if (this.botTrapVerdict.ignore) {
        window.location.href = '/cart';
        return;
      }

      if (!this.validate({ focusFirst: true, isSubmit: true })) {
        return;
      }

      const file = this.getSelectedFile();

      try {
        const input = this.getPersonalizationInput();

        this.setSubmittingState(true);
        this.setMessage('', false);

        const fingerprint = this.fingerprintPersonalizationInput(input);
        let { personalizationId, reused } = await this.ensurePersonalization(input, fingerprint);

        const uploadFile = await normalizeUploadOrientation(file);

        let confirmation;

        try {
          confirmation = await this.submitPrimaryPhoto(personalizationId, uploadFile, { reused });
        } catch (error) {
          if (!(error instanceof PersonalizationReuseRefusedError)) {
            throw error;
          }

          // TASK TL17. The reused id was refused by the step that just tried it (e.g. it went
          // terminal between attempts) — the server's own word for it, not a client guess
          // (see isPersonalizationReuseRefusal()). Drop it and retry ONCE from a fresh
          // create(), rather than surface this as a customer-facing failure; a second
          // refusal, on a FRESH id, is a real failure and is not caught again here.
          this.activePersonalizationId = null;
          this.activePersonalizationFingerprint = null;
          personalizationId = await this.createFreshPersonalization(input, fingerprint);
          confirmation = await this.submitPrimaryPhoto(personalizationId, uploadFile, { reused: false });
        }

        // The server gate, read the way the server actually speaks.
        //
        // MEASURED 2026-09-16, both sides. On rejection the backend answers HTTP 200
        // with `rejection: { reason, message }` and `sourceImageKeySaved: false`, and
        // `status` carries the status the personalization ALREADY had — see
        // `mapUploadRejectionToResponse` and the docblock on `ConfirmUploadResponseDto`
        // in the service. It never sends the literal 'rejected'.
        //
        // The previous condition compared `confirmation.status` to 'rejected', so it was
        // never true, and the fields it then read (`confirmation.reason`, `.message`)
        // live inside `rejection`, not at the top level. The gate existed on both sides
        // and touched on neither: a rejected photo reached checkout, and the customer
        // paid for a book the pipeline could not make (order 1009).
        //
        // Fail-open is still the policy for the UNKNOWN case — a network error must
        // never be invented into a rejection, and one thrown out of submitPrimaryPhoto above
        // already bypasses this. But a rejection the server stated explicitly stops the
        // flow: this throw unwinds before the cart add is reached.
        if (confirmation && confirmation.rejection) {
          throw new PhotoRejectedError(
            confirmation.rejection.reason,
            confirmation.rejection.message
          );
        }

        // Photos 2 and 3, if the customer supplied either. Deliberately awaited here, not
        // fired in parallel with the block above: photo 1's paid pre-checkout check must
        // finish and pass first, unaffected by whatever happens with the extras. A customer
        // who supplied only photo 1 never reaches this call — extraSlots.getFile() is null
        // for both, the loop below has nothing to iterate, and no request is made.
        await this.uploadExtraPhotos(personalizationId);

        await this.addPersonalizedProductToCart({
          variantId: input.selectedVariantId,
          personalizationId,
          childName: input.childName,
          ageRange: input.ageRange,
          gender: input.gender,
          hairColor: input.hairColor,
          eyeColor: input.eyeColor,
          subjectHint: this.buildSubjectHintProperty()
        });

        window.location.href = '/cart';
      } catch (error) {
        this.handlePersonalizationError(error);
        this.setSubmittingState(false);
      }
    }

    /**
     * TASK TL17. The production incident this task exists for: every retry inside the SAME
     * modal session called createPersonalization() again, even when create had already
     * succeeded and only a LATER step (upload or confirm) failed — 37 personalizations
     * created in 20 minutes for one real submit attempt (see this task's brief). Reused only
     * while the fields createPersonalization() reads are unchanged since the last successful
     * call (`fingerprint`) — a changed field (a corrected birth date, a different age band)
     * means the record create() would produce now disagrees with what is on screen, so a
     * fresh one is made rather than silently submitting stale data under an old id.
     */
    async ensurePersonalization(input, fingerprint) {
      if (this.activePersonalizationId && this.activePersonalizationFingerprint === fingerprint) {
        return { personalizationId: this.activePersonalizationId, reused: true };
      }

      return { personalizationId: await this.createFreshPersonalization(input, fingerprint), reused: false };
    }

    async createFreshPersonalization(input, fingerprint) {
      const personalization = await this.createPersonalization(input);
      const personalizationId = personalization?.personalizationId;

      if (!personalizationId) {
        throw new PersonalizationFlowError(GENERIC_ERROR_MESSAGE, 'MISSING_PERSONALIZATION_ID');
      }

      // TASK TL9 (S118) — kept locally the moment it is known, before any upload call is
      // made, so the very first upload/photo request already has it available.
      storeGuestAccessToken(personalizationId, personalization?.guestAccessToken);

      this.activePersonalizationId = personalizationId;
      this.activePersonalizationFingerprint = fingerprint;

      return personalizationId;
    }

    // Only the fields createPersonalization() actually sends in its body — see that method.
    // Nothing else (which photo was picked, which optional slots are filled) changes what the
    // service's record for this personalization says, so none of it belongs in this
    // comparison.
    fingerprintPersonalizationInput(input) {
      return JSON.stringify({
        productId: input.productId,
        variantId: input.variantId,
        childName: input.childName,
        childBirthDate: input.childBirthDate,
        parentalConsent: input.parentalConsent,
        ageRange: input.ageRange,
        gender: input.gender,
        hairColor: input.hairColor,
        eyeColor: input.eyeColor
      });
    }

    /**
     * TASK TL17. Uploads and confirms slot 1's photo against a single personalizationId —
     * either just created or reused from an earlier attempt in this session. Isolated from
     * submitPersonalization() so the exact same sequence can run a second time against a
     * FRESH id, without duplicating the upload/confirm logic, if the server refuses a reused
     * one.
     *
     * Throws PersonalizationReuseRefusedError — caught only by the caller — when `reused` is
     * true and the failure means the id itself is no longer usable (see
     * isPersonalizationReuseRefusal()); never when `reused` is false, since there is nothing
     * to fall back to from a FRESH id. Every other failure is thrown as whatever
     * handlePersonalizationError() expects: PhotoUploadFailedError for a 400/413 the upload
     * step itself produced, or the raw error (NetworkError, a 5xx/429 ApiRequestError, or a
     * confirm-step ApiRequestError) for anything handlePersonalizationError() already knows
     * how to read.
     */
    async submitPrimaryPhoto(personalizationId, uploadFile, { reused }) {
      let upload;

      try {
        upload = await this.uploadPhotoToService({ personalizationId, file: uploadFile });
      } catch (error) {
        if (reused && isPersonalizationReuseRefusal(error)) {
          throw new PersonalizationReuseRefusedError(error);
        }

        if (isServerSideError(error)) {
          throw error;
        }

        throw new PhotoUploadFailedError(getPhotoUploadFailureMessage(error), error);
      }

      const storageKey = upload?.storageKey;

      if (!storageKey) {
        throw new PersonalizationFlowError(UPLOAD_FAILED_MESSAGE, 'MISSING_UPLOAD_DATA');
      }

      try {
        return await this.confirmUpload({ personalizationId, storageKey });
      } catch (error) {
        if (reused && isPersonalizationReuseRefusal(error)) {
          throw new PersonalizationReuseRefusedError(error);
        }

        throw error;
      }
    }

    // Uploads whichever of slots 2/3 the customer filled, one at a time, each independently
    // caught: a failure here must never block checkout (R3) — the customer can still buy with
    // photo 1 alone. So each slot's failure is shown against that slot and swallowed, not
    // rethrown, and the next slot (and the cart-add after this) still runs. Nothing here
    // touches this.photoPrecheckRejected, this.setFieldError('photo', …), or any other state
    // slot 1 or validate() reads.
    async uploadExtraPhotos(personalizationId) {
      for (const extraSlot of this.extraSlots) {
        const file = extraSlot.getFile();

        if (!file) {
          continue;
        }

        try {
          extraSlot.setChecking(true);

          const uploadFile = await normalizeUploadOrientation(file);
          const upload = await this.uploadPhotoToService({ personalizationId, file: uploadFile, slot: extraSlot.slot });
          const storageKey = upload?.storageKey;

          if (!storageKey) {
            throw new PersonalizationFlowError(UPLOAD_FAILED_MESSAGE, 'MISSING_UPLOAD_DATA');
          }

          await this.confirmUpload({ personalizationId, storageKey, slot: extraSlot.slot });
          extraSlot.setChecking(false);
        } catch (error) {
          extraSlot.setChecking(false);

          // TASK TL17. Whatever failed, the server does not have this slot's photo — reset()
          // (not just a message) clears its file and preview so refreshPhotoCount(), which
          // reads the inputs themselves, stops counting it as uploaded. reset() also clears
          // the message it is about to set, so setMessage() runs after it, not before.
          const message = isServerSideError(error)
            ? SERVER_ERROR_MESSAGE
            : error instanceof ApiRequestError
              ? getPhotoUploadFailureMessage(error)
              : this.getCustomerErrorMessage(error);

          extraSlot.reset();
          extraSlot.setMessage(message);
          this.refreshPhotoCount();

          console.warn('[product-photo-upload-modal] Extra photo upload failed, continuing without it', {
            slot: extraSlot.slot,
            code: error?.code || null,
            status: typeof error?.status === 'number' ? error.status : null
          });
        }
      }
    }

    getPersonalizationInput() {
      const productContext = document.querySelector(PRODUCT_CONTEXT_SELECTOR);
      const productForm = document.querySelector(PRODUCT_FORM_SELECTOR);
      const variantInput = productForm?.querySelector(VARIANT_INPUT_SELECTOR) ||
        document.querySelector(VARIANT_INPUT_SELECTOR);
      const selectedGender = this.getSelectedGender();
      const selectedHairColor = this.getSelectedSwatch('hair');
      const selectedEyeColor = this.getSelectedSwatch('eye');
      const productId = productContext?.dataset.productGid || toShopifyGid('Product', productContext?.dataset.productId);
      const selectedVariantId = variantInput?.value;
      const shopDomain = window.Shopify?.shop || productContext?.dataset.shopDomain || window.location.hostname;

      if (!productId || !selectedVariantId) {
        throw new PersonalizationFlowError('Please refresh the page and try again.', 'MISSING_PRODUCT_CONTEXT');
      }

      // A missing checkbox is not "unconsented" (false) and not "consented" (true) — it is a
      // broken modal, and neither boolean is honest about that. validate() already refuses to
      // reach this point while the checkbox exists and is unchecked, but this function must
      // not simply trust that a caller ran validate() first: it derives parentalConsent itself,
      // from the actual element, so the two can never drift apart.
      if (!this.consentCheckbox) {
        throw new PersonalizationFlowError(COMPLETE_DETAILS_MESSAGE, 'MISSING_CONSENT_ELEMENT');
      }

      return {
        shopDomain,
        productId,
        variantId: toShopifyGid('ProductVariant', selectedVariantId),
        selectedVariantId,
        childName: this.nameInput.value.trim(),
        // null when the (optional) field is empty — never `''`, which the DTO rejects same as
        // a malformed date. validate() has already confirmed a present value is plausible.
        childBirthDate: isoDateToChildBirthDate(this.birthDateInput ? this.birthDateInput.value : ''),
        // The actual checkbox state, strictly boolean — the backend's @Equals(true) rejects
        // anything else, including a truthy non-boolean.
        parentalConsent: this.consentCheckbox.checked === true,
        ageRange: this.ageSelect.value,
        gender: selectedGender.textContent.trim().toLowerCase(),
        hairColor: {
          hex: selectedHairColor.dataset.colorHex,
          name: selectedHairColor.dataset.colorName
        },
        eyeColor: {
          hex: selectedEyeColor.dataset.colorHex,
          name: selectedEyeColor.dataset.colorName
        }
      };
    }

    getSelectedFile() {
      return this.fileInput && this.fileInput.files ? this.fileInput.files[0] : null;
    }

    createPersonalization(input) {
      const body = {
        shopDomain: input.shopDomain,
        productId: input.productId,
        variantId: input.variantId,
        childName: input.childName,
        parentalConsent: input.parentalConsent,
        ageRange: input.ageRange,
        gender: input.gender,
        hairColor: input.hairColor,
        eyeColor: input.eyeColor
      };

      // Omitted entirely rather than sent as null/''. The DTO's @IsOptional only skips
      // validation when the KEY is absent — a present-but-empty value still hits
      // @IsValidChildBirthDate and is rejected, same as a malformed date would be.
      if (input.childBirthDate) {
        body.childBirthDate = input.childBirthDate;
      }

      return postJson(this.withTrapSignals(CREATE_PERSONALIZATION_URL), body);
    }

    /**
     * Uploads the photo THROUGH the service, not straight to S3.
     *
     * The presigned-PUT flow it replaced could not work: the bucket has no CORS
     * configuration and we have no admin access to that AWS account to add one, so the
     * browser's preflight was refused. The service now takes the bytes itself, which also
     * keeps a presigned write credential out of the browser entirely.
     *
     * `personalizationId` and `contentType` go in the QUERY STRING; the bytes are the BODY.
     * The one content-type string is used for both the header and the query value on
     * purpose — the service's parser matches the header and its magic-byte check compares
     * against the query value, and deriving them from one variable is what keeps them from
     * disagreeing.
     *
     * The response carries `storageKey` in the same shape `upload/sign` returned, so
     * `confirmUpload` below is unchanged.
     *
     * `slot` is the one addition for the multi-photo branch: query string here (this
     * endpoint's body is the raw bytes, so slot cannot travel in the body), and only appended
     * when a caller passes one. Photo 1's own call never passes it, so its request is
     * byte-for-byte what it was before this branch — the service already treats an absent
     * slot as 1 (see photo-slot.ts / REQUIRED_PHOTO_SLOT on the service side), which is the
     * whole reason every caller that predates this feature keeps working untouched.
     *
     * TASK TL9 (S118) — `guestAccessToken` is the other query-string addition, read from
     * local storage by personalizationId (never passed in by a caller — there is exactly one
     * place a token for a given id can come from). Omitted entirely when absent, same as
     * `slot`: harmless and ignored server-side while GUEST_ACCESS_TOKEN_ENFORCEMENT_ENABLED
     * is off, and the only thing a guest can present once it is on.
     */
    async uploadPhotoToService({ personalizationId, file, slot }) {
      const contentType = file.type;

      // personalizationId travels in the PATH and the content type in the
      // Content-Type header. Neither may be a query parameter.
      //
      // Shopify's App Proxy appends shop, path_prefix, timestamp, signature and
      // logged_in_customer_id to every forwarded request, and those five are the
      // request's authentication — they cannot be removed. The service runs a global
      // ValidationPipe with forbidNonWhitelisted, so any route that reads a @Query()
      // DTO refuses the whole request before its handler runs.
      //
      // Measured against production on 2026-09-09: the query-parameter form answered
      // 400 VALIDATION_ERROR with all five App Proxy parameters listed as
      // "should not exist"; the path form answered 201. Service side merged as 1386e26.
      // `slot` is not one of those five — it is a field the service's query DTO now
      // whitelists explicitly (merged as b303a0a) — so it is safe to add here.
      let url = UPLOAD_PHOTO_URL + '/' + encodeURIComponent(personalizationId);

      const queryParams = [];

      if (slot) {
        queryParams.push('slot=' + encodeURIComponent(slot));
      }

      const guestAccessToken = getGuestAccessToken(personalizationId);

      if (guestAccessToken) {
        queryParams.push('guestAccessToken=' + encodeURIComponent(guestAccessToken));
      }

      if (queryParams.length > 0) {
        url += '?' + queryParams.join('&');
      }

      url = this.withTrapSignals(url);

      let response;

      try {
        response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': contentType
          },
          body: file
        });
      } catch (error) {
        throw new NetworkError(error);
      }

      // Read the body on failure BEFORE throwing. The service answers with
      // `{success:false, error:{code, message}, requestId}`, and throwing without reading
      // it discards the only thing that says WHY — which cost a diagnosis round on
      // 2026-09-09, where the console showed only this function's own 'UPLOAD_FAILED' and
      // a null requestId. `parseJsonResponse` already throws `ApiRequestError` carrying the
      // payload and the status, so on a non-ok response we let it do that instead.
      return parseJsonResponse(response);
    }

    // `slot` is appended to the body only when passed — omitted entirely for photo 1, same
    // reasoning as uploadPhotoToService above: an absent slot already means 1 to the service,
    // and the single-photo request must stay exactly what it was before this branch.
    //
    // TASK TL9 (S118) — `guestAccessToken`, same source and same "omit when absent" rule as
    // uploadPhotoToService above.
    confirmUpload({ personalizationId, storageKey, slot }) {
      const body = { personalizationId, storageKey };

      if (slot) {
        body.slot = slot;
      }

      const guestAccessToken = getGuestAccessToken(personalizationId);

      if (guestAccessToken) {
        body.guestAccessToken = guestAccessToken;
      }

      return postJson(this.withTrapSignals(CONFIRM_UPLOAD_URL), body);
    }

    async addPersonalizedProductToCart({ variantId, personalizationId, childName, ageRange, gender, hairColor, eyeColor, subjectHint }) {
      // TASK TL19 — "Checkout order summary shows raw property names." Shopify hides
      // from checkout/order pages any property whose name starts with `_`, same
      // mechanism as `_personalization_id` below. "Child's Name" is kept visible (not
      // read by forever-storybooks-service by key — confirmed read-only investigation,
      // see the TL19 report — so it's free to be a display-only label); Age/Gender were
      // left alone since they already read as plain English. None of these are read by
      // the service: only `_personalization_id` and `_subject_hint` are.
      const properties = {
        _personalization_id: personalizationId,
        "Child's Name": childName,
        Age: ageRange,
        Gender: gender,
        _HairColor: hairColor.name,
        _EyeColor: eyeColor.name
      };

      // Omitted entirely, never null/empty, when no chooser was shown or the
      // customer dismissed it — an absent hint is a defined state on the
      // backend; an empty value is not. Leading underscore hides it from the
      // cart and checkout UI, same as _personalization_id.
      if (subjectHint) {
        properties._subject_hint = subjectHint;
      }

      let response;

      try {
        response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: properties
          })
        });
      } catch (error) {
        throw new NetworkError(error);
      }

      if (!response.ok) {
        throw new PersonalizationFlowError(
          'We could not add this book to your cart. Please try again.',
          'CART_ADD_FAILED',
          response.status
        );
      }

      return response.json();
    }

    handlePersonalizationError(error) {
      if (error instanceof PhotoRejectedError) {
        // Route to the photo control, not the footer — keep the modal open
        // and every other field's value intact so the customer only
        // re-picks the photo. This is a real, expected outcome of the
        // server gate, not a technical failure, so it is not console.warn'd.
        this.photoPrecheckRejected = true;
        this.setFieldError('photo', true);
        this.setPhotoMessage(error.message);
        // TASK TL18 item 4. Same reasoning as the client precheck's reject branch — the
        // file stays in place for the customer to reconsider, but a slot the server itself
        // just refused must stop reading as "uploaded".
        this.refreshPhotoCount();
        return;
      }

      // TASK TL17. The upload request itself was refused — the server never has the bytes,
      // so unlike PhotoRejectedError/precheck above (which leave the file in place so the
      // customer can reconsider it) there is nothing left to reconsider. See
      // rejectCurrentPhoto(). Not console.warn'd, same reasoning as PhotoRejectedError: an
      // expected outcome of client-side validation the customer's own file slipped past
      // (an extension-renamed photo), not a technical failure.
      if (error instanceof PhotoUploadFailedError) {
        this.rejectCurrentPhoto(error.message);
        return;
      }

      // TASK TL6, corrected by TASK TL17 — see the comment on CHILD_NAME_INVALID_CHARACTERS_CODE
      // above for why `error?.code` could never match this and the fix reads `details` instead.
      // Route to the name control, same reasoning as PhotoRejectedError above: a real, expected
      // outcome of the server's own rule (the one window.ChildNameRule mirrors client-side), not
      // a technical failure. Reachable only when a name the client's own check missed still gets
      // refused — e.g. a character this file's regex and the service's regex disagree on, which
      // the agreement table in scripts/verify-child-name.js exists to catch before that can
      // happen.
      if (hasValidationDetail(error, (message) => message.includes(CHILD_NAME_INVALID_CHARACTERS_CODE))) {
        this.showNameError(window.ChildNameRule.MESSAGE, { alert: true });
        this.focusField('name');
        return;
      }

      // TASK TL17. Same mechanism as above, for the one other validator that crafts its own
      // message instead of class-validator's auto-generated text — child-birth-date.validator.ts
      // also names its own field at the start of the message (measured against the service),
      // so the signal is there to read; routed to the client's own existing message for exactly
      // this failure (BIRTH_DATE_INVALID_MESSAGE, used by validate()'s own plausibility check)
      // rather than the server's more technical wording.
      if (hasValidationDetail(error, (message) => message.startsWith('childBirthDate'))) {
        this.setFieldError('birthDate', true);
        this.setMessage(BIRTH_DATE_INVALID_MESSAGE, true);
        this.focusField('birthDate');
        return;
      }

      // Network/5xx/429 is handled below by getCustomerErrorMessage() itself (it checks
      // isServerSideError() right after its own PersonalizationFlowError check) rather than
      // intercepted here — a PersonalizationFlowError can carry a 5xx status too (e.g.
      // CART_ADD_FAILED from a Shopify outage) and must keep ITS OWN message either way,
      // which only getCustomerErrorMessage()'s ordering guarantees.
      const status = typeof error?.status === 'number' ? error.status : null;
      const code = error?.code || null;
      const requestId = error?.requestId || null;

      // `message` carries the server's own explanation — ApiRequestError puts it on the
      // error via `super(apiError?.message)`. Omitting it here is what made every production
      // 400 read as "something went wrong" and cost an ssh round-trip to diagnose.
      console.warn('[product-photo-upload-modal] Personalization flow failed', {
        code,
        requestId,
        status,
        message: error?.message || null
      });

      this.setMessage(this.getCustomerErrorMessage(error), true);
    }

    /**
     * TASK TL17. The server never received usable bytes, so unlike a precheck/confirm
     * rejection there is no file worth leaving in place — clears slot 1 back to the same
     * empty, error-bordered state PHOTO_TYPE_MESSAGE/PHOTO_SIZE_MESSAGE already produce for a
     * client-side rejection (handleFileChange()). The two are visually identical on purpose:
     * the CSS only styles an EMPTY errored preview (`.has-error .preview.is-empty`), not a
     * thumbnail with a border around it, and `refreshPhotoCount()` counts a slot as filled by
     * reading its `<input>`, not a separate tally — clearing the input is what removes this
     * photo from "N of 3 uploaded", per this task's spec, with no second counter to keep in
     * step.
     */
    rejectCurrentPhoto(message) {
      if (this.fileInput) {
        this.fileInput.value = '';
      }

      this.setFileName('');
      this.clearPreview();
      this.setFieldError('photo', true);
      this.setPhotoMessage(message);
      this.refreshPhotoCount();
    }

    getCustomerErrorMessage(error) {
      if (error instanceof PersonalizationFlowError) {
        return error.message || GENERIC_ERROR_MESSAGE;
      }

      if (isServerSideError(error)) {
        return SERVER_ERROR_MESSAGE;
      }

      switch (error?.code) {
        case 'BAD_REQUEST':
          // TASK TL17. Every BadRequestException this service throws on create/upload/confirm
          // carries its own specific, customer-safe message (verified against
          // forever-storybooks-service/src/modules/personalization/personalization.service.ts
          // and personalization.controller.ts — see this task's report for the full list);
          // `code` here is always the generic HTTP-status-mapped value, never a per-case one
          // (see the comment on ApiRequestError.details), so `message` is the only place the
          // real reason lives. This is also what fixes the GENDER_NOT_FOR_THIS_BOOK case this
          // switch used to special-case — that comparison could never match for the same
          // reason CHILD_NAME_INVALID_CHARACTERS_CODE couldn't, and is removed rather than
          // left as dead code. Falls back only if a future throw site omits a message.
          return error.message || CHECK_DETAILS_MESSAGE;
        case 'VALIDATION_ERROR':
          // Every field this service can name here (childName, childBirthDate) is already
          // intercepted in handlePersonalizationError() above before this is reached — by the
          // time a VALIDATION_ERROR gets here, nothing in it could be attributed to a field.
          return CHECK_DETAILS_MESSAGE;
        case 'UNAUTHORIZED':
        case 'FORBIDDEN':
          return 'We could not verify this request. Please refresh and try again.';
        case 'NOT_FOUND':
          return 'We could not find this personalization. Please try again.';
        case 'PAYLOAD_TOO_LARGE':
          return PHOTO_SIZE_MESSAGE;
        default:
          return CHECK_DETAILS_MESSAGE;
      }
    }

    setSubmittingState(isSubmitting) {
      this.isSubmitting = isSubmitting;

      if (this.form) {
        this.form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      }

      [
        this.submitButton,
        this.uploadButton,
        this.previewRemoveButton,
        this.nameInput,
        this.birthDateInput,
        this.consentCheckbox,
        this.ageSelect,
        this.fileInput,
        ...Array.from(this.modal.querySelectorAll(GENDER_SELECTOR)),
        ...Array.from(this.modal.querySelectorAll(SWATCH_SELECTOR))
      ].filter(Boolean).forEach((element) => {
        element.disabled = isSubmitting;
      });

      // applyAudienceLock() disables the gender buttons permanently for a girl/boy book — the
      // loop above just set them back to `isSubmitting` (false once a submit ends), which would
      // silently unlock a field the customer must never be able to change. Re-assert the lock
      // every time, rather than excluding gender from the loop above, so this stays correct even
      // if a future change reorders that list.
      if (this.genderLocked) {
        this.modal.querySelectorAll(GENDER_SELECTOR).forEach((button) => {
          button.disabled = true;
        });
      }

      this.extraSlots.forEach((extraSlot) => extraSlot.setDisabled(isSubmitting));

      if (this.submitButton) {
        this.submitButton.textContent = isSubmitting ? 'Adding...' : this.submitButtonText;
      }
    }

    setFieldError(fieldName, hasError) {
      const field = this.modal.querySelector(`${FIELD_SELECTOR}[data-product-photo-modal-field="${fieldName}"]`);

      if (!field) {
        return;
      }

      field.classList.toggle('has-error', hasError);

      field
        .querySelectorAll('input, select, button, [role="group"]')
        .forEach((element) => {
          element.setAttribute('aria-invalid', hasError ? 'true' : 'false');
        });
    }

    /**
     * TASK TL6. The child-name field's own message, under the input — separate from the shared
     * footer message (this.message/setMessage()), which COMPLETE_DETAILS_MESSAGE and friends
     * use. `alert` controls whether role="alert" is present: true only for the submit-triggered
     * call in validate(), false for handleNameBlur() — the requirement is that this message
     * interrupts on submit and never on a keystroke, and role is the mechanism, so it is added
     * and removed here rather than left on permanently.
     */
    showNameError(message, { alert = false } = {}) {
      this.setFieldError('name', true);

      if (!this.nameErrorEl) {
        return;
      }

      this.nameErrorEl.textContent = message;
      this.nameErrorEl.hidden = false;

      if (alert) {
        this.nameErrorEl.setAttribute('role', 'alert');
      } else {
        this.nameErrorEl.removeAttribute('role');
      }
    }

    clearNameError() {
      this.setFieldError('name', false);

      if (!this.nameErrorEl) {
        return;
      }

      this.nameErrorEl.textContent = '';
      this.nameErrorEl.hidden = true;
      this.nameErrorEl.removeAttribute('role');
    }

    getSelectedGender() {
      return this.modal.querySelector(`${GENDER_SELECTOR}.is-selected`);
    }

    focusField(fieldName) {
      const focusTarget = {
        name: this.nameInput,
        birthDate: this.birthDateInput,
        age: this.ageSelect,
        gender: this.modal.querySelector(GENDER_SELECTOR),
        hairColor: this.modal.querySelector('[data-product-photo-modal-swatch="hair"]'),
        eyeColor: this.modal.querySelector('[data-product-photo-modal-swatch="eye"]'),
        photo: this.uploadButton,
        consent: this.consentCheckbox
      }[fieldName];

      if (focusTarget) {
        // Find the actual scrollable container (.product-photo-modal__scroll)
        const scrollContainer = this.modal.querySelector('.product-photo-modal__scroll');

        if (scrollContainer) {
          // Designer request 2026-10-28: bring the FIRST missing field into view (centred in the
          // scroll area) instead of always jumping to the top. The footer message stays visible
          // on its own (it sits outside the scroll area), so jumping to the top only hid a
          // missing field near the bottom, such as the consent box.
          const fieldEl = focusTarget.closest(FIELD_SELECTOR) || focusTarget;
          const containerRect = scrollContainer.getBoundingClientRect();
          const fieldRect = fieldEl.getBoundingClientRect();
          const targetTop = scrollContainer.scrollTop + (fieldRect.top - containerRect.top)
            - Math.max(0, (scrollContainer.clientHeight - fieldRect.height) / 2);

          scrollContainer.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth'
          });
        }

        // Focus after a short delay to ensure scroll animation completes
        setTimeout(function () {
          focusTarget.focus({ preventScroll: true });
        }, 100);
      }
    }

    trapFocus(event) {
      const focusableElements = this.getFocusableElements();

      if (!focusableElements.length) {
        event.preventDefault();
        this.dialog.focus({ preventScroll: true });
        return;
      }

      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus({ preventScroll: true });
        return;
      }

      if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus({ preventScroll: true });
      }
    }

    getFocusableElements() {
      return Array.from(this.dialog.querySelectorAll(FOCUSABLE_SELECTOR)).filter((element) => {
        return element.tabIndex >= 0 &&
          !element.hidden &&
          !element.closest('[hidden]') &&
          element.getAttribute('aria-hidden') !== 'true';
      });
    }

    trapCameraFocus(event) {
      this.trapFocusWithin(this.camera, event);
    }

    /**
     * The camera layer's Tab trap, generalised so the guided intro/keep panels can share
     * it — they are a sibling layer with exactly the same contract (absolutely positioned
     * over the dialog, own Escape, own Tab cycle). One implementation rather than two that
     * would be free to drift apart on which elements count as focusable.
     */
    trapFocusWithin(container, event) {
      if (!container) {
        return;
      }

      const focusableElements = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter((element) => {
        // closest('[hidden]'), not just element.hidden: the guide layer keeps both of its
        // panels in the DOM and hides the inactive one at the panel, so its buttons are
        // not themselves hidden — without this the Tab cycle would walk into the stage the
        // parent is not on. It tightens the camera layer's own trap for the same reason
        // (the guided header and Skip live behind hidden ancestors outside guided mode).
        return element.tabIndex >= 0 &&
          !element.hidden &&
          !element.closest('[hidden]') &&
          element.getAttribute('aria-hidden') !== 'true';
      });

      if (!focusableElements.length) {
        return;
      }

      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus({ preventScroll: true });
        return;
      }

      if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus({ preventScroll: true });
      }
    }

    /**
     * A desktop/laptop's own camera, when it has one, faces the customer sitting at it — not
     * the child standing in front of them — so the camera card has no useful role there; the
     * QR slot (`.product-photo-modal__qr-slot`, shown by CSS alone at the same breakpoint)
     * plays that role instead. Below 1024 this changes nothing — the camera keeps working
     * exactly as it did.
     *
     * Toggles the real `hidden` attribute, never a CSS-only display swap:
     * getFocusableElements() decides who is in the Tab trap purely from `element.hidden` /
     * `closest('[hidden]')` / `aria-hidden` — it has no idea what `display` computes to. A
     * card hidden by CSS alone would stay in that filter's result, focusable to nothing
     * visible, desyncing the trap's first/last-element bookkeeping. `hidden` is the one
     * signal both the browser's own focus order and this filter already agree on.
     *
     * Also hides the fallback trigger on the way to desktop. With the camera trigger itself
     * hidden, openCamera() can never fire there, so showCameraFallbackTrigger() can't either
     * going forward — this call only matters for the button having ALREADY been showing from
     * a narrower width the customer just resized or rotated past.
     *
     * Deliberately does NOT close an already-open camera view (`this.cameraOpen`) if the
     * window happens to cross 1024 while it's in use — an iPad rotating from portrait to
     * landscape mid-shot is a real case (12.9" landscape is exactly 1024 wide), and tearing
     * down a live stream out from under someone mid-action would be worse than leaving a
     * session that started validly running until they close it themselves.
     */
    updateCameraAvailability() {
      if (!this.cameraTrigger || !this.cameraDesktopQuery) {
        return;
      }

      const isDesktop = this.cameraDesktopQuery.matches;

      // Hiding a focused element blurs it (HTML spec) — if the customer had Tabbed onto
      // this card and then widened the window past 1024 (or a tablet rotated past it) with
      // focus still sitting there, the browser would drop focus to <body>, outside the
      // dialog's own trap entirely (trapFocus() only intercepts the Tab key itself; it
      // never observes a blur caused by something else). Moving focus to the upload card
      // first keeps focus inside the dialog through the transition — falling back to the
      // always-present, never-hidden close button on the off chance the upload card is ALSO
      // hidden at that exact moment (every one of the 3 photo slots already filled).
      if (isDesktop && document.activeElement === this.cameraTrigger) {
        const fallbackFocusTarget = (this.uploadButton && !this.uploadButton.hidden)
          ? this.uploadButton
          : this.closeButton;

        if (fallbackFocusTarget) {
          fallbackFocusTarget.focus({ preventScroll: true });
        }
      }

      this.cameraTrigger.hidden = isDesktop;

      if (isDesktop) {
        this.hideCameraFallbackTrigger();
      }
    }

    readHandoffAssetUrls() {
      const el = this.modal.querySelector(HANDOFF_ASSETS_SELECTOR);

      if (!el) {
        return null;
      }

      let parsed;

      try {
        parsed = JSON.parse(el.textContent);
      } catch {
        return null;
      }

      if (typeof parsed.qrEncoderScript !== 'string' || parsed.qrEncoderScript.length === 0) {
        return null;
      }

      return parsed;
    }

    /**
     * Loads the vendored QR encoder (assets/qrcode.js, assets/qrcode-utf8.js) as plain
     * <script> tags, same reasoning as loadPrecheckModule() above: Shopify's asset pipeline
     * rewrites a variable import() into a bare require() call, which throws in a browser.
     * Two files, loaded in order — qrcode-utf8.js overwrites qrcode.stringToBytes and
     * expects the qrcode global to already exist.
     */
    loadQrEncoderModule() {
      if (!this.qrEncoderModulePromise) {
        if (!this.handoffAssetUrls || !this.handoffAssetUrls.qrEncoderScript) {
          return Promise.resolve(null);
        }

        const loadScript = (src) => new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.async = false;
          script.onload = () => resolve();
          script.onerror = () => reject(new Error('Failed to load ' + src));
          document.head.appendChild(script);
        });

        this.qrEncoderModulePromise = loadScript(this.handoffAssetUrls.qrEncoderScript)
          .then(() => {
            return this.handoffAssetUrls.qrEncoderUtf8Script
              ? loadScript(this.handoffAssetUrls.qrEncoderUtf8Script)
              : null;
          })
          .then(() => window.qrcode || null)
          .catch(() => null);
      }

      return this.qrEncoderModulePromise;
    }

    /**
     * Mirrors updateCameraAvailability()'s gate exactly — the task brief names this
     * explicitly ("правило то же, на котором построено скрытие карточки камеры"). A handoff
     * is active only while BOTH are true — the modal is open, and the viewport is >=1024 —
     * and torn down the instant either stops being true. Below 1024, or while the modal is
     * closed, this method's only possible effect is stopHandoff(): starting a handoff is
     * the one thing that happens exclusively on the >=1024-and-open branch.
     */
    updateHandoffAvailability() {
      if (!this.qrSlot || !this.cameraDesktopQuery) {
        return;
      }

      const isDesktop = this.cameraDesktopQuery.matches;

      if (!this.isOpen || !isDesktop) {
        this.stopHandoff();
        return;
      }

      if (this.handoffToken) {
        return;
      }

      this.startHandoff();
    }

    /**
     * Requests a fresh handoff token and renders the QR/link that answers it. Reached from
     * updateHandoffAvailability() (open + >=1024) and from the "Get a new code" / "Try
     * again" buttons. Never waits for, asks for, or reads a personalizationId — one does
     * not exist yet at this point in the flow (see the comment on HANDOFF_CREATE_URL).
     */
    async startHandoff() {
      if (!this.qrSlot) {
        return;
      }

      // TASK TL4. This runs PROGRAMMATICALLY from updateHandoffAvailability() the moment the
      // modal opens at >=1024px, so it is always under the two-second floor — which since the
      // 2026-10-13 rework needs no special case, because the time rule never refuses on this
      // path anyway. The trap still applies: a filled trap means no handoff token is created.
      const verdict = BotTrap.evaluate(this.form, Date.now());

      if (verdict.ignore) {
        return;
      }

      this.botTrapVerdict = verdict;

      this.handoffRequestToken += 1;
      const requestToken = this.handoffRequestToken;

      this.renderHandoffLoading();

      let payload;

      try {
        payload = await postJson(this.withTrapSignals(HANDOFF_CREATE_URL), {});
      } catch (error) {
        if (requestToken !== this.handoffRequestToken) {
          return;
        }

        console.warn('[product-photo-upload-modal] Handoff token request failed', {
          message: error?.message || null,
          code: error?.code || null,
          status: typeof error?.status === 'number' ? error.status : null
        });
        this.renderHandoffError(HANDOFF_ERROR_MESSAGE);
        return;
      }

      // The modal could have closed, or the viewport could have left >=1024, while this was
      // in flight — a superseded response must never start polling or draw a QR.
      if (requestToken !== this.handoffRequestToken || !this.isOpen || !this.cameraDesktopQuery.matches) {
        return;
      }

      const token = payload?.token;
      const expiresAtMs = payload?.expiresAt ? Date.parse(payload.expiresAt) : NaN;

      if (!token || Number.isNaN(expiresAtMs)) {
        console.warn('[product-photo-upload-modal] Handoff response missing token/expiresAt', { payload });
        this.renderHandoffError(HANDOFF_ERROR_MESSAGE);
        return;
      }

      this.handoffToken = token;
      this.handoffExpiresAtMs = expiresAtMs;
      this.handoffSeenPhotoIds = new Set();

      const qrModule = await this.loadQrEncoderModule();

      if (requestToken !== this.handoffRequestToken) {
        return;
      }

      const phoneUrl = this.buildHandoffPhoneUrl(token);

      if (qrModule) {
        this.renderHandoffQr(qrModule, phoneUrl);
      } else {
        // No encoder, no QR. The link alone is no longer a complete handoff on its own now
        // that a plain click copies rather than opens (see buildHandoffLink()) — showing it
        // by itself here would be a copy control with nothing to explain what it is for.
        // A visible refusal plus a retry is honest about the failure instead.
        this.renderHandoffError(HANDOFF_ERROR_MESSAGE);
      }

      this.scheduleHandoffExpiry(expiresAtMs);
      this.handoffPollTimer = window.setInterval(this.pollHandoffStatus, HANDOFF_POLL_INTERVAL_MS);
    }

    /**
     * The QR/link target is this theme's own phone-facing page — a HUMAN STEP, not a code
     * dependency: it has to exist in Shopify admin at HANDOFF_PAGE_PATH's handle, or this
     * URL 404s (see that constant's comment and this task's run report). `token` is the only
     * thing the phone page needs — it derives its own upload path from the token (see
     * photo-handoff.js), so nothing else travels in this URL. A hand-crafted or reprinted QR
     * therefore cannot carry an attacker-chosen upload target; the token is the whole of it.
     */
    buildHandoffPhoneUrl(token) {
      const params = new URLSearchParams({ token: token });

      return window.location.origin + HANDOFF_PAGE_PATH + '?' + params.toString();
    }

    /**
     * A client-side backstop alongside the server's own alive:false, not a replacement for
     * it: a backgrounded/throttled tab can let a setInterval poll slip past expiresAt
     * unnoticed, and this fires once, exactly at that moment, regardless of whether a poll
     * happens to land nearby. Harmless if the server's own alive:false already handled it
     * first — stopHandoff()/renderHandoffExpired() tolerate being reached twice.
     */
    scheduleHandoffExpiry(expiresAtMs) {
      if (this.handoffExpiryTimer) {
        window.clearTimeout(this.handoffExpiryTimer);
      }

      // setTimeout's delay silently misbehaves past the 32-bit signed int range (~24.8
      // days); this token is short-lived by design, but capping costs nothing and removes
      // the question entirely.
      const delay = Math.min(Math.max(0, expiresAtMs - Date.now()), 2147483647);
      const requestToken = this.handoffRequestToken;

      this.handoffExpiryTimer = window.setTimeout(() => {
        if (requestToken !== this.handoffRequestToken) {
          return;
        }

        this.stopHandoff();
        this.renderHandoffExpired();
      }, delay);
    }

    /**
     * Tears down everything a handoff can have running: the poll interval, the client-side
     * expiry timeout, and the slot's own content — restored to the same empty state the
     * Liquid shipped it in, so :empty hides it again without any CSS needing to know this
     * happened. Idempotent: safe to call when nothing is active. Bumps handoffRequestToken
     * so any in-flight create/poll/import response belonging to what is now a superseded
     * handoff writes into nothing.
     */
    stopHandoff() {
      this.handoffRequestToken += 1;

      if (this.handoffPollTimer) {
        window.clearInterval(this.handoffPollTimer);
        this.handoffPollTimer = null;
      }

      if (this.handoffExpiryTimer) {
        window.clearTimeout(this.handoffExpiryTimer);
        this.handoffExpiryTimer = null;
      }

      this.handoffToken = null;
      this.handoffExpiresAtMs = null;
      this.handoffSeenPhotoIds = new Set();

      if (this.qrSlot) {
        this.qrSlot.innerHTML = '';
        this.qrSlot.setAttribute('aria-hidden', 'true');
      }
    }

    async pollHandoffStatus() {
      if (!this.handoffToken) {
        return;
      }

      const token = this.handoffToken;
      const requestToken = this.handoffRequestToken;

      // Client-side backstop ahead of the round trip below — no reason to ask the server
      // again once local time already says this token is past its own expiresAt.
      if (this.handoffExpiresAtMs && Date.now() >= this.handoffExpiresAtMs) {
        this.stopHandoff();
        this.renderHandoffExpired();
        return;
      }

      let payload;

      try {
        payload = await getJson(HANDOFF_BASE_URL + encodeURIComponent(token));
      } catch (error) {
        // A single failed poll is treated as transient, not fatal — this endpoint does not
        // exist in production yet (see the task's server dependency), so failures here are
        // expected during development and must never tear down a QR the customer may
        // already be scanning over one dropped request.
        console.warn('[product-photo-upload-modal] Handoff status poll failed', {
          message: error?.message || null,
          status: typeof error?.status === 'number' ? error.status : null
        });
        return;
      }

      if (requestToken !== this.handoffRequestToken || token !== this.handoffToken) {
        return;
      }

      if (payload?.alive === false) {
        this.stopHandoff();
        this.renderHandoffExpired();
        return;
      }

      const photos = Array.isArray(payload?.photos) ? payload.photos : [];
      const newPhotos = photos.filter((photo) => {
        return photo?.photoId && !this.handoffSeenPhotoIds.has(photo.photoId);
      });

      if (newPhotos.length === 0) {
        return;
      }

      // ONE PHOTO PER TICK, NOT THE WHOLE BATCH. A phone can fill all three slots before the
      // next poll — most commonly because this tab was backgrounded (throttled setInterval,
      // see scheduleHandoffExpiry()'s comment) while the customer kept uploading from their
      // phone — and every import below is its own signed App Proxy request to the SAME route
      // pattern, handoff/:token/photo/:photoId. AppProxyReplayGuard's nonce is scoped to
      // signature + ROUTE PATTERN, not to :photoId — deliberately, to stop one captured
      // signature reading every photo ever uploaded (see the guard's own docblock and
      // app-proxy-replay-guard-route-scoped.spec.ts's PROOF 3). Shopify signs with one-second
      // resolution, so two imports fired back to back land in the same second and the second
      // one is refused with 401 — reproduced in
      // handoff-photo-batch-replay.integration.spec.ts (service repo). Importing only the
      // earliest-slot photo per tick and leaving the rest for the next one
      // (HANDOFF_POLL_INTERVAL_MS later, well outside the one-second window) fixes the
      // collision without touching the guard. Ascending by slot so a batch that arrives
      // together still lands in the order the customer sent it, not response order, one tick
      // at a time. A photo missing `slot` (an old, undeployed status response) is treated as
      // preferring the required slot, and resolveHandoffImportTarget() then moves it to the
      // next free slot — so an out-of-sync deploy still fills slots in arrival order rather
      // than importing nothing or overwriting slot 1.
      const ordered = newPhotos.slice().sort((a, b) => {
        const slotA = PHOTO_SLOT_NUMBERS.includes(a?.slot) ? a.slot : REQUIRED_PHOTO_SLOT;
        const slotB = PHOTO_SLOT_NUMBERS.includes(b?.slot) ? b.slot : REQUIRED_PHOTO_SLOT;
        return slotA - slotB;
      });

      const [next] = ordered;
      this.handoffSeenPhotoIds.add(next.photoId);
      await this.importHandoffPhoto(next.photoId, next.contentType, next.slot);
    }

    /**
     * The slot the server assigned a photo is a preference, not a guarantee — the server
     * claims free slots against what THIS token has already delivered, blind to a slot the
     * customer filled on the desktop by picking a file directly (never uploaded through this
     * token, so the server cannot see it). Tries the preferred slot first, then the remaining
     * slots in order, and returns whichever is free — the modal itself (owns applyCapturedFile
     * for slot 1) or the matching ExtraPhotoSlot. `null` means every slot already holds a
     * photo; the caller must leave all of them exactly as they are.
     */
    resolveHandoffImportTarget(preferredSlot) {
      const slot = PHOTO_SLOT_NUMBERS.includes(preferredSlot) ? preferredSlot : REQUIRED_PHOTO_SLOT;
      const ordered = [slot, ...PHOTO_SLOT_NUMBERS.filter((candidate) => candidate !== slot)];

      for (const candidate of ordered) {
        if (candidate === REQUIRED_PHOTO_SLOT) {
          if (!this.getSelectedFile()) {
            return this;
          }
          continue;
        }

        const extraSlot = this.extraSlots.find((slotInstance) => slotInstance.slot === candidate);

        if (extraSlot && !extraSlot.getFile()) {
          return extraSlot;
        }
      }

      return null;
    }

    /**
     * Fetches the phone's photo bytes and hands them to the target slot's own
     * applyCapturedFile() — THE integration point this whole feature is built to reuse, not
     * duplicate (see the task brief). From here on, a photo that arrived from a phone is
     * indistinguishable from one picked off disk or captured via the in-modal camera: same
     * DataTransfer assignment, same dispatched 'change', same per-slot handleFileChange()
     * validation and precheck.
     */
    async importHandoffPhoto(photoId, contentType, slot) {
      if (!this.handoffToken) {
        return;
      }

      const target = this.resolveHandoffImportTarget(slot);

      if (!target) {
        // Every local slot already holds a photo — the server has no way to know that (see
        // resolveHandoffImportTarget's docblock), so this is a report, not a bug: leave every
        // slot exactly as it is rather than silently choosing one to overwrite.
        console.warn('[product-photo-upload-modal] Handoff photo arrived with every slot already filled', {
          slot: slot
        });
        // The console is not the customer: their phone reported success, so the desktop must
        // say why the photo did not appear.
        this.setPhotoMessage(HANDOFF_ALL_SLOTS_FULL_MESSAGE);
        return;
      }

      const token = this.handoffToken;
      const url = HANDOFF_BASE_URL + encodeURIComponent(token) + '/photo/' + encodeURIComponent(photoId);

      let blob;

      try {
        const response = await fetch(url, { method: 'GET' });

        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }

        blob = await response.blob();
      } catch (error) {
        console.warn('[product-photo-upload-modal] Could not fetch handoff photo', {
          message: error?.message || null
        });

        if (target === this) {
          this.setPhotoMessage(HANDOFF_ATTACH_FAILED_MESSAGE);
        } else {
          target.setMessage(HANDOFF_ATTACH_FAILED_MESSAGE);
        }

        return;
      }

      if (token !== this.handoffToken) {
        return;
      }

      const type = blob.type || contentType || 'image/jpeg';
      const file = new File([blob], 'phone-photo.jpg', { type: type, lastModified: Date.now() });

      target.applyCapturedFile(file);
    }

    /**
     * Every "put real content in the slot" path funnels through here so none of them can
     * forget the one thing that makes injected content actually reachable: the slot ships
     * aria-hidden="true" in the Liquid (correct while it is genuinely empty — CSS :empty
     * already fully excludes it from layout, Tab order, and the accessibility tree then).
     * The moment it holds a real, visible, interactive link or button, that attribute MUST
     * come off: aria-hidden on an ancestor hides every descendant from the accessibility
     * tree even when the descendant carries no aria-hidden of its own — which would leave a
     * link that is focusable but invisible to assistive tech, exactly the trap
     * getFocusableElements() exists elsewhere in this file to prevent.
     */
    setQrSlotContent(buildFn) {
      if (!this.qrSlot) {
        return;
      }

      this.qrSlot.innerHTML = '';
      this.qrSlot.removeAttribute('aria-hidden');
      buildFn(this.qrSlot);
    }

    renderHandoffLoading() {
      this.setQrSlotContent((slot) => {
        const status = document.createElement('p');
        status.className = 'product-photo-modal__qr-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.textContent = HANDOFF_LOADING_TEXT;
        slot.appendChild(status);
      });
    }

    /**
     * Tries QR type 1 through 40 (this library's own valid range) and keeps the first that
     * fits, rather than guessing a fixed size: the library throws a plain string (not an
     * Error) when the data overflows a given type's capacity, and a handoff URL's length
     * depends on the server's own token format, which this file does not control. Measured
     * against the actual vendored library with a realistic ~85-character URL during this
     * task, not assumed — see the run report.
     */
    buildQrSvg(qrModule, text) {
      for (let typeNumber = 1; typeNumber <= 40; typeNumber += 1) {
        try {
          const qr = qrModule(typeNumber, 'M');
          qr.addData(text);
          qr.make();
          return qr.createSvgTag({ cellSize: 4, margin: 8, scalable: true });
        } catch {
          // Overflowed this size — the next iteration tries a larger one.
        }
      }

      return null;
    }

    /**
     * The QR image itself is marked aria-hidden — it is exactly what the task brief calls
     * "a picture that can't be read off the screen and can't be pressed with a keyboard".
     * The REAL accessible control is the link built alongside it: not aria-hidden, a
     * genuine <a href>, focusable and activatable with Enter or Space. On a computer a
     * plain left click on it copies the URL instead of navigating this device to a page
     * written for a phone — see buildHandoffLink()/handleHandoffLinkClick() for why and
     * for the two gestures (a modifier key, a non-primary button) left alone on purpose.
     */
    renderHandoffQr(qrModule, phoneUrl) {
      const svg = this.buildQrSvg(qrModule, phoneUrl);

      if (!svg) {
        // No QR to show, and the link alone is no longer a complete handoff on its own now
        // that a plain click copies rather than opens — same reasoning as the other call
        // site in startHandoff(). A visible refusal plus a retry, not a bare copy control.
        this.renderHandoffError(HANDOFF_ERROR_MESSAGE);
        return;
      }

      this.setQrSlotContent((slot) => {
        const wrap = document.createElement('div');
        wrap.className = 'product-photo-modal__qr-image';
        wrap.setAttribute('aria-hidden', 'true');
        wrap.innerHTML = svg;
        slot.appendChild(wrap);

        slot.appendChild(this.buildHandoffLink(phoneUrl));
      });
    }

    /**
     * Still a genuine <a href> — focusable, its target announced to assistive tech,
     * copyable by right-click / long-press, and openable for real by a modifier-key or
     * non-primary-button click (handleHandoffLinkClick() leaves those alone). What changes
     * is the plain left click: this device is not the phone the link is written for, and
     * measured behaviour (this task's own run report, 2026-09-24) showed that click
     * actually opening product-photo-handoff on the SAME computer, in state "ready", every
     * word of it false there ("Take a photo" where a file picker opens; "Photo sent! Check
     * your computer screen." read ON the computer). target="_blank"/rel are left in place:
     * they only ever mattered for the click this handler now intercepts, and still apply
     * correctly to the modifier-key/middle-click paths the browser handles on its own.
     */
    buildHandoffLink(phoneUrl) {
      const link = document.createElement('a');
      link.className = 'product-photo-modal__qr-link';
      link.href = phoneUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = HANDOFF_LINK_TEXT;
      link.addEventListener('click', this.handleHandoffLinkClick);
      return link;
    }

    /**
     * event.button !== 0 catches a non-primary button (middle/right); the modifier checks
     * catch cmd/ctrl/shift/alt-click. Both are the customer deliberately asking for the
     * browser's own "open it anyway" behaviour (a new tab, typically) — left completely
     * alone, not just un-prevented, so nothing about them can regress independently of this
     * handler. Only a plain primary-button click with no modifier is intercepted.
     */
    handleHandoffLinkClick(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      event.preventDefault();
      this.copyHandoffLink(event.currentTarget);
    }

    /**
     * Clipboard access can be refused (a permission prompt the customer denies) or absent
     * entirely (an insecure context, an old browser) — both are ordinary, not exceptional,
     * and neither may end in silence or an unchanged label, which would look like the click
     * did nothing. Absence is checked up front rather than only caught after the fact,
     * since calling a method that does not exist would throw before any promise/catch could
     * run.
     */
    copyHandoffLink(link) {
      const url = link.href;

      if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
        this.showHandoffLinkUrl(link, url);
        return;
      }

      navigator.clipboard.writeText(url).then(
        () => this.showHandoffLinkCopied(link),
        () => this.showHandoffLinkUrl(link, url)
      );
    }

    /** Reverts on its own so a customer who copies for a second phone sees the same label
     * to click again, rather than a permanent "Copied!" that stops describing the control. */
    showHandoffLinkCopied(link) {
      link.textContent = HANDOFF_LINK_COPIED_TEXT;

      window.setTimeout(() => {
        if (link.isConnected) {
          link.textContent = HANDOFF_LINK_TEXT;
        }
      }, 2000);
    }

    /**
     * The fallback when clipboard access is refused or absent: shows the real URL as the
     * link's own visible text, so the customer can select and copy it by hand. Left in
     * place rather than reverted — unlike a successful copy, there is no confirmed action
     * to revert away from, and the customer may still need the URL visible to finish
     * copying it manually.
     */
    showHandoffLinkUrl(link, url) {
      link.textContent = url;
    }

    renderHandoffExpired() {
      this.setQrSlotContent((slot) => {
        const message = document.createElement('p');
        message.className = 'product-photo-modal__qr-status';
        message.setAttribute('role', 'status');
        message.setAttribute('aria-live', 'polite');
        message.textContent = HANDOFF_EXPIRED_MESSAGE;
        slot.appendChild(message);

        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'product-photo-modal__qr-retry';
        retry.textContent = HANDOFF_NEW_CODE_LABEL;
        retry.addEventListener('click', this.handleHandoffRetryClick);
        slot.appendChild(retry);
      });
    }

    renderHandoffError(message) {
      this.setQrSlotContent((slot) => {
        const status = document.createElement('p');
        status.className = 'product-photo-modal__qr-status product-photo-modal__qr-status--error';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.textContent = message;
        slot.appendChild(status);

        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'product-photo-modal__qr-retry';
        retry.textContent = HANDOFF_TRY_AGAIN_LABEL;
        retry.addEventListener('click', this.handleHandoffRetryClick);
        slot.appendChild(retry);
      });
    }

    handleHandoffRetryClick(event) {
      event.preventDefault();

      if (this.isSubmitting) {
        return;
      }

      this.startHandoff();
    }

    handleCameraTriggerClick(event) {
      event.preventDefault();

      if (this.isSubmitting) {
        return;
      }

      // Below 1024 this card now opens the guided three-angle flow rather than a single
      // shot. updateCameraAvailability() already hides this trigger at and above that
      // width, so the query is a second lock on the same door rather than a new rule —
      // it keeps the guided flow off desktop even if this card is ever shown there.
      if (this.guide && this.cameraDesktopQuery && !this.cameraDesktopQuery.matches) {
        this.startGuidedFlow();
        return;
      }

      this.openCamera();
    }

    /**
     * getUserMedia missing or refused is a NORMAL state, not an error to surface as one —
     * Instagram's and Facebook's in-app browsers block it outright, and a customer denying
     * the permission prompt is an ordinary choice. Both fall through to useCameraFallback(),
     * which shows why and reveals a real "Open device camera" button — never to silence,
     * and never to a script-initiated click standing in for the customer's own.
     */
    async openCamera() {
      if (!this.camera || !this.cameraVideo) {
        return;
      }

      // A fresh attempt supersedes whatever the last one offered — including a fallback
      // button left over from a previous failure. It reappears on its own if this attempt
      // fails too.
      this.hideCameraFallbackTrigger();

      if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
        this.useCameraFallback(CAMERA_UNAVAILABLE_MESSAGE);
        return;
      }

      // Read BEFORE the await: the permission prompt takes focus, and after it resolves
      // document.activeElement is <body> — which IS in the document, so closeCamera()'s
      // "still attached?" check would accept it and hand focus to the page instead of back
      // to the button the parent pressed.
      const triggerBeforePrompt = document.activeElement;

      const requestedFacingMode = this.requestedFacingMode();

      // THE DEFECTS THIS REPLACES, all three reproduced in the browser before the fix:
      //
      //  - Leaving the guided flow while the permission prompt was up left a bare camera on
      //    screen, with a LIVE stream, after the parent had already backed out. The old guard
      //    checked only `isOpen`, which was still true — the modal had not closed, the flow
      //    had.
      //  - Two taps on the flip button before the first stream arrived produced two live
      //    streams. The second assignment overwrote `cameraStream` without stopping the
      //    first, so a track stayed live with nothing holding it and the camera indicator
      //    stayed lit. Measured: 2 acquired, 2 still live.
      //  - Both are the same shape: an async continuation adopting a stream the UI no longer
      //    wants.
      //
      // The token is bumped here AND in closeCamera(), so anything in flight when the camera
      // closes or reopens is stale by definition, and a stale continuation stops its stream
      // rather than assigning it.
      this.cameraRequestToken += 1;
      const token = this.cameraRequestToken;
      const stageAtRequest = this.guideStage;

      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia(this.cameraConstraints());
      } catch (error) {
        // A superseded request must stay silent: the request that replaced it owns the UI,
        // and a fallback message from the loser would talk over it.
        if (token !== this.cameraRequestToken) {
          return;
        }

        console.warn('[product-photo-upload-modal] getUserMedia failed', { name: error?.name || null });
        this.useCameraFallback(CAMERA_DENIED_MESSAGE);
        return;
      }

      if (token !== this.cameraRequestToken || !this.isOpen || this.guideStage !== stageAtRequest) {
        stream.getTracks().forEach((track) => track.stop());
        return;
      }

      this.cameraStream = stream;
      this.cameraVideo.srcObject = stream;

      // A flip is a restart of a camera that was already open, so the trigger that opened it
      // in the first place must survive: activeElement here is the flip button itself.
      if (!this.guideFlipPending) {
        this.cameraLastTrigger = triggerBeforePrompt;
      }

      this.cameraOpen = true;
      this.camera.hidden = false;
      this.setCameraMessage('');
      // Before applyCameraChrome(), which reads cameraActiveFacingMode for the flip label.
      this.applyCameraMirroring(stream, requestedFacingMode);
      // Only meaningful once permission has been granted: before that, browsers report
      // videoinput entries with blank deviceIds, or hide them entirely.
      this.refreshVideoInputCount();
      this.refreshTorchAvailability();
      // Draws the step counter, brackets and guidance pill and starts the sampler when the
      // guided flow owns this camera; strips all of it when the single-shot camera does.
      this.applyCameraChrome();

      const wasFlip = this.guideFlipPending;
      this.guideFlipPending = false;

      window.requestAnimationFrame(() => {
        // After a flip, focus goes back to the flip button: a parent who just changed camera
        // is more likely to change it again than to have meant to reach the shutter.
        const focusTarget = (wasFlip && this.cameraFlipButton && !this.cameraFlipButton.hidden)
          ? this.cameraFlipButton
          : this.cameraCaptureButton;

        if (focusTarget) {
          focusTarget.focus({ preventScroll: true });
        }
      });
    }

    /**
     * The guided flow wants the camera pointed AT the child — the rear one — and lets the
     * parent flip. Everything else keeps the front camera it has always asked for, unchanged.
     *
     * `ideal`, not `exact`: `exact` throws OverconstrainedError on a device with only one
     * camera, which would send a perfectly usable phone down the no-camera fallback. `ideal`
     * asks and takes what it gets, which is exactly why applyCameraMirroring() reads the track
     * back instead of trusting this.
     */
    cameraConstraints() {
      if (this.guideStage === 'camera') {
        return { video: { facingMode: { ideal: this.guideFacingMode } }, audio: false };
      }

      return { video: { facingMode: FACING_FRONT }, audio: false };
    }

    requestedFacingMode() {
      return this.guideStage === 'camera' ? this.guideFacingMode : FACING_FRONT;
    }

    /**
     * Mirror the preview only while a FRONT camera is running.
     *
     * A front camera is a mirror: a parent expects their own movements to match. A rear camera
     * is a window, and flipping it would put the child's left on the wrong side of the screen
     * and silently invert every direction the guidance copy gives.
     *
     * getSettings().facingMode is the authority rather than what was requested, because
     * `ideal` is only a preference and a one-camera device satisfies either request with the
     * same hardware. Not every browser reports it, so the requested mode is the fallback —
     * and nothing beyond those two is ever guessed.
     *
     * This only ever touches the PREVIEW. The shutter reads the raw stream through canvas
     * drawImage(), which no CSS transform reaches, so the saved still is never mirrored on
     * either camera.
     */
    applyCameraMirroring(stream, requestedFacingMode) {
      const track = (stream && typeof stream.getVideoTracks === 'function')
        ? stream.getVideoTracks()[0]
        : null;
      const settings = (track && typeof track.getSettings === 'function') ? track.getSettings() : null;
      const reported = settings && settings.facingMode;

      this.cameraActiveFacingMode = reported || requestedFacingMode;

      if (this.cameraVideo) {
        this.cameraVideo.classList.toggle('is-mirrored', this.cameraActiveFacingMode === FACING_FRONT);
      }
    }

    /**
     * Swap cameras and restart the stream on the same step. A full closeCamera()/openCamera()
     * cycle rather than swapping the track in place: getUserMedia is what selects the device,
     * the old track has to be stopped either way, and this keeps ONE path for acquiring a
     * stream rather than two that could drift apart on mirroring or chrome.
     */
    handleCameraFlipClick(event) {
      event.preventDefault();

      if (this.guideStage !== 'camera') {
        return;
      }

      this.guideFacingMode = this.guideFacingMode === FACING_REAR ? FACING_FRONT : FACING_REAR;
      this.guideFlipPending = true;
      this.closeCamera();
      this.openCamera();
    }

    /**
     * No getUserMedia, or it was refused. Says so, and reveals a real button instead of
     * calling .click() on the hidden capture="user" input itself.
     *
     * THE DEFECT THIS REPLACES: the old code called `.click()` here, and this function is
     * only ever reached from openCamera() — either synchronously (API missing) or, far more
     * commonly, from the `catch` after `await getUserMedia(...)` (permission denied). In
     * that second, more common case, the click happens AFTER an await, with the user gesture
     * that started openCamera() long consumed by the permission prompt. Safari refuses to
     * open a file picker from a script-initiated click with no live user gesture behind it,
     * and Chrome refuses it in several cases too — so on the denied branch the customer most
     * likely saw the message and nothing else, while the API-missing branch (synchronous,
     * gesture still live) probably worked. Two branches into the same call, indistinguishable
     * from outside, one reliable and one not.
     *
     * The fix is not "try the click, and if it doesn't work show a button" — that is still
     * two paths, impossible to tell apart from the user's side and just as impossible to
     * debug. There is exactly one path now: show the button, always, and let the customer's
     * own click on it (handleCameraFallbackTriggerClick) be the gesture that opens the
     * picker, every time, on every branch.
     */
    useCameraFallback(message) {
      // Both the message and the "Open device camera" button live in the FORM, underneath
      // the guided layer, so the guided flow has to get out of the way before either can
      // be seen. This is the fallback the task asks for: no camera means today's message
      // and today's upload path, not a guided flow wrapped around a camera that is not
      // going to open. No-op when the single-shot camera is the caller.
      this.closeGuide({ restoreFocus: false });
      this.setPhotoMessage(message);
      this.showCameraFallbackTrigger();
    }

    showCameraFallbackTrigger() {
      if (!this.cameraFallbackTrigger) {
        return;
      }

      this.cameraFallbackTrigger.hidden = false;

      window.requestAnimationFrame(() => {
        if (this.cameraFallbackTrigger && !this.cameraFallbackTrigger.hidden) {
          this.cameraFallbackTrigger.focus({ preventScroll: true });
        }
      });
    }

    /**
     * Called when the fallback is no longer the customer's next step: a fresh camera
     * attempt has started (openCamera()), or the fallback input itself already produced a
     * file (handleCameraFallbackChange()). Never called from handleFileChange() or the
     * extra photo slots — this button's visibility tracks the camera/fallback exchange
     * only, not the primary dropzone, which this task does not touch.
     */
    hideCameraFallbackTrigger() {
      if (!this.cameraFallbackTrigger) {
        return;
      }

      this.cameraFallbackTrigger.hidden = true;
    }

    handleCameraFallbackTriggerClick(event) {
      event.preventDefault();

      if (this.isSubmitting || !this.cameraFallbackInput) {
        return;
      }

      // THE GESTURE. This click handler runs synchronously off the customer's own tap on a
      // real, visible button — nothing awaited before it, nothing consumed in between — so
      // .click() here is exactly the kind of script-initiated-but-gesture-backed call every
      // target browser (including Safari) allows. See useCameraFallback() for what this
      // replaces and why.
      this.cameraFallbackInput.click();
    }

    handleCameraCancelClick(event) {
      event.preventDefault();
      this.closeCamera();
    }

    handleCameraCaptureClick(event) {
      event.preventDefault();
      // A press always wins over a countdown rather than racing it: cancel first, then shoot.
      this.cancelAutoCapture();
      this.runCapture();
    }

    /**
     * The single way a frame is taken, by a press or by the ring's own timer — now from
     * EITHER kind of step. `captureInFlight` is the one guard the 2026-10-01 evening
     * amendment asks for ("make one guard own 'a capture is in progress' and route both
     * paths through it"): both handleCameraCaptureClick() (the tap) and
     * startAutoCapture()'s timer callback (the ring) call this method directly, nothing
     * else, and this is the only place that checks or sets `captureInFlight`. The check
     * happens synchronously, before the first `await` — JS never interleaves a click
     * handler and a timer callback mid-execution, so whichever of the two calls this
     * first runs its synchronous prefix (the check, then `captureInFlight = true`) to
     * completion before the other can even begin; the second call's own check then sees
     * `true` and returns immediately. A tap mid-ring additionally cancels the timer outright
     * (see handleCameraCaptureClick(), below) so the common case never even reaches this
     * race — but the guard holds even in the rarer case where the timer's callback has
     * already started running by the time the tap arrives.
     *
     * THE DEFECT THE IN-FLIGHT GUARD WAS BUILT FOR (2026-09-30, a double-TAP, not a
     * tap-vs-timer race): canvas.toBlob is awaited, and a second tap inside that window ran
     * with the stage already moved to 'keep'. It fell through to the single-shot branch and
     * wrote the frame straight into slot 1 — a photo in the slot, and the counter reading
     * "1 of 3 uploaded", while the parent was still on "Keep this photo?" deciding.
     * Reproduced by dispatching two clicks in one tick. The same guard, unchanged, is what
     * now also closes the tap-vs-timer case the amendment asks about.
     */
    async runCapture() {
      if (this.captureInFlight) {
        return;
      }

      if (!this.cameraVideo || !this.cameraVideo.videoWidth || !this.cameraVideo.videoHeight) {
        this.setCameraMessage(CAMERA_CAPTURE_FAILED_MESSAGE);
        return;
      }

      this.captureInFlight = true;
      this.flashCapture();

      try {
        await this.captureCurrentFrame();
      } finally {
        this.captureInFlight = false;
      }
    }

    /* --- Autocapture (every step, since the 2026-10-01 evening amendment) --
       One timer, no hold phase, no digit countdown. The ring drawn around the oval (CSS,
       `.is-ready .camera-ring-fill`) IS the countdown a parent sees; this only has to agree
       with it on duration (GUIDE_READY_RING_MS) and fire once at the end. Nothing in this
       function or cancelAutoCapture() ever checked which step was active — it only ran on
       the front step before because 'ready' (see setGuidanceState()) was only reachable
       from there; a profile step's own success condition reaches the same kind now, so the
       same timer serves it with no changes here. */

    /**
     * THE VISIBLE ring/text/colour are driven purely by the committed, hysteresis-smoothed
     * `guideGuidanceKind` — exactly as the brief asks ("through the existing hysteresis,
     * never by flicker"), and that is still true here: `cancelAutoCapture()` is called the
     * instant `kind` leaves 'ready' (see setGuidanceState()), so a VISIBLY-reset ring never
     * disagrees with whether a capture is still pending.
     *
     * THE ACTUAL FIRE DECISION additionally re-checks `this.guideRawReady` — the UNDEBOUNCED
     * condition, recomputed every sample in applyGuidanceVerdict() — because the committed
     * `kind` is deliberately sticky and can stay 'ready' for up to GUIDE_STATE_LEAVE_SAMPLES
     * (3 samples, ~1.5 s) after the child has actually moved out of frame entirely. Measured
     * on this harness: a face removed outright stays inside the committed 'ready' kind for
     * that whole 1.5 s, which is LONGER than GUIDE_READY_RING_MS (1.0 s) — so relying on
     * `kind` alone would let the timer fire, and the shutter capture, a frame with no child
     * in it. That is exactly the "shutter fires after the face has left" bug class the old
     * syncAutoCapture(rawReady) existed to prevent; retiming the ring to the committed kind
     * alone reopens it, so the raw check comes back here, in the one place it is actually
     * needed — a single check at the instant the timer fires, not a continuously-polled
     * countdown.
     *
     * Checking `guideGuidanceKind` at fire time (rather than trusting the scheduling site) is
     * still worth doing too: a 'ready' that is lost and regained cancels and restarts this
     * timer via setGuidanceState's own kind-transition calls, but re-reading the current kind
     * here as well costs nothing and removes any dependence on that being the only path that
     * could end 'ready' before this fires.
     */
    startAutoCapture() {
      this.cancelAutoCapture();

      if (!GUIDE_STEPS[this.guideStepIndex] || this.guideStage !== 'camera') {
        return;
      }

      this.autoCaptureTimer = window.setTimeout(() => {
        this.autoCaptureTimer = null;

        if (this.guideGuidanceKind === 'ready' && this.guideStage === 'camera' && this.guideRawReady) {
          this.runCapture();
        }
      }, GUIDE_READY_RING_MS);
    }

    cancelAutoCapture() {
      if (this.autoCaptureTimer) {
        window.clearTimeout(this.autoCaptureTimer);
        this.autoCaptureTimer = null;
      }
    }

    flashCapture() {
      if (!this.camera) {
        return;
      }

      this.camera.classList.add('is-capturing');
      window.setTimeout(() => {
        if (this.camera) {
          this.camera.classList.remove('is-capturing');
        }
      }, 300);

      // Absent on iOS Safari; feature-detected so calling it is never an error there.
      if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
        navigator.vibrate(30);
      }
    }

    async captureCurrentFrame() {
      const token = this.cameraRequestToken;
      const stageAtCapture = this.guideStage;

      const canvas = document.createElement('canvas');
      canvas.width = this.cameraVideo.videoWidth;
      canvas.height = this.cameraVideo.videoHeight;

      const context = canvas.getContext('2d');

      if (!context) {
        this.setCameraMessage(CAMERA_CAPTURE_FAILED_MESSAGE);
        return;
      }

      // Reads the video element's actual frame data, which is the stream as the camera
      // sent it. The mirrored preview the parent sees is a CSS transform on <video> alone
      // (.product-photo-modal__camera-video) and never touches these pixels — so the file
      // captured here is never mirrored, even though the live preview is.
      // THE WHOLE FRAME, never the bracketed area. The brackets are a composition guide, and
      // cropping to them would throw away exactly what the service needs downstream: room
      // around the head for subject selection when more than one face is present, and the
      // full outline of the hair. Saving less than the camera saw is not recoverable later.
      context.drawImage(this.cameraVideo, 0, 0, canvas.width, canvas.height);

      const blob = await new Promise((resolve) => {
        canvas.toBlob(resolve, 'image/jpeg', 0.92);
      });

      if (!blob) {
        this.setCameraMessage(CAMERA_CAPTURE_FAILED_MESSAGE);
        return;
      }

      // The camera can have been closed, flipped or left entirely while toBlob ran. A frame
      // from a camera session the parent has moved on from must not be committed anywhere.
      if (token !== this.cameraRequestToken || this.guideStage !== stageAtCapture) {
        return;
      }

      const file = new File([blob], 'camera-photo.jpg', { type: 'image/jpeg', lastModified: Date.now() });

      // In the guided flow a shutter press is not a decision yet — the frame goes to the
      // "Keep this photo?" stage, and only Save routes it to a slot. The single-shot
      // camera keeps committing straight away, as it always has.
      if (stageAtCapture === 'camera') {
        this.showGuideKeep(file);
        return;
      }

      this.closeCamera();
      this.applyCapturedFile(file);
    }

    handleCameraFallbackChange() {
      const file = this.cameraFallbackInput.files && this.cameraFallbackInput.files[0];
      this.cameraFallbackInput.value = '';

      if (!file) {
        return;
      }

      this.hideCameraFallbackTrigger();
      this.applyCapturedFile(file);
    }

    /**
     * THE integration point: feeds a captured Blob/File through the exact same path a
     * manually chosen file takes. `this.fileInput.files` is otherwise read-only, so a
     * FileList has to be built with DataTransfer and assigned; dispatching a real 'change'
     * event afterwards is what makes handleFileChange() run — the sole owner of
     * ALLOWED_FILE_TYPES / MAX_FILE_SIZE checks, re-encoding, precheck and the subject
     * chooser. Nothing here duplicates any of that.
     */
    applyCapturedFile(file) {
      if (!this.fileInput) {
        return;
      }

      // WHY THIS IS WRAPPED. `new DataTransfer()` and assigning `.files` are supported by
      // every browser we target (Chrome 59+, Firefox 62+, Safari 14.1 desktop / 14.5 iOS),
      // so this is not expected to fire. It is wrapped anyway because of WHERE it sits: the
      // parent has already taken the photo, the camera view has already closed, and this
      // runs inside an async handler — a throw here would become an unhandled rejection and
      // the parent would see the camera close and nothing happen at all. An unexpected
      // failure has to say so.
      try {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        this.fileInput.files = dataTransfer.files;
      } catch (error) {
        console.warn('[product-photo-upload-modal] could not attach captured file', { name: error?.name || null });
        this.setPhotoMessage(CAMERA_ATTACH_FAILED_MESSAGE);
        return;
      }

      this.fileInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setCameraMessage(message) {
      if (!this.cameraMessage) {
        return;
      }

      this.cameraMessage.textContent = message || '';
      this.cameraMessage.hidden = !message;
    }

    /**
     * Stops every track on the stream, not just the video one — a track left running is
     * exactly what keeps a browser's camera indicator lit after this UI is gone, which
     * would read as "the site is still watching". Called on cancel, Escape, a successful
     * capture, AND from close()/destroy() so the outer modal closing can never leave a
     * stream behind either. Idempotent: safe to call when nothing is open.
     */
    closeCamera() {
      // Any getUserMedia still in flight is stale from this moment: its continuation will
      // see a newer token and stop its stream instead of adopting it. This is what stops a
      // pending request from re-opening a camera the parent has just left.
      this.cameraRequestToken += 1;
      this.cancelAutoCapture();

      // Then: no stream means nothing left to sample, and a sample already in flight must
      // not be allowed to write guidance into a camera that is closing.
      this.stopGuidanceSampling();

      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach((track) => track.stop());
        this.cameraStream = null;
      }

      if (this.cameraVideo) {
        this.cameraVideo.srcObject = null;
      }

      if (!this.cameraOpen) {
        return;
      }

      this.cameraOpen = false;

      if (this.camera) {
        this.camera.hidden = true;
      }

      this.setCameraMessage('');

      // Still inside the guided flow: the next stage places focus itself (the keep panel,
      // or the next step's shutter). Bouncing focus back to the card that opened the flow
      // in between would scroll the form under the overlay and, with a screen reader,
      // announce a form the parent has not returned to.
      if (this.guideStage) {
        return;
      }

      const restoreTarget = (this.cameraLastTrigger && document.contains(this.cameraLastTrigger))
        ? this.cameraLastTrigger
        : this.cameraTrigger;

      if (restoreTarget) {
        restoreTarget.focus({ preventScroll: true });
      }

      this.cameraLastTrigger = null;
    }

    /* --- Guided three-angle capture ---------------------------------------
     *
     * Three stages, three steps. The stages are 'intro' -> 'camera' -> 'keep'; the steps
     * are GUIDE_STEPS (front, left profile, right profile), and 'camera'/'keep' repeat
     * once per step. this.guideStage is the only flag saying which stage is on screen and
     * this.guideStepIndex the only one saying which step — every branch below reads those
     * two rather than inspecting the DOM.
     *
     * What this flow does NOT do is upload. "Save photo" routes the frame into that step's
     * existing file input; the network upload still happens at form submit through
     * uploadPhotoToService()/confirmUpload(). The service contract is untouched: slot 1 is
     * the required front photo with the same paid pre-check it has always had, slots 2 and
     * 3 the optional profiles.
     */

    startGuidedFlow() {
      if (!this.guide) {
        return;
      }

      this.guideLastTrigger = document.activeElement;
      this.guideStage = 'intro';
      this.guideStepIndex = 0;
      this.showGuidePanel('intro');
      this.focusFirstIn(this.guide);
    }

    showGuidePanel(name) {
      if (!this.guide) {
        return;
      }

      this.guide.hidden = false;
      this.guidePanels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-product-photo-modal-guide-panel') !== name;
      });
    }

    focusFirstIn(container) {
      if (!container) {
        return;
      }

      // rAF so focus lands after the panel swap above has taken effect — focusing an
      // element still inside a hidden panel silently does nothing.
      window.requestAnimationFrame(() => {
        const focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).find((element) => {
          return element.tabIndex >= 0 && !element.hidden && !element.closest('[hidden]');
        });

        if (focusable) {
          focusable.focus({ preventScroll: true });
        }
      });
    }

    handleGuideStartClick(event) {
      event.preventDefault();
      this.startGuideStep(0);
    }

    /**
     * "Upload photo instead" — the design's own escape hatch. Hands back to the existing
     * picker for the first free slot, the same path the "Upload photo" card takes. The
     * guide closes first so the picker, and whatever handleFileChange() shows afterwards,
     * is not opened behind an overlay.
     */
    handleGuideUploadClick(event) {
      event.preventDefault();

      const target = this.firstFreeFileInput();

      this.closeGuide({ restoreFocus: false });

      if (target) {
        target.click();
        return;
      }

      // Every slot is taken. This used to close the guide and do nothing at all, which reads
      // as a broken button — the one thing a parent falling back from the camera cannot
      // afford. Say which state they are in and what to do about it; the slots they need are
      // on screen the moment the guide closes.
      this.setPhotoMessage(GUIDE_SLOTS_FULL_MESSAGE);
    }

    /**
     * Back, from either the intro's chevron or the camera's, leaves the guided flow and
     * returns to the form. One rule for both, rather than "the intro exits but a camera
     * step goes back one stage": stepping back into a stage whose photo is already saved
     * has no meaning, and a back button that does different things on different screens is
     * harder to predict than one that always does the same thing. Photos already saved stay
     * saved; Skip, not Back, is how a parent moves past an optional step.
     */
    handleGuideBackClick(event) {
      event.preventDefault();

      // Mid-retake the parent already has photos held that nothing has committed yet, so a
      // back out of the retake must return to the review screen rather than discard all of
      // them. Discarding is available there, as a labelled action.
      if (this.guideReturnToReview) {
        this.guideReturnToReview = false;
        this.showGuideReview();
        return;
      }

      this.closeGuide();
    }

    startGuideStep(index) {
      const step = GUIDE_STEPS[index];

      if (!step) {
        this.finishGuidedFlow();
        return;
      }

      this.guideStepIndex = index;
      this.guideStage = 'camera';
      this.releaseCapturedPhoto();

      if (this.guide) {
        this.guide.hidden = true;
      }

      // The stream starts only here — after "I'm ready", or a retake — never on the intro.
      // openCamera() owns the permission prompt; if it fails, useCameraFallback() closes
      // this flow and surfaces today's message and upload path instead.
      this.openCamera();
    }

    /**
     * Dresses the camera layer for whichever flow opened it. Called from openCamera() once
     * the stream is live, so the chrome and the picture arrive together.
     */
    applyCameraChrome() {
      const guided = this.guideStage === 'camera';
      const step = guided ? GUIDE_STEPS[this.guideStepIndex] : null;

      if (this.camera) {
        this.camera.classList.toggle('is-guided', guided);
      }

      if (this.cameraHeader) {
        this.cameraHeader.hidden = !guided;
      }

      if (this.cameraOverlay) {
        this.cameraOverlay.hidden = !guided;
        this.cameraOverlay.classList.remove('is-ready', 'is-detecting');
      }

      this.updateScanRange(null);
      this.updateTurnMeter(null);

      if (this.cameraSkipButton) {
        // Slot 1 is the required photo, so step 1 has no Skip. Steps 2 and 3 map to the
        // optional slots and must have one.
        this.cameraSkipButton.hidden = !guided || step.slot === REQUIRED_PHOTO_SLOT;
      }

      this.updateFlipVisibility();

      if (this.cameraTorchButton && !guided) {
        this.cameraTorchButton.hidden = true;
      }

      if (this.cameraFlipLabel) {
        // Names the camera the button switches TO, which is the choice being offered rather
        // than a restatement of the picture already on screen.
        this.cameraFlipLabel.textContent =
          this.cameraActiveFacingMode === FACING_FRONT ? 'Rear' : 'Front';
      }

      if (this.cameraFlipButton) {
        this.cameraFlipButton.setAttribute(
          'aria-label',
          this.cameraActiveFacingMode === FACING_FRONT
            ? 'Switch to the rear camera'
            : 'Switch to the front camera'
        );
      }

      if (!guided) {
        this.setCameraGuidance('');
        return;
      }

      if (this.cameraStepCount) {
        this.cameraStepCount.textContent = `Photo ${this.guideStepIndex + 1} of ${GUIDE_STEPS.length}`;
      }

      if (this.cameraStepLabel) {
        this.cameraStepLabel.textContent = step.label;
      }

      // null first, so setGuidanceState('static') always writes on a fresh step even when
      // the previous step ended on 'static' too.
      this.guideGuidanceKind = null;
      this.resetGuideSignals();
      this.setGuidanceState('static');
      this.startGuidanceSampling();
    }

    /**
     * A flip button on a device with one camera promises something it cannot do: `ideal`
     * constraints hand back the same hardware either way, so pressing it restarts the same
     * camera while the label claims it will switch.
     */
    refreshVideoInputCount() {
      if (!navigator.mediaDevices || typeof navigator.mediaDevices.enumerateDevices !== 'function') {
        return;
      }

      navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          this.videoInputCount = devices.filter((device) => device.kind === 'videoinput').length;
          this.updateFlipVisibility();
        })
        .catch(() => {
          // Counting failed; videoInputCount stays null and the button stays available.
        });
    }

    currentVideoTrack() {
      return (this.cameraStream && typeof this.cameraStream.getVideoTracks === 'function')
        ? this.cameraStream.getVideoTracks()[0]
        : null;
    }

    /**
     * The torch appears only when the ACTIVE track says it has one, re-checked on every
     * stream: it is a rear-camera capability on most phones, absent on desktop, and
     * getCapabilities() does not exist at all in Safari. Never inferred from the facing mode
     * — a button that claims a torch and produces nothing is worse than no button, and the
     * intro's own tip already asks for good light, which is the problem this solves.
     */
    refreshTorchAvailability() {
      if (!this.cameraTorchButton) {
        return;
      }

      // A new stream starts with the torch off, so the control must not claim otherwise.
      this.torchOn = false;
      this.cameraTorchButton.setAttribute('aria-pressed', 'false');
      this.cameraTorchButton.hidden = !this.cameraSupportsTorch();
    }

    cameraSupportsTorch() {
      const track = this.currentVideoTrack();

      if (!track || typeof track.getCapabilities !== 'function') {
        return false;
      }

      try {
        const capabilities = track.getCapabilities();
        return !!(capabilities && capabilities.torch);
      } catch {
        return false;
      }
    }

    async handleCameraTorchClick(event) {
      event.preventDefault();

      const track = this.currentVideoTrack();

      if (!track || typeof track.applyConstraints !== 'function') {
        return;
      }

      const next = !this.torchOn;

      try {
        await track.applyConstraints({ advanced: [{ torch: next }] });
      } catch (error) {
        // The capability was advertised and then refused. Withdraw the control rather than
        // leave one that does nothing when pressed.
        console.warn('[product-photo-upload-modal] torch refused', { name: error?.name || null });
        this.cameraTorchButton.hidden = true;
        this.torchOn = false;
        this.cameraTorchButton.setAttribute('aria-pressed', 'false');
        return;
      }

      this.torchOn = next;
      this.cameraTorchButton.setAttribute('aria-pressed', String(next));
    }

    updateFlipVisibility() {
      if (!this.cameraFlipButton) {
        return;
      }

      const guided = this.guideStage === 'camera';
      const singleCamera = this.videoInputCount !== null && this.videoInputCount < 2;

      this.cameraFlipButton.hidden = !guided || singleCamera;
    }

    setCameraGuidance(message) {
      if (!this.cameraGuidance) {
        return;
      }

      this.cameraGuidance.textContent = message || '';
      this.cameraGuidance.hidden = !message;
    }

    startGuidanceSampling() {
      this.stopGuidanceSampling();

      if (!this.cameraVideo) {
        return;
      }

      this.guideSampleTimer = window.setInterval(() => {
        this.sampleGuidanceFrame();
      }, GUIDE_SAMPLE_INTERVAL_MS);
    }

    stopGuidanceSampling() {
      if (this.guideSampleTimer) {
        window.clearInterval(this.guideSampleTimer);
        this.guideSampleTimer = null;
      }

      this.guideSampleInFlight = false;
    }

    /**
     * One detector run against the live preview, at most every GUIDE_SAMPLE_INTERVAL_MS
     * and never more than one at a time. Advisory only: it moves the guidance line and the
     * bracket styling, and nothing else. The shutter stays live throughout, on every step,
     * whatever this returns — the same rule the pre-check follows on an uploaded file, and
     * the reason a parent shooting a side-on profile (which the model frequently cannot see
     * at all) is never locked out of their own camera.
     */
    sampleGuidanceFrame() {
      if (this.guideSampleInFlight || !this.cameraOpen || this.guideStage !== 'camera') {
        return;
      }

      const video = this.cameraVideo;

      if (!video || video.readyState < 2 || !video.videoWidth) {
        return;
      }

      this.guideSampleInFlight = true;

      this.loadPrecheckModule()
        .then((precheck) => {
          if (!precheck || typeof precheck.runLive !== 'function') {
            return null;
          }

          return precheck.runLive(video, this.precheckAssetUrls).then((result) => {
            return { precheck: precheck, result: result };
          });
        })
        .then((payload) => {
          // The parent may have pressed the shutter, gone back, or backgrounded the tab
          // while this frame was still in the detector.
          if (!this.cameraOpen || this.guideStage !== 'camera') {
            return;
          }

          this.applyGuidanceVerdict(payload && payload.precheck, payload && payload.result);
        })
        .catch(() => {
          // A failed sample is not something to tell a parent about — the guidance line
          // stays as it is until the next one.
        })
        .finally(() => {
          this.guideSampleInFlight = false;
        });
    }

    /**
     * One detector result in, one guidance state out.
     *
     * BOTH front and profile steps can now reach 'ready' — reversed, 2026-10-01 evening, from
     * this same task's own earlier decision the same day ("no green state and no
     * auto-capture" on profile steps). That line was Cowork's addition to the brief, not the
     * Human's; the Human's actual instruction was "I wanted auto-capture here too... Both
     * should work, manual and auto." The two cascades below still differ in SHAPE — the front
     * step is a five-hint priority ladder ending in 'ready'; a profile step is the simpler
     * two-state rule it always was ('ready' or 'turn' or static) — but they now share the one
     * 'ready' KIND and everything that kind drives (green oval, the ring, the "Hold still…"
     * text, autocapture). What differs between them is only the RAW CONDITION that earns
     * 'ready': the front step's five conditions (centred, sized, not too close, straight,
     * frontal) versus a profile step's own `profileOk` (centred AND turned far enough toward
     * THIS step's own side — never a frontal face, see turnedEnough below). See
     * setGuidanceState() for where the shared kind turns into shared behaviour, and
     * `guideRawReady` below for how each step's own condition still gets its own fire-time
     * safety check.
     *
     * "Everything else" on a profile step (not yet 'ready', not frontal) deliberately
     * includes both "already turned, just not enough" and "cannot tell". They are not the
     * same thing, but they call for the same standing advice rather than a nudge to turn
     * further, and estimateHeadTurn() returns null rather than guessing whenever it lacks the
     * three landmarks it needs (the native FaceDetector path never has them).
     *
     * The shutter is live in every one of these states, on every step — including while the
     * ring is running: see runCapture()'s own `captureInFlight` guard, the one place that
     * decides "is a capture already underway" regardless of whether the tap or the timer got
     * there first.
     */
    applyGuidanceVerdict(precheck, result) {
      const step = GUIDE_STEPS[this.guideStepIndex];

      if (!step) {
        return;
      }

      const sawFace = !!result && result.verdict === 'pass';
      const isFrontStep = step.slot === REQUIRED_PHOTO_SLOT;

      // Needed on BOTH kinds of step now: profile steps read turn.frontal (has this child's
      // head not yet turned?) and turn.noseOffset (how far through the turn?); the front step
      // reads turn.frontal too, for its own new "Face the camera" hint (see below).
      const turn = (sawFace && precheck && typeof precheck.estimateHeadTurn === 'function')
        ? precheck.estimateHeadTurn(result.keypoints)
        : null;
      // Roll (eye-line tilt) only matters to the front step's own cascade (hint 4, "Keep the
      // head straight") — a profile step's eye line is expected to tilt as the head turns, so
      // roll is not part of its rule and is left null there.
      const roll = (sawFace && isFrontStep && precheck && typeof precheck.estimateHeadRoll === 'function')
        ? precheck.estimateHeadRoll(result.keypoints)
        : null;

      // Every raw reading goes through the hysteresis before anything on screen moves.
      // Centring is asked of BOTH kinds of step: a head turned perfectly but sitting in a
      // corner of the oval is not the photo either step wants. The 120px service minimum
      // stays front-only, because that is the slot the service actually generates from.
      const centered = sawFace && this.guideFaceWithinBrackets(result.face);
      // faceShortEdgePx is in the saved still's pixels — see GUIDE_READY_MIN_FACE_PX.
      const bigEnough = sawFace && (result.faceShortEdgePx || 0) >= GUIDE_READY_MIN_FACE_PX;

      // "Too close": the face's own projected box overflowing the box it is meant to sit
      // inside of. Derived from GUIDE_FRAME's own width/height — the brief asks this not
      // invent a new ratio, and GUIDE_FRAME is the one box both the oval (CSS) and the size
      // gate above already agree on.
      const rect = sawFace ? this.projectFaceToViewport(result.face) : null;
      const tooClose = !!rect &&
        (rect.width > (GUIDE_FRAME.right - GUIDE_FRAME.left) ||
          rect.height > (GUIDE_FRAME.bottom - GUIDE_FRAME.top));

      // A profile step's own success condition. Without this the two profile steps had no
      // positive state at all: doing it RIGHT looked exactly like no face in frame, which is
      // what "it doesn't work like when you look straight at the camera" was reporting.
      //
      // Goes through precheck.isTurnedTowardStep(), not a local |noseOffset| comparison and
      // not a second copy of `noseOffset * turnSign` — turnProgress() below shares the exact
      // same call. An adversarial pass on 2026-09-30 found the old |noseOffset| version
      // direction-blind (see the derivation on GUIDE_STEPS' turnSign field), and the fix that
      // followed still left the sign multiplication written out twice, once here and once in
      // turnProgress — which is exactly how a later edit to only one of them could reintroduce
      // the same class of bug. `>= 1` is the boolean gate; isTurnedTowardStep returns the
      // graded value both callers need.
      const turnedEnough = !!turn && !!step.turnSign &&
        precheck.isTurnedTowardStep(turn.noseOffset, step.turnSign) >= 1;

      const detected = this.debounceSignal('detected', sawFace);
      // Fast release: these all issue an instruction, and an instruction that has been obeyed
      // must stop being shown at once — see GUIDE_INSTRUCTION_LEAVE_SAMPLES, and the
      // 2026-09-30 staleness fix this follows the same discipline as. Debouncing the PROBLEM
      // (raw && !condition) rather than the condition itself is what makes the fast release
      // apply to the direction that matters: appearing (two samples, so one noisy frame does
      // not flash a hint on) is slower than disappearing (one sample, so a correction reads as
      // corrected at once) — see debounceSignal()'s own `needed` line, and the ENTER/LEAVE
      // samples comment above GUIDE_STATE_ENTER_SAMPLES, for the two directions this exploits.
      const needsCenter = this.debounceSignal('needsCenter', sawFace && !centered, GUIDE_INSTRUCTION_LEAVE_SAMPLES);
      const needsCloser = this.debounceSignal('needsCloser', sawFace && !bigEnough, GUIDE_INSTRUCTION_LEAVE_SAMPLES);
      const needsFurther = this.debounceSignal('needsFurther', sawFace && tooClose, GUIDE_INSTRUCTION_LEAVE_SAMPLES);
      // turn.frontal is read leniently here (missing keypoints do not block the hint from
      // clearing): the native FaceDetector fallback never returns keypoints, so treating a
      // null turn as "needs straightening"/"needs to face the camera" would permanently block
      // 'ready' on exactly the devices that could not measure it before this task either —
      // see the long comment on `turn` above this method for why estimateHeadTurn() returns
      // null rather than guessing.
      const needsStraighten = this.debounceSignal(
        'needsStraighten', sawFace && !!roll && !roll.straight, GUIDE_INSTRUCTION_LEAVE_SAMPLES
      );
      const needsFaceCamera = this.debounceSignal(
        'needsFaceCamera', sawFace && !!turn && !turn.frontal, GUIDE_INSTRUCTION_LEAVE_SAMPLES
      );
      // Fast release: this one issues an instruction too (the profile steps' turn prompt).
      const frontal = this.debounceSignal('frontal', !!(turn && turn.frontal), GUIDE_INSTRUCTION_LEAVE_SAMPLES);
      // A profile step's own ready condition: centred in the oval AND turned far enough
      // toward THIS step's own side. Never true on a frontal face — turnedEnough requires
      // isTurnedTowardStep() >= 1, and a frontal noseOffset never clears that threshold.
      const profileOk = this.debounceSignal('profileOk', !isFrontStep && centered && turnedEnough);

      // THE RAW (undebounced) ready condition for WHICHEVER step this is, re-derived every
      // sample and kept around only for startAutoCapture()'s own fire-time check — never read
      // by anything that draws on screen.
      //
      // THE GAP THIS CLOSES: every needsX check above is deliberately gated on `sawFace`
      // (see their own comment), which is right for deciding WHICH HINT TO SHOW — there is
      // no "centre the face" instruction to give when there is no face. But that same gating
      // means that the instant the face disappears ENTIRELY, every needsX reads "no problem"
      // (false), and the cascade's only remaining way to notice is `detected`, which is
      // sticky on purpose (GUIDE_STATE_LEAVE_SAMPLES, ~1.5 s). Caught on this harness: a face
      // removed mid-ring stayed in the committed 'ready' kind, un-reset, for the full 1.5 s —
      // longer than GUIDE_READY_RING_MS (1.0 s), so the timer in startAutoCapture() would
      // fire and capture a frame with no child in it at all. That is precisely the "shutter
      // fires after the face has left" bug class syncAutoCapture() used to exist to prevent,
      // reopened by retiming autocapture to the committed kind alone. The exact same gap
      // applies to a profile step turning back toward frontal mid-ring — `centered` and
      // `turnedEnough` both read straight off `sawFace`-gated geometry, so they go false the
      // instant the child turns back, same as the front step's conditions go false the
      // instant the face leaves.
      //
      // The fix is NOT to make the visible state (text, oval colour, ring) react faster —
      // the brief is explicit that those go "through the existing hysteresis, never by
      // flicker", and they still do, below. It is to give the one thing that actually fires
      // the shutter (startAutoCapture()'s own timer callback) a fresh, undebounced answer to
      // check itself against at the single instant it matters, exactly as the old
      // syncAutoCapture(rawReady) did — just as a one-shot check now, since this fires once.
      this.guideRawReady = isFrontStep
        ? (centered && bigEnough && !tooClose && (!roll || roll.straight) && (!turn || turn.frontal))
        : (centered && turnedEnough);

      if (isFrontStep) {
        // Priority order exactly as the brief lists it. 'ready' is not itself debounced as a
        // combined signal — each of the five needsX checks above already carries its own
        // hysteresis, so by the time every one of them reads false simultaneously each
        // condition has independently held for its own ENTER/LEAVE window; stacking a sixth
        // debounce on top of five already-debounced inputs would only add latency, not
        // stability. See startAutoCapture() for the separate, direct re-check that keeps the
        // shutter honest regardless of this cascade's exact timing.
        if (!detected) {
          this.setGuidanceState('static');
        } else if (needsCenter) {
          this.setGuidanceState('center');
        } else if (needsCloser) {
          this.setGuidanceState('closer');
        } else if (needsFurther) {
          this.setGuidanceState('further');
        } else if (needsStraighten) {
          this.setGuidanceState('straighten');
        } else if (needsFaceCamera) {
          this.setGuidanceState('faceCamera');
        } else {
          this.setGuidanceState('ready');
        }
      } else {
        // profileOk first: it is the success state, and the two cannot both be true from one
        // reading — only from hysteresis briefly disagreeing with itself. Reaches the same
        // 'ready' kind the front step does (2026-10-01 evening amendment) — see
        // setGuidanceState() for what that kind now does on every step.
        this.setGuidanceState(profileOk ? 'ready' : (frontal ? 'turn' : 'static'));
      }

      this.setScanDetected(detected && this.guideGuidanceKind !== 'ready');

      // The turn meter follows the RAW reading, not the debounced one: it is a picture of
      // what the detector sees this instant, and smoothing it would make it lie about its
      // own freshness. The text and the oval styling stay debounced, which is why those do
      // not flicker while this moves.
      this.updateScanRange(sawFace ? result.face : null);
      this.updateTurnMeter(isFrontStep ? null : this.turnProgress(turn, step.turnSign, precheck));
    }

    /**
     * Debounced boolean. `streak` counts consecutive samples that DISAGREE with the value
     * currently committed; once enough of them pile up, the committed value flips and the
     * count resets. Agreement resets it too, so a single stray frame never accumulates
     * toward a change.
     *
     * Returns the committed value, never the raw one — callers must not see the raw signal,
     * or the flapping this exists to stop would simply move to the caller.
     */
    debounceSignal(name, raw, leaveSamples) {
      const committed = this.guideSignals[name];

      if (raw === committed) {
        this.guideSignalStreaks[name] = 0;
        return committed;
      }

      this.guideSignalStreaks[name] += 1;

      const needed = raw
        ? GUIDE_STATE_ENTER_SAMPLES
        : (leaveSamples || GUIDE_STATE_LEAVE_SAMPLES);

      if (this.guideSignalStreaks[name] >= needed) {
        this.guideSignals[name] = raw;
        this.guideSignalStreaks[name] = 0;
      }

      return this.guideSignals[name];
    }

    /**
     * Signals ONLY. It runs at the start of every camera stage, so anything reset here is
     * reset between steps — which is right for the detector's conclusions and catastrophic
     * for the photos already taken.
     */
    resetGuideSignals() {
      this.guideSignals = {
        detected: false,
        frontal: false,
        profileOk: false,
        needsCenter: false,
        needsCloser: false,
        needsFurther: false,
        needsStraighten: false,
        needsFaceCamera: false
      };
      this.guideSignalStreaks = {
        detected: 0,
        frontal: 0,
        profileOk: 0,
        needsCenter: 0,
        needsCloser: 0,
        needsFurther: 0,
        needsStraighten: 0,
        needsFaceCamera: 0
      };
      this.guideRawReady = false;
    }

    setScanDetected(detected) {
      if (this.cameraOverlay) {
        this.cameraOverlay.classList.toggle('is-detecting', detected);
      }
    }

    setGuidanceState(kind) {
      // Only on a change: the guidance pill is an aria-live region, and rewriting it twice
      // a second with the same sentence would have a screen reader repeat itself forever.
      if (this.guideGuidanceKind === kind) {
        return;
      }

      const wasReady = this.guideGuidanceKind === 'ready';
      this.guideGuidanceKind = kind;

      const step = GUIDE_STEPS[this.guideStepIndex];
      let message = step ? step.guidance : '';

      if (kind === 'ready') {
        // Shared verbatim by both kinds of step since the 2026-10-01 evening amendment —
        // see the doc comment on applyGuidanceVerdict() for why 'profileok' as a separate
        // kind is gone. GUIDE_PROFILE_READY_MESSAGE ('Good angle — tap button to take
        // photo') is retired along with it: it promised a tap, and autocapture now does
        // that itself here too.
        message = GUIDE_READY_MESSAGE;
      } else if (kind === 'center') {
        message = GUIDE_CENTER_MESSAGE;
      } else if (kind === 'closer') {
        message = GUIDE_CLOSER_MESSAGE;
      } else if (kind === 'further') {
        message = GUIDE_FURTHER_MESSAGE;
      } else if (kind === 'straighten') {
        message = GUIDE_STRAIGHTEN_MESSAGE;
      } else if (kind === 'faceCamera') {
        message = GUIDE_FACE_CAMERA_MESSAGE;
      } else if (kind === 'turn' && step && step.turnPrompt) {
        message = step.turnPrompt;
      }

      this.setCameraGuidance(message);

      if (this.cameraOverlay) {
        // BOTH kinds of step turn the oval green on 'ready' — explicit product decision,
        // 2026-10-01 evening amendment: "I wanted auto-capture here too... Both should
        // work, manual and auto." The earlier same-day "no green state and no auto-capture"
        // line was withdrawn the same day it was written. See applyGuidanceVerdict() for
        // what 'ready' actually MEANS on a profile step (profileOk && centered) versus the
        // front step (the five-hint cascade all clear) — two different raw conditions,
        // reusing one kind and one visual treatment because the brief now asks the two to
        // look and behave identically once reached.
        this.cameraOverlay.classList.toggle('is-ready', kind === 'ready');
      }

      // The ring/autocapture pairing lives here, on the kind TRANSITION, rather than being
      // read back out of a raw signal at the end of applyGuidanceVerdict(): there is only
      // one source of truth for "is this the ready state" (guideGuidanceKind), so there is
      // nothing for a second reading of it to disagree with. Applies to every step now,
      // unchanged code — startAutoCapture()/cancelAutoCapture() never checked which step
      // this was; they only ever ran because 'ready' used to be reachable from the front
      // step alone. Now that a profile step's own success condition also reaches 'ready',
      // the exact same two lines below schedule and cancel its ring too.
      if (kind === 'ready' && !wasReady) {
        this.startAutoCapture();
      } else if (kind !== 'ready' && wasReady) {
        this.cancelAutoCapture();
      }
    }

    /**
     * The detector reports a box normalised against the SOURCE frame; the brackets are
     * percentages of the video ELEMENT, which shows a centred crop of that frame because of
     * object-fit: cover. Without re-projecting, a face dead centre on a phone whose camera
     * is 4:3 inside a 9:16 element reads as well outside the brackets.
     *
     * Tests the face's centre rather than all four edges: a detector box routinely runs past
     * the chin and ears, so demanding full containment would keep saying "not yet" to a face
     * that is plainly framed. Centre-inside is what a parent means by "inside the brackets",
     * and this is advisory either way.
     *
     * The preview's CSS mirror does not matter here: GUIDE_FRAME is symmetric about the
     * vertical centre line, so x -> 1 - x maps it onto itself.
     */
    projectFaceToViewport(face) {
      const video = this.cameraVideo;

      if (!face || !video) {
        return null;
      }

      const sourceWidth = video.videoWidth;
      const sourceHeight = video.videoHeight;
      const boxWidth = video.clientWidth;
      const boxHeight = video.clientHeight;

      if (!sourceWidth || !sourceHeight || !boxWidth || !boxHeight) {
        return null;
      }

      const scale = Math.max(boxWidth / sourceWidth, boxHeight / sourceHeight);
      const offsetX = (boxWidth - sourceWidth * scale) / 2;
      const offsetY = (boxHeight - sourceHeight * scale) / 2;

      return {
        left: (offsetX + face.x * sourceWidth * scale) / boxWidth,
        top: (offsetY + face.y * sourceHeight * scale) / boxHeight,
        width: (face.width * sourceWidth * scale) / boxWidth,
        height: (face.height * sourceHeight * scale) / boxHeight
      };
    }

    guideFaceWithinBrackets(face) {
      const rect = this.projectFaceToViewport(face);

      if (!rect) {
        return false;
      }

      const centreX = rect.left + rect.width / 2;
      const centreY = rect.top + rect.height / 2;

      return centreX >= GUIDE_FRAME.left &&
        centreX <= GUIDE_FRAME.right &&
        centreY >= GUIDE_FRAME.top &&
        centreY <= GUIDE_FRAME.bottom;
    }

    /**
     * Narrows the sweep onto the face.
     *
     * The signal this replaces was a second rectangle drawn around the face, which tracked
     * correctly and still had to go: inside the composition brackets it read as a competing
     * frame rather than as feedback. This carries the same information through an element
     * that is already in the viewfinder. While nothing is found the line travels the whole
     * framed area, which is what "looking" looks like; once a face is found it travels only
     * the band the face occupies, which is what "looking AT something" looks like. Nothing
     * new is added to the frame and nothing stops moving.
     *
     * Padded and floored: a sweep hugging the jawline reads as a glitch, and on a small or
     * distant face the band would be shorter than the line's own glow.
     */

    updateScanRange(face) {
      if (!this.cameraScan) {
        return;
      }

      const rect = face ? this.projectFaceToViewport(face) : null;

      if (!rect) {
        this.cameraScan.style.top = '';
        this.cameraScan.style.height = '';
        this.cameraScan.classList.remove('is-narrowed');
        return;
      }

      // The overlay is the framed area, not the whole viewport, so the face has to be
      // re-expressed against it before it can position anything inside it.
      const frameTop = GUIDE_FRAME.top;
      const frameHeight = GUIDE_FRAME.bottom - GUIDE_FRAME.top;

      const padded = SCAN_BAND_PADDING * rect.height;
      let top = (rect.top - padded - frameTop) / frameHeight;
      let height = (rect.height + padded * 2) / frameHeight;

      if (height < SCAN_BAND_MIN_FRACTION) {
        top -= (SCAN_BAND_MIN_FRACTION - height) / 2;
        height = SCAN_BAND_MIN_FRACTION;
      }

      top = Math.max(0, Math.min(1 - height, top));

      if (!(height > 0) || height > 1) {
        this.cameraScan.style.top = '';
        this.cameraScan.style.height = '';
        this.cameraScan.classList.remove('is-narrowed');
        return;
      }

      this.cameraScan.style.top = `${(top * 100).toFixed(2)}%`;
      this.cameraScan.style.height = `${(height * 100).toFixed(2)}%`;
      this.cameraScan.classList.add('is-narrowed');
    }

    /**
     * How far through the turn a profile step is, 0 to 1.
     *
     * The rule already measures this continuously — the nose offset runs from about 0 when
     * a face looks into the lens to 0.35 and beyond in a real profile. Collapsing that to
     * one boolean and a sentence threw away everything a parent could have used to tell
     * whether they were getting closer. Now it fills.
     *
     * Goes through precheck.isTurnedTowardStep(), the same call turnedEnough makes in
     * applyGuidanceVerdict() — one signed computation, read by both, rather than the two
     * separate copies of `noseOffset * sign` this used to carry (which is how the guided
     * flow ended up direction-blind in the first place). A wrong-direction turn floors at
     * 0 (clamped by Math.max) rather than filling the meter for progress toward the WRONG
     * shot: isTurnedTowardStep already returns negative for that case.
     */
    turnProgress(turn, sign, precheck) {
      if (!turn || typeof turn.noseOffset !== 'number' || !sign || !precheck) {
        return null;
      }

      return Math.max(0, Math.min(1, precheck.isTurnedTowardStep(turn.noseOffset, sign)));
    }

    updateTurnMeter(progress) {
      if (!this.cameraTurnMeter || !this.cameraTurnFill) {
        return;
      }

      if (progress === null) {
        this.cameraTurnMeter.hidden = true;
        return;
      }

      this.cameraTurnMeter.hidden = false;
      this.cameraTurnFill.style.width = `${(progress * 100).toFixed(1)}%`;
      this.cameraTurnMeter.classList.toggle('is-complete', progress >= 1);
    }

    showGuideKeep(file) {
      this.guideStage = 'keep';
      // Between shots the stream stops: nothing is being previewed, so nothing justifies
      // holding the camera open behind a still image.
      this.closeCamera();
      this.releaseCapturedPhoto();

      this.guideCapturedFile = file;
      this.guideCapturedUrl = URL.createObjectURL(file);

      // The review screen used to point three <img> elements at the full-size frames. A
      // browser decodes what it is given regardless of the 64px box it is drawn into, so
      // three stream-resolution frames meant tens of megabytes of decoded bitmap held
      // alongside the WASM detector and a live video — on a low-end phone that is the kind
      // of pressure that ends a tab. Built here rather than at Save so the work overlaps
      // the time the parent spends looking at the keep screen.
      this.guideCapturedThumbUrl = null;
      this.createThumbnailUrl(file).then((url) => {
        // The parent may have saved, retaken or left while this was encoding.
        if (this.guideCapturedFile !== file) {
          if (url) {
            URL.revokeObjectURL(url);
          }
          return;
        }

        this.guideCapturedThumbUrl = url;
      });

      const step = GUIDE_STEPS[this.guideStepIndex];

      if (this.keepImage) {
        this.keepImage.src = this.guideCapturedUrl;
      }

      if (this.keepCaption) {
        this.keepCaption.textContent = `Photo ${this.guideStepIndex + 1} of ${GUIDE_STEPS.length} · ${step.label}`;
      }

      this.showGuidePanel('keep');
      this.focusFirstIn(this.guide);
    }

    releaseCapturedPhoto() {
      if (this.guideCapturedUrl) {
        URL.revokeObjectURL(this.guideCapturedUrl);
        this.guideCapturedUrl = null;
      }

      if (this.guideCapturedThumbUrl) {
        URL.revokeObjectURL(this.guideCapturedThumbUrl);
        this.guideCapturedThumbUrl = null;
      }

      this.guideCapturedFile = null;

      if (this.keepImage) {
        this.keepImage.removeAttribute('src');
      }
    }

    handleKeepSaveClick(event) {
      event.preventDefault();

      const step = GUIDE_STEPS[this.guideStepIndex];

      if (!this.guideCapturedFile || !step) {
        return;
      }

      // THE DEFECT THIS REPLACES: this assignment overwrote whatever the slot already held
      // without releasing it, so every retake orphaned a blob URL and the full-size frame
      // behind it. Measured: four retakes of one step left five URLs alive for one photo
      // actually held, and three of them outlived closeGuide() entirely — releaseGuidePending
      // can only free what is still in the array, and an overwritten entry no longer is.
      this.releasePendingPhotoAt(this.guideStepIndex);

      // Ownership of the blob: URL moves into the pending slot — detach, do not release, or
      // the review screen's thumbnail would point at a revoked URL.
      this.guidePendingPhotos[this.guideStepIndex] = this.detachCapturedPhoto();
      this.advanceGuideStep();
    }

    /**
     * Hands the pending frame and its URL to the caller and clears them WITHOUT revoking.
     * releaseCapturedPhoto() is the opposite: it throws the frame away. Two callers with two
     * intentions, and mixing them up revokes a URL something is still displaying.
     */
    detachCapturedPhoto() {
      const file = this.guideCapturedFile;

      // Hand the THUMBNAIL to the review screen and let the full-size preview go: the keep
      // screen that needed it is being left. If the thumbnail has not finished encoding yet
      // the full-size URL is transferred instead, because a correct picture costs less than
      // an empty box.
      const url = this.guideCapturedThumbUrl || this.guideCapturedUrl;

      if (this.guideCapturedThumbUrl && this.guideCapturedUrl) {
        URL.revokeObjectURL(this.guideCapturedUrl);
      }

      this.guideCapturedFile = null;
      this.guideCapturedUrl = null;
      this.guideCapturedThumbUrl = null;

      if (this.keepImage) {
        this.keepImage.removeAttribute('src');
      }

      return { file: file, url: url };
    }

    /**
     * A small JPEG for the review row. 240px on the long edge is comfortably more than the
     * 64px box needs on a 3x screen, and encodes in a few milliseconds.
     */
    createThumbnailUrl(file, maxEdge = 240) {
      return createImageBitmap(file)
        .then((bitmap) => {
          const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
          const canvas = document.createElement('canvas');

          canvas.width = Math.max(1, Math.round(bitmap.width * scale));
          canvas.height = Math.max(1, Math.round(bitmap.height * scale));

          const context = canvas.getContext('2d');

          if (!context) {
            bitmap.close();
            return null;
          }

          context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
          bitmap.close();

          return new Promise((resolve) => {
            canvas.toBlob(resolve, 'image/jpeg', 0.8);
          });
        })
        .then((blob) => (blob ? URL.createObjectURL(blob) : null))
        .catch(() => null);
    }

    /**
     * Hands the frame to that slot's own file input, through the path every other photo in
     * this modal takes: applyCapturedFile() for slot 1, the matching ExtraPhotoSlot for 2
     * and 3. Each dispatches a real 'change', so the slot's own handleFileChange() runs —
     * validation, re-encode, pre-check, preview, file name — and refreshPhotoCount() picks
     * the photo up off that same event. Nothing is uploaded here.
     */
    routeCapturedFileToSlot(file, slot) {
      if (slot === REQUIRED_PHOTO_SLOT) {
        this.applyCapturedFile(file);
        return;
      }

      const extraSlot = this.extraSlots.find((candidate) => candidate.slot === slot);

      if (extraSlot) {
        extraSlot.applyCapturedFile(file);
      }
    }

    handleKeepRetakeClick(event) {
      event.preventDefault();
      this.releaseCapturedPhoto();
      this.startGuideStep(this.guideStepIndex);
    }

    handleCameraSkipClick(event) {
      event.preventDefault();
      this.advanceGuideStep();
    }

    advanceGuideStep() {
      // A retake started from the review screen owes exactly one step, then goes back.
      if (this.guideReturnToReview) {
        this.guideReturnToReview = false;
        this.showGuideReview();
        return;
      }

      const nextIndex = this.guideStepIndex + 1;

      if (nextIndex >= GUIDE_STEPS.length) {
        this.showGuideReview();
        return;
      }

      this.startGuideStep(nextIndex);
    }

    showGuideReview() {
      this.guideStage = 'review';
      this.closeCamera();
      this.releaseCapturedPhoto();
      this.renderGuideReview();
      this.renderReviewNotice();
      this.showGuidePanel('review');

      // The heading, not focusFirstIn's answer — which was the first row's Retake button.
      // On a screen whose whole job is "here is what you have, decide", the first thing
      // announced should be what the screen is, not an action on one row of it.
      this.focusReviewHeading();
    }

    /**
     * Rebuilt on every visit rather than updated in place: three rows is not worth a
     * diffing scheme, and a stale thumbnail pointing at a revoked URL is a real cost.
     * Built with createElement, not innerHTML — the labels are ours, but a blob: URL going
     * through string concatenation is a habit worth not having.
     */
    renderGuideReview() {
      if (!this.reviewList) {
        return;
      }

      this.reviewList.textContent = '';

      GUIDE_STEPS.forEach((step, index) => {
        const pending = this.guidePendingPhotos[index];

        const row = document.createElement('li');
        row.className = 'product-photo-modal__review-row';

        const thumb = document.createElement('span');
        thumb.className = 'product-photo-modal__review-thumb';

        if (pending) {
          const image = document.createElement('img');
          image.src = pending.url;
          image.alt = `Photo ${index + 1}: ${step.label}`;
          thumb.appendChild(image);
        } else {
          const empty = document.createElement('span');
          empty.className = 'product-photo-modal__review-empty';
          empty.textContent = 'Skipped';
          thumb.appendChild(empty);
        }

        const text = document.createElement('span');
        text.className = 'product-photo-modal__review-text';

        const label = document.createElement('span');
        label.className = 'product-photo-modal__review-label';
        label.textContent = `Photo ${index + 1} of ${GUIDE_STEPS.length}`;

        const state = document.createElement('span');
        state.className = 'product-photo-modal__review-state';
        state.textContent = pending ? step.label : `${step.label} \u00b7 skipped`;

        text.append(label, state);

        const action = document.createElement('button');
        action.type = 'button';
        action.className = 'product-photo-modal__review-action';
        action.textContent = pending ? 'Retake' : 'Take';
        action.setAttribute('data-product-photo-modal-review-retake', String(index));
        action.setAttribute('aria-label', `${pending ? 'Retake' : 'Take'} photo ${index + 1}, ${step.label}`);

        row.append(thumb, text, action);
        this.reviewList.appendChild(row);
      });
    }

    /**
     * How many of the photos about to be saved would land on a slot that already holds one.
     *
     * The guided flow owns slots 1-3 by construction, so replacing is what it is FOR — the
     * upload path refusing when every slot is full is a different operation ("put this
     * somewhere free"), not an inconsistency to iron out. What was wrong is that the
     * replacement happened in silence: a parent who had uploaded three photos and opened the
     * camera to try it lost them with nothing on screen saying so.
     */
    guideReplacementCount() {
      return GUIDE_STEPS.reduce((count, step, index) => {
        if (!this.guidePendingPhotos[index]) {
          return count;
        }

        const input = step.slot === REQUIRED_PHOTO_SLOT
          ? this.fileInput
          : (this.extraSlots.find((slot) => slot.slot === step.slot) || {}).fileInput;

        return count + ((input && input.files && input.files.length) ? 1 : 0);
      }, 0);
    }

    renderReviewNotice() {
      if (!this.reviewNotice) {
        return;
      }

      const replacing = this.guideReplacementCount();

      this.reviewNotice.hidden = replacing === 0;
      this.reviewNotice.textContent = replacing === 0
        ? ''
        : replacing === 1
          ? 'Saving replaces 1 photo already on your order.'
          : `Saving replaces ${replacing} photos already on your order.`;
    }

    handleReviewRetakeClick(event) {
      const trigger = event.target.closest('[data-product-photo-modal-review-retake]');

      if (!trigger) {
        return;
      }

      event.preventDefault();

      const index = Number(trigger.getAttribute('data-product-photo-modal-review-retake'));

      if (!Number.isInteger(index) || !GUIDE_STEPS[index]) {
        return;
      }

      this.guideReturnToReview = true;
      this.startGuideStep(index);
    }

    /**
     * The only place a guided photo reaches a slot. Skipped steps stay null and are simply
     * not routed, which is how an optional slot stays empty.
     */
    handleReviewSaveClick(event) {
      event.preventDefault();

      this.guidePendingPhotos.forEach((pending, index) => {
        if (pending && GUIDE_STEPS[index]) {
          this.routeCapturedFileToSlot(pending.file, GUIDE_STEPS[index].slot);
        }
      });

      this.closeGuide();
    }

    handleReviewDiscardClick(event) {
      event.preventDefault();
      this.closeGuide();
    }

    focusReviewHeading() {
      const heading = this.modal.querySelector(REVIEW_HEADING_SELECTOR);

      if (!heading) {
        this.focusFirstIn(this.guide);
        return;
      }

      window.requestAnimationFrame(() => {
        heading.focus({ preventScroll: true });
      });
    }

    releasePendingPhotoAt(index) {
      const pending = this.guidePendingPhotos[index];

      if (pending && pending.url) {
        URL.revokeObjectURL(pending.url);
      }

      this.guidePendingPhotos[index] = null;
    }

    releaseGuidePending() {
      this.guidePendingPhotos.forEach((pending) => {
        if (pending && pending.url) {
          URL.revokeObjectURL(pending.url);
        }
      });

      this.guidePendingPhotos = GUIDE_STEPS.map(() => null);
    }

    /**
     * NOT the normal exit any more — the review screen is, and it is reached from
     * advanceGuideStep(). This is only the guard for startGuideStep() being handed an index
     * outside GUIDE_STEPS, which nothing currently does. Kept so that an out-of-range step
     * closes the flow cleanly rather than leaving a camera stage with no step behind it.
     */
    finishGuidedFlow() {
      this.closeGuide();
    }

    closeGuide({ restoreFocus = true } = {}) {
      // Safe to call when the guided flow was never running — close() and destroy() both
      // do, without having to know which of the two cameras was open.
      if (!this.guideStage) {
        return;
      }

      this.stopGuidanceSampling();
      // Before guideStage is cleared, so closeCamera() leaves focus alone and this method
      // stays the only thing that moves it.
      this.closeCamera();
      this.guideStage = null;
      this.guideStepIndex = 0;
      this.guideResumeOnReturn = false;
      this.guideReturnToReview = false;
      this.releaseCapturedPhoto();
      this.releaseGuidePending();

      if (this.guide) {
        this.guide.hidden = true;
        this.guidePanels.forEach((panel) => {
          panel.hidden = true;
        });
      }

      if (this.camera) {
        this.camera.classList.remove('is-guided');
      }

      if (this.cameraHeader) {
        this.cameraHeader.hidden = true;
      }

      if (this.cameraOverlay) {
        this.cameraOverlay.hidden = true;
        this.cameraOverlay.classList.remove('is-ready', 'is-detecting');
      }

      this.updateTurnMeter(null);

      if (this.cameraSkipButton) {
        this.cameraSkipButton.hidden = true;
      }

      if (this.cameraFlipButton) {
        this.cameraFlipButton.hidden = true;
      }

      // Back to the rear camera for the next run of the flow. A flip is a choice about this
      // session's conditions — where the parent is standing, who is holding the phone — not a
      // preference worth carrying into a later one.
      this.guideFacingMode = GUIDE_DEFAULT_FACING_MODE;
      this.guideFlipPending = false;
      this.guideGuidanceKind = null;
      this.resetGuideSignals();
      this.setCameraGuidance('');

      const restoreTarget = (this.guideLastTrigger && document.contains(this.guideLastTrigger))
        ? this.guideLastTrigger
        : this.cameraTrigger;

      if (restoreFocus && restoreTarget) {
        restoreTarget.focus({ preventScroll: true });
      }

      this.guideLastTrigger = null;
    }

    /**
     * A backgrounded tab must not hold the camera open. Applied to the single-shot camera
     * as well as the guided flow, deliberately: it is the same stream and the same promise
     * to the parent, and leaving one path holding the camera in the background would undo
     * the guarantee made on the other.
     *
     * Only the guided flow reopens on return, because only it knows which step to reopen
     * on. The single-shot camera closes and the parent taps the card again — the same thing
     * that happens today if they cancel.
     */
    handleBeforeUnload(event) {
      if (!this.guidePendingPhotos.some(Boolean)) {
        return;
      }

      event.preventDefault();
      // Legacy channel some browsers still require; the string itself is ignored by all of
      // them, which is why the wording lives in GUIDE_DISCARD_CONFIRM and not here.
      event.returnValue = '';
    }

    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        if (this.cameraOpen) {
          this.guideResumeOnReturn = this.guideStage === 'camera';
          this.closeCamera();
        }

        return;
      }

      if (this.guideResumeOnReturn && this.isOpen && this.guideStage === 'camera') {
        this.guideResumeOnReturn = false;
        this.openCamera();
      }
    }

    lockBodyScroll() {
      const body = document.body;

      this.scrollY = window.scrollY || window.pageYOffset || 0;
      this.previousBodyStyles = {
        position: body.style.position,
        top: body.style.top,
        width: body.style.width,
        overflow: body.style.overflow
      };

      body.style.position = 'fixed';
      body.style.top = `-${this.scrollY}px`;
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    }

    unlockBodyScroll() {
      if (!this.previousBodyStyles) {
        return;
      }

      const body = document.body;

      body.style.position = this.previousBodyStyles.position;
      body.style.top = this.previousBodyStyles.top;
      body.style.width = this.previousBodyStyles.width;
      body.style.overflow = this.previousBodyStyles.overflow;
      window.scrollTo(0, this.scrollY);
      this.previousBodyStyles = null;
    }
  }

  function initProductPhotoUploadModal() {
    if (window.productPhotoUploadModalInstance) {
      window.productPhotoUploadModalInstance.destroy();
    }

    const modal = document.querySelector(MODAL_SELECTOR);

    if (!modal) {
      window.productPhotoUploadModalInstance = null;
      return;
    }

    window.productPhotoUploadModalInstance = new ProductPhotoUploadModal(modal);
  }

  function destroyProductPhotoUploadModal() {
    if (!window.productPhotoUploadModalInstance) {
      return;
    }

    window.productPhotoUploadModalInstance.destroy();
    window.productPhotoUploadModalInstance = null;
  }

  window.initProductPhotoUploadModal = initProductPhotoUploadModal;
  window.destroyProductPhotoUploadModal = destroyProductPhotoUploadModal;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPhotoUploadModal, { once: true });
  } else {
    initProductPhotoUploadModal();
  }

  if (window.Shopify && window.Shopify.designMode && !window.productPhotoUploadModalEditorListenersBound) {
    document.addEventListener('shopify:section:load', () => {
      window.initProductPhotoUploadModal();
    });
    document.addEventListener('shopify:section:unload', () => {
      window.destroyProductPhotoUploadModal();
    });
    window.productPhotoUploadModalEditorListenersBound = true;
  }
})();
